var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMassageAmico(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-3",
    d: "M77.66,248.83c-95.18,54.95-95.17,144,0,199s249.49,55,344.67,0,95.17-144,0-199S172.84,193.88,77.66,248.83Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Frame--inject-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "216.75 199.91 219.07 201.29 298.06 155.69 295.74 154.31 216.75 199.91",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.74 154.31 219.07 198.56 219.07 70.31 295.74 26.07 295.74 154.31",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.44,17.11,214.69,67.78v141.1l87.75-50.66Zm-4.38,138.58-79,45.61v-131l79-45.61Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.06 155.69 295.74 154.31 295.74 26.07 298.06 24.7 298.06 155.69",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.07 161.21 219.07 163.94 298.06 118.34 295.74 116.95 219.07 161.21",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.07 99.89 219.07 102.62 298.06 57.02 295.74 55.63 219.07 99.89",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.44 17.11 300.08 15.76 212.33 66.43 214.69 67.78 302.44 17.11",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.33 66.43 214.69 67.78 214.69 208.88 212.33 207.53 212.33 66.43",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.85 50.8 255.21 49.44 255.21 180.44 252.85 179.09 252.85 50.8",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "259.6 46.92 255.21 49.44 255.21 180.44 259.6 177.9 259.6 46.92",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.44 54.49 302.44 59.54 214.69 110.2 214.69 105.15 302.44 54.49",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.44 115.8 302.44 120.85 214.69 171.51 214.69 166.46 302.44 115.8",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.21 81.75 252.85 80.39 219.07 99.89 219.07 102.62 255.21 81.75",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.21 143.04 252.85 141.68 219.07 161.19 219.07 163.91 255.21 143.04",
    style: {
      fill: "#fafafa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shelves--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shelf--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--shelf--inject-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "119.59 79.78 48.06 121.07 74.07 136.08 145.59 94.79 119.59 79.78",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.59 94.79 145.59 98.55 74.07 139.84 74.07 136.08 145.59 94.79",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "48.06 121.07 74.07 136.08 74.07 139.84 48.06 124.83 48.06 121.07",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-3",
    d: "M131.22,89.3c5.05,2.91,5.05,7.64,0,10.56s-13.23,2.91-18.28,0-5-7.65,0-10.56S126.17,86.38,131.22,89.3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-3",
    d: "M96,116.82l11.11-6.41c1.32-.77,1.32-2,0-2.77l-7.61-4.4a5.34,5.34,0,0,0-4.8,0l-11.11,6.42c-1.33.76-1.33,2,0,2.77l7.61,4.39A5.28,5.28,0,0,0,96,116.82Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-3",
    d: "M73.4,129.88l11.11-6.41c1.32-.77,1.33-2,0-2.77l-7.61-4.4a5.34,5.34,0,0,0-4.8,0L61,122.72c-1.32.76-1.32,2,0,2.77l7.61,4.39A5.28,5.28,0,0,0,73.4,129.88Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114,95.23c-4.4-4.49-7-15.69-2.69-19.25h21.82c4.29,3.55,1.71,14.75-2.69,19.24a.74.74,0,0,1-.12.13l-.15.15c-.12.12-.25.23-.39.35l-.11.08a4.08,4.08,0,0,1-.33.25c-.19.13-.38.26-.57.37a14.53,14.53,0,0,1-13.1,0h0c-.19-.11-.38-.24-.57-.37l-.31-.23-.13-.11a4.32,4.32,0,0,1-.39-.34l-.17-.17Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.28,74.54c5,2.88,5,7.54,0,10.41s-13.06,2.88-18,0-5-7.53,0-10.41S126.3,71.67,131.28,74.54Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.75,76.58c3,1.75,3,4.59,0,6.34a12.14,12.14,0,0,1-11,0c-3-1.75-3-4.59,0-6.34A12.14,12.14,0,0,1,127.75,76.58Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.77,79.59a12.14,12.14,0,0,1,11,0,5,5,0,0,1,1.81,1.66,5,5,0,0,1-1.81,1.67,12.14,12.14,0,0,1-11,0A5,5,0,0,1,115,81.25,5,5,0,0,1,116.77,79.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.08,81.25a25,25,0,0,0,4-5.27c1.83-3.24,2.17-7.59,1.22-8.12s-4.8,3.79-4.8,3.79a23.73,23.73,0,0,0,.4-5.53c-.16-2.88-.86-5.51-1.69-6s-2.68,3.12-3.47,5.75-1.27,4.81-1.27,4.81A40.9,40.9,0,0,0,120,64.57c-1-2.74-1.83-3.36-2.51-3.09s-1.12,1.55-1.32,5.2a36.18,36.18,0,0,0,.16,5.22S115,70.41,113.48,69s-2.36-1.82-2.84-1.51-.6,2.78,2,7.42a25.8,25.8,0,0,0,4.84,6.38S121,83.54,127.08,81.25Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.08,81.25a25,25,0,0,0,4-5.27c1.83-3.24,2.17-7.59,1.22-8.12s-4.8,3.79-4.8,3.79a23.73,23.73,0,0,0,.4-5.53c-.16-2.88-.86-5.51-1.69-6s-2.68,3.12-3.47,5.75-1.27,4.81-1.27,4.81A40.9,40.9,0,0,0,120,64.57c-1-2.74-1.83-3.36-2.51-3.09s-1.12,1.55-1.32,5.2a36.18,36.18,0,0,0,.16,5.22S115,70.41,113.48,69s-2.36-1.82-2.84-1.51-.6,2.78,2,7.42a25.8,25.8,0,0,0,4.84,6.38S121,83.54,127.08,81.25Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Soap--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.53,78,94,76a3,3,0,0,1,3-.3c.78.45,5.88,3.36,6.66,3.83a3,3,0,0,1,1.21,2.75v25.1a2.37,2.37,0,0,1-1.07,1.86L93.93,115a.77.77,0,0,1-.76.08l-6.61-3.81a.78.78,0,0,1-.31-.7V85.43A9.46,9.46,0,0,1,90.53,78Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.53,78,94,76a3,3,0,0,1,3-.3c.78.45,5.88,3.36,6.66,3.83a3,3,0,0,1,1.21,2.75V93.58L86.67,83.05A9.45,9.45,0,0,1,90.53,78Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.91,107.39a2.37,2.37,0,0,1-1.07,1.86L93.93,115a.77.77,0,0,1-.76.08l-6.61-3.81a.78.78,0,0,1-.31-.7V85.43a7.61,7.61,0,0,1,.42-2.38l18.24,10.53Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.93,115a.65.65,0,0,1-1.07-.62V89.24a9.46,9.46,0,0,1,4.28-7.41l3.49-2a3,3,0,0,1,3.07-.28,3,3,0,0,1,1.21,2.75v25.1a2.37,2.37,0,0,1-1.07,1.86Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.93,115a.65.65,0,0,1-1.07-.62V89.24a9.46,9.46,0,0,1,4.28-7.41l3.49-2a3,3,0,0,1,3.07-.28,3,3,0,0,1,1.21,2.75v25.1a2.37,2.37,0,0,1-1.07,1.86Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.59,75.33V79a1.41,1.41,0,0,0,.84,1.16,4.41,4.41,0,0,0,4,0A1.4,1.4,0,0,0,98.29,79V75.33Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.43,76.49a4.47,4.47,0,0,0,4,0,1.23,1.23,0,0,0,0-2.33,4.47,4.47,0,0,0-4,0A1.23,1.23,0,0,0,93.43,76.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6,69.46v5.9a.43.43,0,0,0,.24.35,1.33,1.33,0,0,0,1.2,0,.42.42,0,0,0,.25-.35v-5.9Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6,72h.13a15.09,15.09,0,0,1,1.56.2V69.46H94.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.6,71.6l-.59-.41A3.53,3.53,0,0,1,98.55,69a1.6,1.6,0,0,0-1.12-1,5.05,5.05,0,0,0-3.38.1c-1.77.71-2.11,2-.86,2.76a3.42,3.42,0,0,0,1.54.42,10.6,10.6,0,0,1,3.72.84l.72.34A1.43,1.43,0,0,0,100.6,71.6Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--soap--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.84,91.09l3.48-2a3,3,0,0,1,3-.3c.78.45,5.88,3.36,6.65,3.84a3,3,0,0,1,1.22,2.75v25.1a2.36,2.36,0,0,1-1.07,1.85L71.24,128a.77.77,0,0,1-.76.08l-6.61-3.81a.76.76,0,0,1-.31-.7V98.5A9.43,9.43,0,0,1,67.84,91.09Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.84,91.09l3.48-2a3,3,0,0,1,3-.3c.78.45,5.88,3.36,6.65,3.84a3,3,0,0,1,1.22,2.75v11.29L64,96.13A9.48,9.48,0,0,1,67.84,91.09Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.22,120.47a2.36,2.36,0,0,1-1.07,1.85L71.24,128a.77.77,0,0,1-.76.08l-6.61-3.81a.76.76,0,0,1-.31-.7V98.5A7.5,7.5,0,0,1,64,96.13l18.24,10.53Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.24,128a.77.77,0,0,1-.76.08.75.75,0,0,1-.31-.69v-25.1a9.47,9.47,0,0,1,4.28-7.42l3.49-2A3,3,0,0,1,81,92.62a3,3,0,0,1,1.22,2.75v25.1a2.36,2.36,0,0,1-1.07,1.85Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.24,128a.77.77,0,0,1-.76.08.75.75,0,0,1-.31-.69v-25.1a9.47,9.47,0,0,1,4.28-7.42l3.49-2A3,3,0,0,1,81,92.62a3,3,0,0,1,1.22,2.75v25.1a2.36,2.36,0,0,1-1.07,1.85Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9,88.4v3.66a1.44,1.44,0,0,0,.83,1.17,4.49,4.49,0,0,0,4,0,1.44,1.44,0,0,0,.83-1.17V88.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.73,89.56a4.43,4.43,0,0,0,4,0,1.23,1.23,0,0,0,0-2.33,4.49,4.49,0,0,0-4,0A1.23,1.23,0,0,0,70.73,89.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9,82.53v5.9a.43.43,0,0,0,.25.35,1.33,1.33,0,0,0,1.2,0,.41.41,0,0,0,.25-.35v-5.9Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9,85.05H72a15.09,15.09,0,0,1,1.56.2V82.53H71.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.91,84.68l-.59-.42a3.5,3.5,0,0,1-1.46-2.17,1.6,1.6,0,0,0-1.12-1,5.05,5.05,0,0,0-3.38.1c-1.77.71-2.11,2-.86,2.77a3.51,3.51,0,0,0,1.54.41,10.72,10.72,0,0,1,3.71.84l.72.34A1.44,1.44,0,0,0,77.91,84.68Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--shelf--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--shelf--inject-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "162.72 127.71 48.06 193.96 85.86 215.81 200.52 149.56 162.72 127.71",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.52 149.56 200.52 153.32 85.86 219.56 85.86 215.81 200.52 149.56",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "48.06 193.96 85.86 215.81 85.86 219.56 48.06 197.72 48.06 193.96",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-3",
    points: "136.43 184.02 168.52 165.51 136.43 146.98 104.38 165.5 136.43 184.02",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lavander--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-3",
    d: "M159.94,140.49c-5.28,3-5.28,8,0,11s13.84,3.05,19.12,0,5.28-8,0-11S165.22,137.44,159.94,140.49Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Jar--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--jar--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180,113.27c0-1.51-1-3-3-4.19a16.35,16.35,0,0,0-14.65,0c-1.9,1.09-2.91,2.49-3,3.91,0,.09,0,.19,0,.28v1.31c0,.1,0,.21,0,.31.12,1.42,1.13,2.82,3,3.9a16.29,16.29,0,0,0,14.65,0c2-1.15,3-2.67,3-4.18Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,113.27c0-1.51-1-3-3-4.19a16.35,16.35,0,0,0-14.65,0c-1.9,1.09-2.91,2.49-3,3.91,0,.09,0,.19,0,.28v1.31c0,.1,0,.21,0,.31.12,1.42,1.13,2.82,3,3.9a16.29,16.29,0,0,0,14.65,0c2-1.15,3-2.67,3-4.18Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.2,116.3h0c-.21-1.52-1.33-3-3.36-4.16-4.53-2.59-11.89-2.59-16.42,0-2.11,1.21-3.23,2.76-3.38,4.33h0a3.14,3.14,0,0,0-.07.68v28.14c0,1.72,1.14,3.44,3.42,4.76,4.56,2.63,11.94,2.63,16.49,0,2.28-1.32,3.42-3,3.42-4.76V117.15A4.09,4.09,0,0,0,181.2,116.3Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.2,116.3h0c-.21-1.52-1.33-3-3.36-4.16-4.53-2.59-11.89-2.59-16.42,0-2.11,1.21-3.23,2.76-3.38,4.33h0a3.14,3.14,0,0,0-.07.68v28.14c0,1.72,1.14,3.44,3.42,4.76,4.56,2.63,11.94,2.63,16.49,0,2.28-1.32,3.42-3,3.42-4.76V117.15A4.09,4.09,0,0,0,181.2,116.3Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.35,117.15v25c0,1.57-1,3.15-3.15,4.35a17,17,0,0,1-15.22,0c-2-1.13-3-2.58-3.13-4.05V117.15c0-1.46,1.05-2.87,3-4a9.41,9.41,0,0,1,1.46-.7,18.29,18.29,0,0,1,12.66,0,10.37,10.37,0,0,1,1.46.7C179.3,114.28,180.35,115.69,180.35,117.15Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.38,142.18c0,1.57-1,3.15-3.15,4.35a17,17,0,0,1-15.22,0c-2-1.13-3-2.58-3.14-4.05q0-.3,0-.6c.13-1.47,1.17-2.92,3.14-4a17,17,0,0,1,15.22,0C179.33,139,180.38,140.61,180.38,142.18Z",
    style: {
      fill: "#FF725E",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M180,113.27c0-1.51-1-3-3-4.19a16.35,16.35,0,0,0-14.65,0c-1.9,1.09-2.91,2.49-3,3.91,0,.09,0,.19,0,.28v1.31c0,.1,0,.21,0,.31.12,1.42,1.13,2.82,3,3.9a16.29,16.29,0,0,0,14.65,0c2-1.15,3-2.67,3-4.18Z",
    style: {
      fill: "#FF725E",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,113.27c0,1.52-1,3-3,4.19a16.35,16.35,0,0,1-14.65,0c-1.9-1.09-2.91-2.48-3-3.9a5.42,5.42,0,0,1,0-.57c.12-1.42,1.13-2.82,3-3.91a16.35,16.35,0,0,1,14.65,0C179,110.24,180,111.76,180,113.27Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179,113.27c0,1.33-.92,2.67-2.75,3.68A15.24,15.24,0,0,1,163,117c-1.73-1-2.64-2.18-2.75-3.43a2.09,2.09,0,0,1,0-.5c.11-1.25,1-2.48,2.75-3.43a15.31,15.31,0,0,1,13.31,0C178.11,110.61,179,111.94,179,113.27Z",
    style: {
      fill: "#FF725E",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.28,111.62a15.31,15.31,0,0,0-13.31,0,5.29,5.29,0,0,0-2.58,2.67A5.31,5.31,0,0,0,163,117a15.24,15.24,0,0,0,13.31,0,5.29,5.29,0,0,0,2.57-2.66A5.31,5.31,0,0,0,176.28,111.62Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lavender--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.83,126.1q0-9.21.68-18.39a32.2,32.2,0,0,0-.19-6.87c-.29-2.11-.69-4.19-1.12-6.27s-.84-4.16-1.11-6.26a48.59,48.59,0,0,1-.38-6.26,55.1,55.1,0,0,1,1.48-12.53c.12-.52.25-1,.39-1.55,0-.07-.08-.16-.11-.06a47.91,47.91,0,0,0-2.16,12.34,54.47,54.47,0,0,0,1,12.61c.41,2.1.86,4.19,1.2,6.3a44,44,0,0,1,.44,7.86c-.06,2.67-.31,5.47-.51,8.13a92.62,92.62,0,0,0,.45,14.7C169.85,128.6,169.84,127.35,169.83,126.1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.29,67.39a.49.49,0,0,0,0,.24.24.24,0,0,1,0,.12c-.05.1-.2.06-.31.09s-.18.23-.15.38a3.38,3.38,0,0,1,.13.42.07.07,0,0,1,0,0s0,0-.05,0a.3.3,0,0,0-.23.25c-.05.27.14.43.24.66a1.25,1.25,0,0,1,0,.74c.4-.42.77-.85,1.13-1.29.08-.1.16-.26.07-.35a.27.27,0,0,1-.08-.07.15.15,0,0,1,0-.13c.06-.13.18-.23.24-.36s-.1-.43-.32-.3a.65.65,0,0,1,0-.2.86.86,0,0,0-.11-.28.27.27,0,0,0-.25-.14A.24.24,0,0,0,169.29,67.39Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.88,70.52a1.06,1.06,0,0,0,0-1.06.37.37,0,0,0-.2-.15.21.21,0,0,0-.22.1,1,1,0,0,0-.24-.51.29.29,0,0,0-.16-.13.18.18,0,0,0-.2,0c-.08.08,0,.22,0,.33a.47.47,0,0,0-.32-.21.23.23,0,0,0-.25.09.26.26,0,0,0,0,.24,2.55,2.55,0,0,0,.79.74,1.34,1.34,0,0,1,.6.87C168.78,70.74,168.83,70.63,168.88,70.52Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.88,70.52a1.06,1.06,0,0,0,0-1.06.37.37,0,0,0-.2-.15.21.21,0,0,0-.22.1,1,1,0,0,0-.24-.51.29.29,0,0,0-.16-.13.18.18,0,0,0-.2,0c-.08.08,0,.22,0,.33a.47.47,0,0,0-.32-.21.23.23,0,0,0-.25.09.26.26,0,0,0,0,.24,2.55,2.55,0,0,0,.79.74,1.34,1.34,0,0,1,.6.87C168.78,70.74,168.83,70.63,168.88,70.52Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.64,70.77a2.39,2.39,0,0,1,.23-.58,1.51,1.51,0,0,1,.75-.66.28.28,0,0,1,.25,0,.2.2,0,0,1,0,.28,1.34,1.34,0,0,1,.46-.2.31.31,0,0,1,.35.08c.09.12,0,.29-.14.37s-.28.1-.41.17a.15.15,0,0,1,.18.11.22.22,0,0,1-.09.21.54.54,0,0,1-.22.09c-.24,0-.48,0-.72.08a1,1,0,0,0-.61.33C168.62,71,168.62,70.89,168.64,70.77Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.64,70.77a2.39,2.39,0,0,1,.23-.58,1.51,1.51,0,0,1,.75-.66.28.28,0,0,1,.25,0,.2.2,0,0,1,0,.28,1.34,1.34,0,0,1,.46-.2.31.31,0,0,1,.35.08c.09.12,0,.29-.14.37s-.28.1-.41.17a.15.15,0,0,1,.18.11.22.22,0,0,1-.09.21.54.54,0,0,1-.22.09c-.24,0-.48,0-.72.08a1,1,0,0,0-.61.33C168.62,71,168.62,70.89,168.64,70.77Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.49,70.05c-.09,0-.2-.08-.18.06a1.25,1.25,0,0,0,.11.39.72.72,0,0,0-.73-.25,1.71,1.71,0,0,0,.4.29,1.43,1.43,0,0,1,.44.66,1.22,1.22,0,0,1,1-.12.53.53,0,0,0-.46-.31l.21-.19c.08-.08.09-.17,0-.21a.23.23,0,0,0-.14,0,.47.47,0,0,0-.29.2c.05-.08-.14-.34-.18-.41A.42.42,0,0,0,168.49,70.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.12,72a.89.89,0,0,1,.28-.23.29.29,0,0,1,.31,0c.07.08,0,.21,0,.31a.29.29,0,0,1,.31,0,.08.08,0,0,1,.05,0,.13.13,0,0,1,0,.06,1.2,1.2,0,0,1-.26.45.22.22,0,0,1,.25.18.35.35,0,0,1-.14.31,1.11,1.11,0,0,1-.31.15l-.49.18a.38.38,0,0,1-.23,0,.26.26,0,0,1-.16-.15,1.1,1.1,0,0,1,0-.67A1.73,1.73,0,0,1,169.12,72Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.12,72a.89.89,0,0,1,.28-.23.29.29,0,0,1,.31,0c.07.08,0,.21,0,.31a.29.29,0,0,1,.31,0,.08.08,0,0,1,.05,0,.13.13,0,0,1,0,.06,1.2,1.2,0,0,1-.26.45.22.22,0,0,1,.25.18.35.35,0,0,1-.14.31,1.11,1.11,0,0,1-.31.15l-.49.18a.38.38,0,0,1-.23,0,.26.26,0,0,1-.16-.15,1.1,1.1,0,0,1,0-.67A1.73,1.73,0,0,1,169.12,72Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.79,71.13a.22.22,0,0,0-.19.19.31.31,0,0,0-.19-.13.23.23,0,0,0-.21.14.43.43,0,0,0,0,.25.2.2,0,0,0-.25,0,.24.24,0,0,0-.09.23A.37.37,0,0,0,167,72c-.06,0-.13,0-.15.09a.3.3,0,0,0,.06.18,4.61,4.61,0,0,0,.79.66c.06.05.15.24.24.23l.07,0a1.32,1.32,0,0,0,.34-1.14,1,1,0,0,0-.06-.33,2,2,0,0,0-.11-.35.37.37,0,0,0-.28-.21Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.79,71.13a.22.22,0,0,0-.19.19.31.31,0,0,0-.19-.13.23.23,0,0,0-.21.14.43.43,0,0,0,0,.25.2.2,0,0,0-.25,0,.24.24,0,0,0-.09.23A.37.37,0,0,0,167,72c-.06,0-.13,0-.15.09a.3.3,0,0,0,.06.18,4.61,4.61,0,0,0,.79.66c.06.05.15.24.24.23l.07,0a1.32,1.32,0,0,0,.34-1.14,1,1,0,0,0-.06-.33,2,2,0,0,0-.11-.35.37.37,0,0,0-.28-.21Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.8,73.39a2.38,2.38,0,0,0,.55-1.07.19.19,0,0,0,0-.15c-.05-.07-.15-.06-.23,0s.14-.17.2-.26a.58.58,0,0,0,.13-.3.39.39,0,0,0-.11-.31.24.24,0,0,0-.31,0c-.05-.1-.09-.24-.19-.3a.29.29,0,0,0-.3,0c-.19.09-.2.29-.23.47a.22.22,0,0,0-.3.06.38.38,0,0,0,0,.33,1,1,0,0,0,.17.3c-.12-.07-.27.05-.29.18a.53.53,0,0,0,.12.38c.12.19.23.4.36.58a.57.57,0,0,1,.11.22s.06.24,0,.27A2.26,2.26,0,0,0,168.8,73.39Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.8,73.39a2.38,2.38,0,0,0,.55-1.07.19.19,0,0,0,0-.15c-.05-.07-.15-.06-.23,0s.14-.17.2-.26a.58.58,0,0,0,.13-.3.39.39,0,0,0-.11-.31.24.24,0,0,0-.31,0c-.05-.1-.09-.24-.19-.3a.29.29,0,0,0-.3,0c-.19.09-.2.29-.23.47a.22.22,0,0,0-.3.06.38.38,0,0,0,0,.33,1,1,0,0,0,.17.3c-.12-.07-.27.05-.29.18a.53.53,0,0,0,.12.38c.12.19.23.4.36.58a.57.57,0,0,1,.11.22s.06.24,0,.27A2.26,2.26,0,0,0,168.8,73.39Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.47,72.72a.91.91,0,0,0-.11-.16.18.18,0,0,0-.07,0c-.09,0-.17.06-.23.13a1.12,1.12,0,0,0-.36-.53.52.52,0,0,0-.19-.11.29.29,0,0,0-.28.11.33.33,0,0,0-.06.3.66.66,0,0,0-.54-.32.4.4,0,0,0-.26.06.23.23,0,0,0-.1.23.57.57,0,0,0,.08.13,2,2,0,0,0,.42.39.15.15,0,0,0-.21.07.25.25,0,0,0,.05.23,1.57,1.57,0,0,0,.45.31,3.39,3.39,0,0,0,.53.2,2.48,2.48,0,0,1,.44.2c.07,0,.38.25.33.37a2.87,2.87,0,0,0,.2-1.23A1,1,0,0,0,168.47,72.72Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.47,72.72a.91.91,0,0,0-.11-.16.18.18,0,0,0-.07,0c-.09,0-.17.06-.23.13a1.12,1.12,0,0,0-.36-.53.52.52,0,0,0-.19-.11.29.29,0,0,0-.28.11.33.33,0,0,0-.06.3.66.66,0,0,0-.54-.32.4.4,0,0,0-.26.06.23.23,0,0,0-.1.23.57.57,0,0,0,.08.13,2,2,0,0,0,.42.39.15.15,0,0,0-.21.07.25.25,0,0,0,.05.23,1.57,1.57,0,0,0,.45.31,3.39,3.39,0,0,0,.53.2,2.48,2.48,0,0,1,.44.2c.07,0,.38.25.33.37a2.87,2.87,0,0,0,.2-1.23A1,1,0,0,0,168.47,72.72Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.41,73.21l.06-.09a.39.39,0,0,1,.23-.19c.1,0,.23,0,.22.15a2.43,2.43,0,0,1,.33-.38.32.32,0,0,1,.3-.1.23.23,0,0,1,.1.22.67.67,0,0,1-.1.23,1,1,0,0,1,.7-.07c.11,0,.22.1.24.21a.23.23,0,0,1-.11.24.72.72,0,0,1-.25.12,5.12,5.12,0,0,0-.65.25.8.8,0,0,1,.35.19.08.08,0,0,1,0,.05.09.09,0,0,1,0,.06.79.79,0,0,1-.55.09,3.06,3.06,0,0,0-.8.08.47.47,0,0,1-.17,0c-.24,0-.09-.47-.06-.61A1.62,1.62,0,0,1,168.41,73.21Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.41,73.21l.06-.09a.39.39,0,0,1,.23-.19c.1,0,.23,0,.22.15a2.43,2.43,0,0,1,.33-.38.32.32,0,0,1,.3-.1.23.23,0,0,1,.1.22.67.67,0,0,1-.1.23,1,1,0,0,1,.7-.07c.11,0,.22.1.24.21a.23.23,0,0,1-.11.24.72.72,0,0,1-.25.12,5.12,5.12,0,0,0-.65.25.8.8,0,0,1,.35.19.08.08,0,0,1,0,.05.09.09,0,0,1,0,.06.79.79,0,0,1-.55.09,3.06,3.06,0,0,0-.8.08.47.47,0,0,1-.17,0c-.24,0-.09-.47-.06-.61A1.62,1.62,0,0,1,168.41,73.21Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.55,74.67a5.8,5.8,0,0,1-.56-.55c0-.06-.08-.15,0-.2a.15.15,0,0,1,.09,0c.13,0,.25.09.37.15a2.43,2.43,0,0,1-.28-.47s0-.11,0-.15.28,0,.36,0a1.24,1.24,0,0,1,.23.17c.06.06.11.14.17.19a.51.51,0,0,0,.07-.15l.09-.22a.45.45,0,0,1,.1-.13.2.2,0,0,1,.21,0,.39.39,0,0,1,.12.19.88.88,0,0,1,0,.6.79.79,0,0,1,.69,0,.12.12,0,0,1,.07.1c0,.06,0,.1-.1.13l-.39.24a.79.79,0,0,1,.42.15l.06.06a.11.11,0,0,1-.05.13.69.69,0,0,1-.28.11,1.51,1.51,0,0,0-.35.14,1.78,1.78,0,0,0-.58.51s0-.22,0-.27a1.57,1.57,0,0,0-.08-.29A1.29,1.29,0,0,0,167.55,74.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.58,78.62l.43,0a4.32,4.32,0,0,0,.62,0,.26.26,0,0,0,.2-.08c0-.06,0-.17-.06-.17a2.58,2.58,0,0,0,.83-.08c.05,0,.12,0,.11-.11a.13.13,0,0,0,0-.07,1.15,1.15,0,0,0-.54-.35,4.75,4.75,0,0,0,.64-.2s0,0,0,0,0-.09-.06-.12a1.62,1.62,0,0,0-1.59-.16,3.15,3.15,0,0,0,1.05-1,.92.92,0,0,0,.14-.39.53.53,0,0,0-.1-.41.49.49,0,0,0-.39-.17c-.05,0-.37.14-.35.2a.48.48,0,0,0-.53-.29,1,1,0,0,0-.55.35,2.85,2.85,0,0,0-.63,1.19,5.1,5.1,0,0,0-.14,1.1,1.56,1.56,0,0,0,0,.53c.07.2.31.17.49.16Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.6,77a1.57,1.57,0,0,0-.77-.89.41.41,0,0,0-.4,0,.45.45,0,0,0-.13.45,3.72,3.72,0,0,0-1.1-.87s-.13,0-.16,0,0,0,0,.08a1,1,0,0,0,.16.36,1.85,1.85,0,0,0-.76-.29.67.67,0,0,0-.28,0,.26.26,0,0,0-.18.2c0,.18.16.35.28.45a2,2,0,0,0,.54.37c-.06.05-.12.1-.12.17a.16.16,0,0,0,0,.09,1,1,0,0,0,.22.23c.63.44,1.37.72,2,1.15a5.14,5.14,0,0,0,.49.32l.05,0a.09.09,0,0,0,.07-.06A2.08,2.08,0,0,0,167.6,77Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.6,77a1.57,1.57,0,0,0-.77-.89.41.41,0,0,0-.4,0,.45.45,0,0,0-.13.45,3.72,3.72,0,0,0-1.1-.87s-.13,0-.16,0,0,0,0,.08a1,1,0,0,0,.16.36,1.85,1.85,0,0,0-.76-.29.67.67,0,0,0-.28,0,.26.26,0,0,0-.18.2c0,.18.16.35.28.45a2,2,0,0,0,.54.37c-.06.05-.12.1-.12.17a.16.16,0,0,0,0,.09,1,1,0,0,0,.22.23c.63.44,1.37.72,2,1.15a5.14,5.14,0,0,0,.49.32l.05,0a.09.09,0,0,0,.07-.06A2.08,2.08,0,0,0,167.6,77Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.29,75.94a1,1,0,0,0,0-.24,1.56,1.56,0,0,0-.82-1,.42.42,0,0,0-.22,0,.28.28,0,0,0-.15.2,1.1,1.1,0,0,0,0,.26,1.32,1.32,0,0,0-.7-.51c-.11,0-.26,0-.29.08a.2.2,0,0,0,0,.11,1.86,1.86,0,0,0,.24.56c-.09-.07-.21-.14-.31-.09s-.1.2-.08.31c.14.54.75.83,1,1.32-.1,0-.23-.05-.27,0s.05.17.12.23a3.2,3.2,0,0,1,.47.43,1.84,1.84,0,0,1,.17.22,1.28,1.28,0,0,0,.17.22c.13.07.22-.27.26-.35a5.12,5.12,0,0,0,.36-1.15A2,2,0,0,0,168.29,75.94Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.57,77.4c-.3.2-.59.41-.88.62a4.24,4.24,0,0,0-.83.75.25.25,0,0,1-.14.11c-.2.05-.19-.33-.2-.43a3.64,3.64,0,0,1,.38-1.83.37.37,0,0,1,.17-.18c.08,0,.19,0,.16.12a1.45,1.45,0,0,1,.46-.85.2.2,0,0,1,.21,0,.2.2,0,0,1,.06.2.81.81,0,0,1-.08.34,1.61,1.61,0,0,1,.3-.21.51.51,0,0,1,.32-.06.4.4,0,0,1,.25.49,1.09,1.09,0,0,1-.32.52c.12,0,.26,0,.33.06a.22.22,0,0,1,0,.22A.56.56,0,0,1,169.57,77.4Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.57,77.4c-.3.2-.59.41-.88.62a4.24,4.24,0,0,0-.83.75.25.25,0,0,1-.14.11c-.2.05-.19-.33-.2-.43a3.64,3.64,0,0,1,.38-1.83.37.37,0,0,1,.17-.18c.08,0,.19,0,.16.12a1.45,1.45,0,0,1,.46-.85.2.2,0,0,1,.21,0,.2.2,0,0,1,.06.2.81.81,0,0,1-.08.34,1.61,1.61,0,0,1,.3-.21.51.51,0,0,1,.32-.06.4.4,0,0,1,.25.49,1.09,1.09,0,0,1-.32.52c.12,0,.26,0,.33.06a.22.22,0,0,1,0,.22A.56.56,0,0,1,169.57,77.4Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.62,78.62a4.57,4.57,0,0,1,.92.82c.49-.14,1-.36,1.46-.49.08,0,.18-.07.16-.15s0-.06-.08-.08a1.39,1.39,0,0,0-.69-.18c.13-.25.49-.36.5-.64a.9.9,0,0,0-.6.08,2.56,2.56,0,0,0-.51.35,2.15,2.15,0,0,0-.74-.73.15.15,0,0,0-.13,0c-.08,0-.06.14,0,.22a4.82,4.82,0,0,0,.27.5,1.17,1.17,0,0,0-.93-.27c-.07,0-.2.09-.16.18s.05.06.08.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,80.4a1.54,1.54,0,0,1,.38-.61.52.52,0,0,1,.59-.15.65.65,0,0,1,.23.57.54.54,0,0,1,.57-.2.2.2,0,0,1,.12.06.17.17,0,0,1,0,.12,2.51,2.51,0,0,1-.18,1,.42.42,0,0,1,.58.19.72.72,0,0,1-.06.65,2.07,2.07,0,0,1-.48.5l-.81.67a.91.91,0,0,1-.4.21.55.55,0,0,1-.41-.18,2.21,2.21,0,0,1-.39-1.27A3.36,3.36,0,0,1,168,80.4Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,80.4a1.54,1.54,0,0,1,.38-.61.52.52,0,0,1,.59-.15.65.65,0,0,1,.23.57.54.54,0,0,1,.57-.2.2.2,0,0,1,.12.06.17.17,0,0,1,0,.12,2.51,2.51,0,0,1-.18,1,.42.42,0,0,1,.58.19.72.72,0,0,1-.06.65,2.07,2.07,0,0,1-.48.5l-.81.67a.91.91,0,0,1-.4.21.55.55,0,0,1-.41-.18,2.21,2.21,0,0,1-.39-1.27A3.36,3.36,0,0,1,168,80.4Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,79.67a.45.45,0,0,0-.23.48.71.71,0,0,0-.44-.11.43.43,0,0,0-.3.39,1,1,0,0,0,.1.5.39.39,0,0,0-.47.13.5.5,0,0,0,0,.5.66.66,0,0,0,.4.33.23.23,0,0,0-.21.27.58.58,0,0,0,.24.3,8.58,8.58,0,0,0,1.91.73c.14,0,.44.34.6.26a.23.23,0,0,0,.09-.12,2.64,2.64,0,0,0-.09-2.34,1.87,1.87,0,0,0-.34-.6,4.05,4.05,0,0,0-.43-.57.78.78,0,0,0-.67-.21A.35.35,0,0,0,165,79.67Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,79.67a.45.45,0,0,0-.23.48.71.71,0,0,0-.44-.11.43.43,0,0,0-.3.39,1,1,0,0,0,.1.5.39.39,0,0,0-.47.13.5.5,0,0,0,0,.5.66.66,0,0,0,.4.33.23.23,0,0,0-.21.27.58.58,0,0,0,.24.3,8.58,8.58,0,0,0,1.91.73c.14,0,.44.34.6.26a.23.23,0,0,0,.09-.12,2.64,2.64,0,0,0-.09-2.34,1.87,1.87,0,0,0-.34-.6,4.05,4.05,0,0,0-.43-.57.78.78,0,0,0-.67-.21A.35.35,0,0,0,165,79.67Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.33,83.25a4.87,4.87,0,0,0,.32-2.36.47.47,0,0,0-.11-.27c-.14-.11-.33,0-.47.08.07-.21.16-.42.22-.63a1.2,1.2,0,0,0,0-.65.68.68,0,0,0-.4-.5.47.47,0,0,0-.57.19c-.17-.14-.34-.38-.56-.43a.59.59,0,0,0-.57.15c-.3.29-.19.69-.13,1a.44.44,0,0,0-.53.3.71.71,0,0,0,.15.64,2,2,0,0,0,.51.44c-.27,0-.48.28-.43.55a1.13,1.13,0,0,0,.47.63c.35.28.7.6,1.06.85a1,1,0,0,1,.35.33c.05.07.26.41.2.49A5.46,5.46,0,0,0,168.33,83.25Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.26,82.22a1,1,0,0,0-.32-.23.27.27,0,0,0-.15,0c-.19,0-.29.22-.34.4a2.25,2.25,0,0,0-1-.77.84.84,0,0,0-.44-.08.59.59,0,0,0-.45.39.68.68,0,0,0,.1.6,1.36,1.36,0,0,0-1.24-.25.83.83,0,0,0-.43.28.46.46,0,0,0,0,.5.64.64,0,0,0,.21.19,3.47,3.47,0,0,0,1.05.45.29.29,0,0,0-.34.27.45.45,0,0,0,.25.4,2.79,2.79,0,0,0,1,.3,10.47,10.47,0,0,0,1.12,0,4.49,4.49,0,0,1,1,.08c.16,0,.87.21.86.47a5.74,5.74,0,0,0-.43-2.42A1.87,1.87,0,0,0,167.26,82.22Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.26,82.22a1,1,0,0,0-.32-.23.27.27,0,0,0-.15,0c-.19,0-.29.22-.34.4a2.25,2.25,0,0,0-1-.77.84.84,0,0,0-.44-.08.59.59,0,0,0-.45.39.68.68,0,0,0,.1.6,1.36,1.36,0,0,0-1.24-.25.83.83,0,0,0-.43.28.46.46,0,0,0,0,.5.64.64,0,0,0,.21.19,3.47,3.47,0,0,0,1.05.45.29.29,0,0,0-.34.27.45.45,0,0,0,.25.4,2.79,2.79,0,0,0,1,.3,10.47,10.47,0,0,0,1.12,0,4.49,4.49,0,0,1,1,.08c.16,0,.87.21.86.47a5.74,5.74,0,0,0-.43-2.42A1.87,1.87,0,0,0,167.26,82.22Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.48,83.17a1.42,1.42,0,0,1,0-.2.8.8,0,0,1,.31-.52.36.36,0,0,1,.52.14,3.82,3.82,0,0,1,.36-.92c.11-.19.28-.4.5-.38a.42.42,0,0,1,.32.34,1.16,1.16,0,0,1,0,.49,1.89,1.89,0,0,1,1.25-.57.64.64,0,0,1,.6.23.47.47,0,0,1-.05.52,1.45,1.45,0,0,1-.4.38,9.88,9.88,0,0,0-1,.89,1.45,1.45,0,0,1,.77.14s.08,0,.09.08,0,.08,0,.12a1.58,1.58,0,0,1-1,.53,5.52,5.52,0,0,0-1.45.69.91.91,0,0,1-.3.14c-.48.09-.47-.81-.52-1.09A2.64,2.64,0,0,1,167.48,83.17Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.48,83.17a1.42,1.42,0,0,1,0-.2.8.8,0,0,1,.31-.52.36.36,0,0,1,.52.14,3.82,3.82,0,0,1,.36-.92c.11-.19.28-.4.5-.38a.42.42,0,0,1,.32.34,1.16,1.16,0,0,1,0,.49,1.89,1.89,0,0,1,1.25-.57.64.64,0,0,1,.6.23.47.47,0,0,1-.05.52,1.45,1.45,0,0,1-.4.38,9.88,9.88,0,0,0-1,.89,1.45,1.45,0,0,1,.77.14s.08,0,.09.08,0,.08,0,.12a1.58,1.58,0,0,1-1,.53,5.52,5.52,0,0,0-1.45.69.91.91,0,0,1-.3.14c-.48.09-.47-.81-.52-1.09A2.64,2.64,0,0,1,167.48,83.17Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.69,86.61l-.12-.13c-.31-.35-.79-.43-1.17-.69-.12-.08-.25-.21-.2-.34a.33.33,0,0,1,.13-.13c.25-.12.54,0,.81,0a4.68,4.68,0,0,1-.84-.69c-.08-.08-.16-.18-.13-.29s.49-.22.68-.18a2.49,2.49,0,0,1,.53.16c.16.07.3.19.46.25a.91.91,0,0,0,0-.33c0-.16,0-.31,0-.46a.63.63,0,0,1,.1-.31.37.37,0,0,1,.41-.09.74.74,0,0,1,.35.28,1.77,1.77,0,0,1,.35,1.13,1.57,1.57,0,0,1,1.32-.37.26.26,0,0,1,.21.15c0,.1,0,.21-.11.3l-.58.7a1.58,1.58,0,0,1,.89,0,.46.46,0,0,1,.14.07.24.24,0,0,1,0,.28.8.8,0,0,1-.21.2,10.48,10.48,0,0,0-1.12.87,3,3,0,0,0-.4.64c-.13.24-.25.48-.37.73-.2-.32-.36-.67-.55-1A5.71,5.71,0,0,0,166.69,86.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,91.42c.22-.07.44-.14.66-.19a6,6,0,0,0,.95-.24.41.41,0,0,0,.25-.23c0-.11-.06-.26-.17-.22a4.63,4.63,0,0,0,1.19-.56c.07-.06.15-.15.11-.23a.23.23,0,0,0-.09-.08,2,2,0,0,0-1-.24,9,9,0,0,0,.85-.64l.05-.06c0-.08-.07-.14-.15-.16a2.61,2.61,0,0,0-2.46.61,5.08,5.08,0,0,0,1-2,1.38,1.38,0,0,0,0-.67.88.88,0,0,0-.37-.55.75.75,0,0,0-.67,0c-.07,0-.47.39-.41.47a.77.77,0,0,0-1-.13,1.59,1.59,0,0,0-.63.81,4.59,4.59,0,0,0-.29,2.11,7.25,7.25,0,0,0,.38,1.72,2.19,2.19,0,0,0,.33.77c.21.26.54.1.8,0S169.79,91.49,170,91.42Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.67,89.54a2.43,2.43,0,0,0-1.64-.91.66.66,0,0,0-.61.17.73.73,0,0,0,.05.75,5.61,5.61,0,0,0-2.1-.7c-.09,0-.22,0-.24.09a.15.15,0,0,0,0,.12,1.35,1.35,0,0,0,.43.46,2.68,2.68,0,0,0-1.29,0,1.05,1.05,0,0,0-.41.17.44.44,0,0,0-.16.4c0,.28.43.43.66.53a3.88,3.88,0,0,0,1,.26.36.36,0,0,0-.08.31.2.2,0,0,0,.08.12,1.13,1.13,0,0,0,.46.21c1.18.33,2.42.35,3.61.65a8.26,8.26,0,0,0,.89.22h.09c.05,0,.06-.08.07-.13A3.33,3.33,0,0,0,167.67,89.54Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.67,89.54a2.43,2.43,0,0,0-1.64-.91.66.66,0,0,0-.61.17.73.73,0,0,0,.05.75,5.61,5.61,0,0,0-2.1-.7c-.09,0-.22,0-.24.09a.15.15,0,0,0,0,.12,1.35,1.35,0,0,0,.43.46,2.68,2.68,0,0,0-1.29,0,1.05,1.05,0,0,0-.41.17.44.44,0,0,0-.16.4c0,.28.43.43.66.53a3.88,3.88,0,0,0,1,.26.36.36,0,0,0-.08.31.2.2,0,0,0,.08.12,1.13,1.13,0,0,0,.46.21c1.18.33,2.42.35,3.61.65a8.26,8.26,0,0,0,.89.22h.09c.05,0,.06-.08.07-.13A3.33,3.33,0,0,0,167.67,89.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.84,87.69a2.21,2.21,0,0,0-.32-.72,1.87,1.87,0,0,0-1.34-.82.5.5,0,0,0-.34.09.39.39,0,0,0-.12.37,1.3,1.3,0,0,0,.17.38,2.1,2.1,0,0,0-1.33-.38c-.18,0-.4.09-.39.27a.46.46,0,0,0,.07.16,3,3,0,0,0,.67.71c-.18,0-.4-.1-.52,0s0,.34.05.49c.5.74,1.55.84,2.22,1.43-.16,0-.37.05-.38.21s.16.23.3.27a5.08,5.08,0,0,1,.93.39c.28.14.55.39.82.51a2.62,2.62,0,0,0,0-.84c0-.31,0-.62-.07-.93A14,14,0,0,0,167.84,87.69Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.84,87.69a2.21,2.21,0,0,0-.32-.72,1.87,1.87,0,0,0-1.34-.82.5.5,0,0,0-.34.09.39.39,0,0,0-.12.37,1.3,1.3,0,0,0,.17.38,2.1,2.1,0,0,0-1.33-.38c-.18,0-.4.09-.39.27a.46.46,0,0,0,.07.16,3,3,0,0,0,.67.71c-.18,0-.4-.1-.52,0s0,.34.05.49c.5.74,1.55.84,2.22,1.43-.16,0-.37.05-.38.21s.16.23.3.27a5.08,5.08,0,0,1,.93.39c.28.14.55.39.82.51a2.62,2.62,0,0,0,0-.84c0-.31,0-.62-.07-.93A14,14,0,0,0,167.84,87.69Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.81,89.05c-.34.47-.66.94-1,1.41A7,7,0,0,0,169,92a.43.43,0,0,1-.15.24c-.28.18-.47-.38-.54-.54a5.71,5.71,0,0,1-.4-2.92.55.55,0,0,1,.14-.36c.11-.09.31,0,.31.09A2.28,2.28,0,0,1,168.6,87a.3.3,0,0,1,.28-.17.33.33,0,0,1,.21.26,1.85,1.85,0,0,1,.06.57,2,2,0,0,1,.33-.48.8.8,0,0,1,.44-.26.65.65,0,0,1,.65.6,1.84,1.84,0,0,1-.2.94c.16-.1.36-.2.51-.09a.31.31,0,0,1,.11.34A.85.85,0,0,1,170.81,89.05Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.81,89.05c-.34.47-.66.94-1,1.41A7,7,0,0,0,169,92a.43.43,0,0,1-.15.24c-.28.18-.47-.38-.54-.54a5.71,5.71,0,0,1-.4-2.92.55.55,0,0,1,.14-.36c.11-.09.31,0,.31.09A2.28,2.28,0,0,1,168.6,87a.3.3,0,0,1,.28-.17.33.33,0,0,1,.21.26,1.85,1.85,0,0,1,.06.57,2,2,0,0,1,.33-.48.8.8,0,0,1,.44-.26.65.65,0,0,1,.65.6,1.84,1.84,0,0,1-.2.94c.16-.1.36-.2.51-.09a.31.31,0,0,1,.11.34A.85.85,0,0,1,170.81,89.05Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.06,92.46a7.53,7.53,0,0,1,1.82.73c.66-.47,1.24-1,1.91-1.51.11-.07.24-.2.16-.31s-.1-.07-.17-.08a2.25,2.25,0,0,0-1.12.1c.06-.44.54-.8.41-1.22a1.37,1.37,0,0,0-.85.45,3.74,3.74,0,0,0-.58.79,3.38,3.38,0,0,0-1.5-.69.25.25,0,0,0-.21,0c-.08.09,0,.24.09.33a6.57,6.57,0,0,0,.68.61,1.91,1.91,0,0,0-1.54.09c-.08.06-.24.25-.14.35a.35.35,0,0,0,.17.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.78,103c0-.07-.08,0-.08,0a10.84,10.84,0,0,1-1.24,5.85,20.35,20.35,0,0,0-1.2,2.7,11.21,11.21,0,0,0-.55,2.87,14.09,14.09,0,0,0,0,1.84c.05.6,0,1.2.05,1.8,0,0,0,0,0,0,0-.48.08-1,.13-1.46s.2-1,.29-1.55a25.72,25.72,0,0,1,.61-3,23.78,23.78,0,0,1,1.17-2.76,9.93,9.93,0,0,0,.82-2.87A12.33,12.33,0,0,0,172.78,103Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.92,108.91a27.22,27.22,0,0,1-1-3.19,20.88,20.88,0,0,1-.48-3.33,18,18,0,0,0-.15-1.8,6.21,6.21,0,0,0-.41-1.7,8.2,8.2,0,0,0-.82-1.55,4.06,4.06,0,0,0-.46-.55,2.61,2.61,0,0,0-.69-.44s0,0,0,.05A4.08,4.08,0,0,1,167.39,99c.07.58.15,1.14.18,1.72s0,1.1.07,1.66a19.34,19.34,0,0,0,1.49,6.4,10.72,10.72,0,0,1,1,3.22c0,.1.12.14.16,0A4.23,4.23,0,0,0,169.92,108.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.93,128.88v-.47c0-1.55,0-3.1-.1-4.64a28.22,28.22,0,0,0-.91-6.19,60.92,60.92,0,0,0-2.27-5.79c-1-2.48-2-5-2.86-7.53a124.67,124.67,0,0,1-3.54-12.13c-1-4.13-1.66-8.32-2.24-12.52,0-.08-.1-.08-.09,0,0,.58.07,1.16.14,1.73a98,98,0,0,0,2.26,12.5,119.49,119.49,0,0,0,3.67,12.1c1,2.9,2.18,5.76,3.4,8.59.29.79.57,1.57.8,2.37a26.36,26.36,0,0,1,1,5.34c.15,1.89.15,3.79.17,5.68s0,3.82,0,5.74c0,2.29,0,4.59-.06,6.88,0,.12.14.18.16,0A81.65,81.65,0,0,0,169.93,128.88Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.25,79.47c-.07.09-.16.35-.3.33s-.14-.13-.19-.2a3.33,3.33,0,0,0-.25-.28,3.94,3.94,0,0,1-.51-.65c-.09-.14-.16-.34,0-.45a.34.34,0,0,1,.3-.07,2.26,2.26,0,0,1,0-.37.34.34,0,0,1,.09-.22.25.25,0,0,1,.31,0,.9.9,0,0,1,.21.27.27.27,0,0,1,.29-.11.38.38,0,0,1,.23.22.73.73,0,0,1,0,.33.27.27,0,0,1,.24.06.45.45,0,0,1,.12.42.86.86,0,0,1-.23.39C158.47,79.25,158.35,79.35,158.25,79.47Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.88,80a1,1,0,0,1,.26-1,.37.37,0,0,1,.23-.1.17.17,0,0,1,.18.15,1.06,1.06,0,0,1,.37-.44.34.34,0,0,1,.19-.09.21.21,0,0,1,.18.07c.06.1,0,.23-.08.32a.49.49,0,0,1,.37-.12c.09,0,.2.06.22.15a.27.27,0,0,1-.09.22,2.68,2.68,0,0,1-1,.53,1.34,1.34,0,0,0-.8.69C157.93,80.29,157.9,80.17,157.88,80Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.88,80a1,1,0,0,1,.26-1,.37.37,0,0,1,.23-.1.17.17,0,0,1,.18.15,1.06,1.06,0,0,1,.37-.44.34.34,0,0,1,.19-.09.21.21,0,0,1,.18.07c.06.1,0,.23-.08.32a.49.49,0,0,1,.37-.12c.09,0,.2.06.22.15a.27.27,0,0,1-.09.22,2.68,2.68,0,0,1-1,.53,1.34,1.34,0,0,0-.8.69C157.93,80.29,157.9,80.17,157.88,80Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.06,80.35a2,2,0,0,0-.09-.62,1.45,1.45,0,0,0-.55-.82.31.31,0,0,0-.24-.07.21.21,0,0,0-.11.27,1.11,1.11,0,0,0-.4-.31.32.32,0,0,0-.35,0c-.12.1-.07.29,0,.4s.25.16.36.26a.15.15,0,0,0-.2.06.21.21,0,0,0,0,.23.6.6,0,0,0,.2.14c.22.1.45.15.67.25a1,1,0,0,1,.51.48C158,80.58,158.05,80.48,158.06,80.35Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.06,80.35a2,2,0,0,0-.09-.62,1.45,1.45,0,0,0-.55-.82.31.31,0,0,0-.24-.07.21.21,0,0,0-.11.27,1.11,1.11,0,0,0-.4-.31.32.32,0,0,0-.35,0c-.12.1-.07.29,0,.4s.25.16.36.26a.15.15,0,0,0-.2.06.21.21,0,0,0,0,.23.6.6,0,0,0,.2.14c.22.1.45.15.67.25a1,1,0,0,1,.51.48C158,80.58,158.05,80.48,158.06,80.35Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.39,79.69c.1,0,.2,0,.15.1a1.58,1.58,0,0,1-.2.36.69.69,0,0,1,.76-.07,1.37,1.37,0,0,1-.45.18,1.48,1.48,0,0,0-.6.54,1.18,1.18,0,0,0-.9-.36.54.54,0,0,1,.52-.19l-.16-.24c-.06-.09,0-.18.08-.19a.22.22,0,0,1,.14,0,.47.47,0,0,1,.24.26c0-.09.21-.3.27-.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.83,83a.77.77,0,0,0-.28-.23.27.27,0,0,0-.31,0c-.07.08,0,.21,0,.31-.07-.08-.2,0-.3,0a.1.1,0,0,0,0,0s0,0,0,.06a1.29,1.29,0,0,0,.25.46.2.2,0,0,0-.24.18.33.33,0,0,0,.13.3.92.92,0,0,0,.31.16l.49.19a.35.35,0,0,0,.22,0,.23.23,0,0,0,.17-.15,1.1,1.1,0,0,0,0-.67A1.71,1.71,0,0,0,157.83,83Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.83,83a.77.77,0,0,0-.28-.23.27.27,0,0,0-.31,0c-.07.08,0,.21,0,.31-.07-.08-.2,0-.3,0a.1.1,0,0,0,0,0s0,0,0,.06a1.29,1.29,0,0,0,.25.46.2.2,0,0,0-.24.18.33.33,0,0,0,.13.3.92.92,0,0,0,.31.16l.49.19a.35.35,0,0,0,.22,0,.23.23,0,0,0,.17-.15,1.1,1.1,0,0,0,0-.67A1.71,1.71,0,0,0,157.83,83Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.17,82.18a.23.23,0,0,1,.19.19.35.35,0,0,1,.19-.12.23.23,0,0,1,.21.14.69.69,0,0,1,0,.25.19.19,0,0,1,.24,0,.24.24,0,0,1,.09.24.33.33,0,0,1-.14.22c.06,0,.13,0,.14.09a.23.23,0,0,1-.06.18,4.21,4.21,0,0,1-.8.65c-.06,0-.15.24-.24.23a.18.18,0,0,1-.07,0,1.3,1.3,0,0,1-.32-1.13,1,1,0,0,1,.06-.34,2,2,0,0,1,.12-.34.37.37,0,0,1,.29-.21Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.17,82.18a.23.23,0,0,1,.19.19.35.35,0,0,1,.19-.12.23.23,0,0,1,.21.14.69.69,0,0,1,0,.25.19.19,0,0,1,.24,0,.24.24,0,0,1,.09.24.33.33,0,0,1-.14.22c.06,0,.13,0,.14.09a.23.23,0,0,1-.06.18,4.21,4.21,0,0,1-.8.65c-.06,0-.15.24-.24.23a.18.18,0,0,1-.07,0,1.3,1.3,0,0,1-.32-1.13,1,1,0,0,1,.06-.34,2,2,0,0,1,.12-.34.37.37,0,0,1,.29-.21Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.12,84.43a2.47,2.47,0,0,1-.52-1.08.19.19,0,0,1,0-.15c0-.07.15-.06.23,0s-.14-.17-.2-.26a.69.69,0,0,1-.12-.31.34.34,0,0,1,.11-.3.24.24,0,0,1,.31,0c.05-.1.1-.24.19-.29a.3.3,0,0,1,.3,0c.19.09.2.3.23.48a.22.22,0,0,1,.3.06.35.35,0,0,1,0,.33.85.85,0,0,1-.17.29c.12-.06.27.06.29.19a.53.53,0,0,1-.13.38c-.12.19-.24.4-.37.57a.78.78,0,0,0-.12.22s-.05.24,0,.27A2.9,2.9,0,0,1,158.12,84.43Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.47,83.76a.91.91,0,0,1,.11-.16l.07,0c.09,0,.17,0,.22.13a1.27,1.27,0,0,1,.38-.53.39.39,0,0,1,.19-.1.29.29,0,0,1,.28.11.32.32,0,0,1,.05.3.66.66,0,0,1,.55-.31.36.36,0,0,1,.25.06.26.26,0,0,1,.1.24.28.28,0,0,1-.08.12,1.69,1.69,0,0,1-.42.38c.06,0,.17,0,.2.08a.25.25,0,0,1-.05.23,1.68,1.68,0,0,1-.45.3c-.17.08-.36.14-.53.2a1.79,1.79,0,0,0-.45.19c-.08,0-.39.24-.34.36a2.86,2.86,0,0,1-.18-1.23A1.26,1.26,0,0,1,158.47,83.76Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.47,83.76a.91.91,0,0,1,.11-.16l.07,0c.09,0,.17,0,.22.13a1.27,1.27,0,0,1,.38-.53.39.39,0,0,1,.19-.1.29.29,0,0,1,.28.11.32.32,0,0,1,.05.3.66.66,0,0,1,.55-.31.36.36,0,0,1,.25.06.26.26,0,0,1,.1.24.28.28,0,0,1-.08.12,1.69,1.69,0,0,1-.42.38c.06,0,.17,0,.2.08a.25.25,0,0,1-.05.23,1.68,1.68,0,0,1-.45.3c-.17.08-.36.14-.53.2a1.79,1.79,0,0,0-.45.19c-.08,0-.39.24-.34.36a2.86,2.86,0,0,1-.18-1.23A1.26,1.26,0,0,1,158.47,83.76Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.52,84.25l-.05-.08a.47.47,0,0,0-.23-.21c-.11,0-.24.05-.23.15a2,2,0,0,0-.32-.38c-.08-.07-.2-.15-.3-.1a.21.21,0,0,0-.1.21.65.65,0,0,0,.09.23,1,1,0,0,0-.69-.07c-.11,0-.23.09-.25.2a.27.27,0,0,0,.1.25,1.19,1.19,0,0,0,.26.11,5,5,0,0,1,.64.26.8.8,0,0,0-.35.19.09.09,0,0,0,0,0s0,0,0,.06a.81.81,0,0,0,.54.1,2.69,2.69,0,0,1,.8.09.34.34,0,0,0,.17,0c.24,0,.1-.46.07-.61A1.36,1.36,0,0,0,158.52,84.25Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.52,84.25l-.05-.08a.47.47,0,0,0-.23-.21c-.11,0-.24.05-.23.15a2,2,0,0,0-.32-.38c-.08-.07-.2-.15-.3-.1a.21.21,0,0,0-.1.21.65.65,0,0,0,.09.23,1,1,0,0,0-.69-.07c-.11,0-.23.09-.25.2a.27.27,0,0,0,.1.25,1.19,1.19,0,0,0,.26.11,5,5,0,0,1,.64.26.8.8,0,0,0-.35.19.09.09,0,0,0,0,0s0,0,0,.06a.81.81,0,0,0,.54.1,2.69,2.69,0,0,1,.8.09.34.34,0,0,0,.17,0c.24,0,.1-.46.07-.61A1.36,1.36,0,0,0,158.52,84.25Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.08,91.63a3,3,0,0,0-.43.06,4.62,4.62,0,0,1-.61.11.27.27,0,0,1-.21-.07.1.1,0,0,1,0-.17,2.88,2.88,0,0,1-.83,0c-.06,0-.13,0-.13-.11a.13.13,0,0,1,0-.07,1.34,1.34,0,0,1,.51-.4,4.69,4.69,0,0,1-.65-.14l0,0s0-.09,0-.12a1.63,1.63,0,0,1,1.57-.29,3.45,3.45,0,0,1-1.12-.88.87.87,0,0,1-.17-.38.53.53,0,0,1,.07-.41.44.44,0,0,1,.38-.2s.37.1.36.16a.48.48,0,0,1,.51-.32,1.05,1.05,0,0,1,.58.3,2.82,2.82,0,0,1,.71,1.14,5,5,0,0,1,.23,1.08,1.58,1.58,0,0,1,0,.53c-.06.21-.29.2-.47.2A2.68,2.68,0,0,0,159.08,91.63Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.92,89.94a1.6,1.6,0,0,1,.7-1,.42.42,0,0,1,.4,0c.15.07.18.27.17.43a3.8,3.8,0,0,1,1-.94s.13-.06.16,0a.11.11,0,0,1,0,.08,1,1,0,0,1-.13.37,1.64,1.64,0,0,1,.73-.34.66.66,0,0,1,.28,0,.26.26,0,0,1,.2.19c0,.17-.14.35-.24.47a2.24,2.24,0,0,1-.51.41.26.26,0,0,1,.13.16.29.29,0,0,1,0,.09.69.69,0,0,1-.21.24c-.59.5-1.3.83-1.9,1.31-.15.12-.3.25-.46.36l0,0a.09.09,0,0,1-.07,0A2.1,2.1,0,0,1,159.92,89.94Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.92,89.94a1.6,1.6,0,0,1,.7-1,.42.42,0,0,1,.4,0c.15.07.18.27.17.43a3.8,3.8,0,0,1,1-.94s.13-.06.16,0a.11.11,0,0,1,0,.08,1,1,0,0,1-.13.37,1.64,1.64,0,0,1,.73-.34.66.66,0,0,1,.28,0,.26.26,0,0,1,.2.19c0,.17-.14.35-.24.47a2.24,2.24,0,0,1-.51.41.26.26,0,0,1,.13.16.29.29,0,0,1,0,.09.69.69,0,0,1-.21.24c-.59.5-1.3.83-1.9,1.31-.15.12-.3.25-.46.36l0,0a.09.09,0,0,1-.07,0A2.1,2.1,0,0,1,159.92,89.94Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.15,88.93a1,1,0,0,1,0-.24,1.5,1.5,0,0,1,.73-1.08.29.29,0,0,1,.22,0,.24.24,0,0,1,.16.19.76.76,0,0,1,0,.26,1.34,1.34,0,0,1,.67-.57c.1,0,.25,0,.29.06a.2.2,0,0,1,0,.11,2,2,0,0,1-.19.58c.08-.08.2-.16.3-.12a.28.28,0,0,1,.1.3c-.09.55-.67.89-.91,1.4.1,0,.23-.07.28,0s0,.17-.11.24a3.77,3.77,0,0,0-.43.46,1.4,1.4,0,0,0-.15.24c0,.06-.09.19-.16.23s-.23-.25-.28-.33a5.7,5.7,0,0,1-.45-1.12A2,2,0,0,1,159.15,88.93Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,90.48l.93.55a4.19,4.19,0,0,1,.88.69.31.31,0,0,0,.15.1c.21,0,.17-.35.17-.46a3.62,3.62,0,0,0-.53-1.78.3.3,0,0,0-.18-.17c-.08,0-.18,0-.15.13a1.42,1.42,0,0,0-.53-.81.21.21,0,0,0-.2,0,.22.22,0,0,0-.05.21.9.9,0,0,0,.11.34,1.29,1.29,0,0,0-.32-.19.5.5,0,0,0-.32,0,.44.44,0,0,0-.22.52,1.41,1.41,0,0,0,.36.49c-.11,0-.26,0-.32.08a.2.2,0,0,0,0,.22A.67.67,0,0,0,158,90.48Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,90.48l.93.55a4.19,4.19,0,0,1,.88.69.31.31,0,0,0,.15.1c.21,0,.17-.35.17-.46a3.62,3.62,0,0,0-.53-1.78.3.3,0,0,0-.18-.17c-.08,0-.18,0-.15.13a1.42,1.42,0,0,0-.53-.81.21.21,0,0,0-.2,0,.22.22,0,0,0-.05.21.9.9,0,0,0,.11.34,1.29,1.29,0,0,0-.32-.19.5.5,0,0,0-.32,0,.44.44,0,0,0-.22.52,1.41,1.41,0,0,0,.36.49c-.11,0-.26,0-.32.08a.2.2,0,0,0,0,.22A.67.67,0,0,0,158,90.48Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,91.47a4.46,4.46,0,0,0-.85.89c-.5-.1-1-.29-1.5-.37-.08,0-.19-.06-.17-.14a.14.14,0,0,1,.08-.09,1.46,1.46,0,0,1,.67-.24c-.15-.23-.52-.32-.55-.59a.89.89,0,0,1,.6,0,3.16,3.16,0,0,1,.54.31,2.16,2.16,0,0,1,.68-.79.21.21,0,0,1,.13,0c.08,0,.06.14,0,.22a4.83,4.83,0,0,1-.23.52,1.18,1.18,0,0,1,.9-.34c.07,0,.21.07.18.16a.39.39,0,0,1-.08.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.18,95.08a1.9,1.9,0,0,0-.58-.44.51.51,0,0,0-.6.07c-.14.16-.08.41,0,.62a.51.51,0,0,0-.6,0,.22.22,0,0,0-.1.09.25.25,0,0,0,0,.12,2.77,2.77,0,0,0,.53.89.42.42,0,0,0-.48.37.73.73,0,0,0,.29.6,2,2,0,0,0,.62.29l1,.35a.78.78,0,0,0,.45.06.5.5,0,0,0,.31-.31,2.24,2.24,0,0,0-.06-1.33A3.5,3.5,0,0,0,160.18,95.08Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.18,95.08a1.9,1.9,0,0,0-.58-.44.51.51,0,0,0-.6.07c-.14.16-.08.41,0,.62a.51.51,0,0,0-.6,0,.22.22,0,0,0-.1.09.25.25,0,0,0,0,.12,2.77,2.77,0,0,0,.53.89.42.42,0,0,0-.48.37.73.73,0,0,0,.29.6,2,2,0,0,0,.62.29l1,.35a.78.78,0,0,0,.45.06.5.5,0,0,0,.31-.31,2.24,2.24,0,0,0-.06-1.33A3.5,3.5,0,0,0,160.18,95.08Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.78,93.34a.45.45,0,0,1,.38.37.66.66,0,0,1,.38-.25.43.43,0,0,1,.41.25,1,1,0,0,1,.08.51.39.39,0,0,1,.49,0,.51.51,0,0,1,.19.46.67.67,0,0,1-.26.45c.12-.06.26,0,.29.18a.51.51,0,0,1-.12.36A8.33,8.33,0,0,1,163.08,97c-.11.1-.29.48-.47.45a.33.33,0,0,1-.13-.07,2.65,2.65,0,0,1-.72-2.24,2.13,2.13,0,0,1,.1-.67,4.26,4.26,0,0,1,.22-.69.75.75,0,0,1,.55-.43A.38.38,0,0,1,162.78,93.34Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.78,93.34a.45.45,0,0,1,.38.37.66.66,0,0,1,.38-.25.43.43,0,0,1,.41.25,1,1,0,0,1,.08.51.39.39,0,0,1,.49,0,.51.51,0,0,1,.19.46.67.67,0,0,1-.26.45c.12-.06.26,0,.29.18a.51.51,0,0,1-.12.36A8.33,8.33,0,0,1,163.08,97c-.11.1-.29.48-.47.45a.33.33,0,0,1-.13-.07,2.65,2.65,0,0,1-.72-2.24,2.13,2.13,0,0,1,.1-.67,4.26,4.26,0,0,1,.22-.69.75.75,0,0,1,.55-.43A.38.38,0,0,1,162.78,93.34Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.86,97.87a4.71,4.71,0,0,1-1.12-2.1.35.35,0,0,1,0-.3c.08-.14.3-.12.46-.08-.14-.18-.29-.34-.42-.52a1.2,1.2,0,0,1-.26-.6.67.67,0,0,1,.2-.6.48.48,0,0,1,.61,0c.1-.2.18-.48.37-.6a.6.6,0,0,1,.59-.06c.38.17.41.58.48.94a.43.43,0,0,1,.6.1.74.74,0,0,1,.09.65,2.34,2.34,0,0,1-.33.6c.24-.14.55.09.59.36a1.14,1.14,0,0,1-.22.76c-.23.37-.44.79-.69,1.16a.93.93,0,0,0-.22.43c0,.08-.1.47,0,.53A4.92,4.92,0,0,1,160.86,97.87Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.5,96.53a1,1,0,0,1,.21-.32.41.41,0,0,1,.13-.1c.18-.07.35.1.46.25a2.33,2.33,0,0,1,.7-1.08.86.86,0,0,1,.38-.22.58.58,0,0,1,.56.21.65.65,0,0,1,.11.59,1.34,1.34,0,0,1,1.08-.66.79.79,0,0,1,.5.11.48.48,0,0,1,.21.46.62.62,0,0,1-.14.25,3.46,3.46,0,0,1-.83.79.3.3,0,0,1,.42.13.49.49,0,0,1-.09.46,3,3,0,0,1-.87.64,9.57,9.57,0,0,1-1.05.42,4.61,4.61,0,0,0-.87.41c-.14.09-.75.5-.64.75a5.67,5.67,0,0,1-.44-2.43A1.84,1.84,0,0,1,161.5,96.53Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.5,96.53a1,1,0,0,1,.21-.32.41.41,0,0,1,.13-.1c.18-.07.35.1.46.25a2.33,2.33,0,0,1,.7-1.08.86.86,0,0,1,.38-.22.58.58,0,0,1,.56.21.65.65,0,0,1,.11.59,1.34,1.34,0,0,1,1.08-.66.79.79,0,0,1,.5.11.48.48,0,0,1,.21.46.62.62,0,0,1-.14.25,3.46,3.46,0,0,1-.83.79.3.3,0,0,1,.42.13.49.49,0,0,1-.09.46,3,3,0,0,1-.87.64,9.57,9.57,0,0,1-1.05.42,4.61,4.61,0,0,0-.87.41c-.14.09-.75.5-.64.75a5.67,5.67,0,0,1-.44-2.43A1.84,1.84,0,0,1,161.5,96.53Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.62,97.5a1,1,0,0,0-.1-.17.89.89,0,0,0-.47-.39c-.21,0-.46.11-.44.31a4.21,4.21,0,0,0-.67-.73c-.16-.14-.39-.28-.59-.18a.41.41,0,0,0-.19.43,1.13,1.13,0,0,0,.2.45,1.94,1.94,0,0,0-1.38-.1c-.22.07-.45.2-.48.43a.49.49,0,0,0,.23.47,1.53,1.53,0,0,0,.51.21,12.31,12.31,0,0,1,1.28.47,1.54,1.54,0,0,0-.67.4.19.19,0,0,0,0,.1.14.14,0,0,0,.07.11,1.6,1.6,0,0,0,1.09.17,5.32,5.32,0,0,1,1.59.13.78.78,0,0,0,.34,0c.47-.09.15-.93.1-1.21A2.72,2.72,0,0,0,161.62,97.5Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.62,97.5a1,1,0,0,0-.1-.17.89.89,0,0,0-.47-.39c-.21,0-.46.11-.44.31a4.21,4.21,0,0,0-.67-.73c-.16-.14-.39-.28-.59-.18a.41.41,0,0,0-.19.43,1.13,1.13,0,0,0,.2.45,1.94,1.94,0,0,0-1.38-.1c-.22.07-.45.2-.48.43a.49.49,0,0,0,.23.47,1.53,1.53,0,0,0,.51.21,12.31,12.31,0,0,1,1.28.47,1.54,1.54,0,0,0-.67.4.19.19,0,0,0,0,.1.14.14,0,0,0,.07.11,1.6,1.6,0,0,0,1.09.17,5.32,5.32,0,0,1,1.59.13.78.78,0,0,0,.34,0c.47-.09.15-.93.1-1.21A2.72,2.72,0,0,0,161.62,97.5Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.6,99.27a.25.25,0,0,1,.11-.12,1.56,1.56,0,0,1,.83-.33l-.79-.46c-.1,0-.21-.13-.21-.24a.28.28,0,0,1,.14-.21,1.54,1.54,0,0,1,1.37-.11,1.74,1.74,0,0,1-.06-1.19.75.75,0,0,1,.23-.38.39.39,0,0,1,.41-.06.57.57,0,0,1,.2.26c.07.13.14.27.2.41a1,1,0,0,0,.14.31c.13-.11.22-.27.34-.39a2.07,2.07,0,0,1,.44-.34c.17-.1.55-.29.71-.07a.36.36,0,0,1,0,.32,5.51,5.51,0,0,1-.55.94c.24-.12.47-.35.74-.32a.25.25,0,0,1,.16.08c.1.11,0,.27-.06.39-.26.37-.69.61-.86,1A1.22,1.22,0,0,1,163,99a6.5,6.5,0,0,0-.22.62,5,5,0,0,1,1.08-.61,11.5,11.5,0,0,0,1.46-.7A3,3,0,0,0,166.57,97c.06-.16.2,0,.17.15a2.7,2.7,0,0,1-.62,1.24,4.65,4.65,0,0,1-1.11.86c-.5.31-1,.54-1.54.86a1.64,1.64,0,0,0-.42.37c-.13.17-.21.39-.34.57s-.23.18-.3.15l0,0a2.82,2.82,0,0,0-.51-.68,2,2,0,0,0-.56-.44,13.21,13.21,0,0,0-1.35-.43.59.59,0,0,1-.27-.11A.25.25,0,0,1,159.6,99.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.22,107.16a5.12,5.12,0,0,1,.65-.25,6.57,6.57,0,0,0,.91-.34c.1-.06.21-.14.23-.25s-.09-.26-.2-.21a4.3,4.3,0,0,0,1.13-.68c.07-.06.14-.15.09-.23a.2.2,0,0,0-.1-.08,2.1,2.1,0,0,0-1-.14,8.63,8.63,0,0,0,.77-.71.18.18,0,0,0,0-.07c0-.08-.09-.13-.17-.14a2.58,2.58,0,0,0-2.38.86,5.31,5.31,0,0,0,.84-2.1,1.64,1.64,0,0,0-.07-.66.94.94,0,0,0-.43-.51.75.75,0,0,0-.67,0c-.07,0-.43.44-.36.51a.75.75,0,0,0-1,0,1.6,1.6,0,0,0-.55.88,4.47,4.47,0,0,0-.08,2.12,7.43,7.43,0,0,0,.55,1.67,2.23,2.23,0,0,0,.41.74c.24.24.55,0,.8-.1A6,6,0,0,1,166.22,107.16Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.73,105.52a2.5,2.5,0,0,0-1.72-.74.68.68,0,0,0-.6.24.74.74,0,0,0,.13.73,1.37,1.37,0,0,0-1.14,0c-.07,0-.15.08-.15.16s0,.1.06.14a2.57,2.57,0,0,0,.33.33,1,1,0,0,0-.8.23,1.32,1.32,0,0,0-.36.31.54.54,0,0,0-.09.46.51.51,0,0,0,.32.32,1.41,1.41,0,0,0,.46.11c.62.07,1.27.2,1.9.23s1.14,0,1.72.11c.3,0,.6.11.9.13,0,0,.07,0,.1,0a.15.15,0,0,0,.05-.13A3.32,3.32,0,0,0,163.73,105.52Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.73,105.52a2.5,2.5,0,0,0-1.72-.74.68.68,0,0,0-.6.24.74.74,0,0,0,.13.73,1.37,1.37,0,0,0-1.14,0c-.07,0-.15.08-.15.16s0,.1.06.14a2.57,2.57,0,0,0,.33.33,1,1,0,0,0-.8.23,1.32,1.32,0,0,0-.36.31.54.54,0,0,0-.09.46.51.51,0,0,0,.32.32,1.41,1.41,0,0,0,.46.11c.62.07,1.27.2,1.9.23s1.14,0,1.72.11c.3,0,.6.11.9.13,0,0,.07,0,.1,0a.15.15,0,0,0,.05-.13A3.32,3.32,0,0,0,163.73,105.52Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.71,103.67a2.05,2.05,0,0,0-.39-.69,1.88,1.88,0,0,0-1.42-.68.53.53,0,0,0-.33.12.39.39,0,0,0-.07.39,1.07,1.07,0,0,0,.2.36,2.09,2.09,0,0,0-1.36-.25c-.18,0-.39.14-.36.31a.36.36,0,0,0,.08.15,2.82,2.82,0,0,0,.74.64c-.18,0-.4-.06-.51.09s0,.35.09.49c.57.68,1.64.68,2.36,1.19-.16,0-.37.09-.36.25s.19.21.33.24a5.31,5.31,0,0,1,1,.29c.3.12.58.33.87.43a3,3,0,0,0-.07-.84,7.27,7.27,0,0,0-.17-.91A14.23,14.23,0,0,0,163.71,103.67Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.81,104.72c-.3.5-.57,1-.85,1.5a6.87,6.87,0,0,0-.66,1.64.45.45,0,0,1-.12.25c-.26.21-.51-.33-.59-.48a5.73,5.73,0,0,1-.7-2.87.48.48,0,0,1,.11-.37c.09-.1.29-.08.31.06a2.34,2.34,0,0,1,.08-1.53.31.31,0,0,1,.27-.19c.12,0,.19.13.23.24a1.69,1.69,0,0,1,.12.55,2.22,2.22,0,0,1,.28-.5.8.8,0,0,1,.42-.31.65.65,0,0,1,.7.53,1.87,1.87,0,0,1-.1,1c.14-.12.34-.24.5-.15a.34.34,0,0,1,.14.33A1.11,1.11,0,0,1,166.81,104.72Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.81,104.72c-.3.5-.57,1-.85,1.5a6.87,6.87,0,0,0-.66,1.64.45.45,0,0,1-.12.25c-.26.21-.51-.33-.59-.48a5.73,5.73,0,0,1-.7-2.87.48.48,0,0,1,.11-.37c.09-.1.29-.08.31.06a2.34,2.34,0,0,1,.08-1.53.31.31,0,0,1,.27-.19c.12,0,.19.13.23.24a1.69,1.69,0,0,1,.12.55,2.22,2.22,0,0,1,.28-.5.8.8,0,0,1,.42-.31.65.65,0,0,1,.7.53,1.87,1.87,0,0,1-.1,1c.14-.12.34-.24.5-.15a.34.34,0,0,1,.14.33A1.11,1.11,0,0,1,166.81,104.72Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.42,108.49a8,8,0,0,1,1.88.54c.6-.53,1.12-1.17,1.75-1.69.1-.08.21-.23.13-.33A.22.22,0,0,0,167,107a2.37,2.37,0,0,0-1.11.21c0-.44.46-.85.29-1.25a1.41,1.41,0,0,0-.81.53,4.18,4.18,0,0,0-.49.85,3.35,3.35,0,0,0-1.56-.54c-.07,0-.16,0-.2.06s0,.24.12.32a6.25,6.25,0,0,0,.73.54,1.91,1.91,0,0,0-1.51.24c-.08.08-.22.27-.11.37a.29.29,0,0,0,.18.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.76,86a.57.57,0,0,0,.28.11,2.17,2.17,0,0,1,.35.15.52.52,0,0,1,.29.29,2,2,0,0,1,.2.42,3.39,3.39,0,0,0,.23-.34c.24-.35.68-.46,1-.67a2,2,0,0,0,1-1.11s-.06-.09-.07,0c-.18.42-.75.65-1.15.81a4.26,4.26,0,0,0-.62.26.45.45,0,0,1,.1-.13,7.54,7.54,0,0,0,.58-.55c0-.06.08-.14,0-.2a.2.2,0,0,0-.08,0c-.13,0-.25.09-.38.15a2.09,2.09,0,0,0,.3-.47c0-.05,0-.11,0-.15s-.27,0-.35,0a.94.94,0,0,0-.23.16c-.07.06-.11.14-.18.19a.77.77,0,0,1-.07-.16,1,1,0,0,0-.09-.21.3.3,0,0,0-.09-.13.2.2,0,0,0-.21,0,.39.39,0,0,0-.12.19.88.88,0,0,0,0,.6.76.76,0,0,0-.69,0,.14.14,0,0,0-.07.1.17.17,0,0,0,.1.13l.39.24a.86.86,0,0,0-.43.15l-.05.06A.11.11,0,0,0,157.76,86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.27,121.34a20.58,20.58,0,0,0-.83-2.7,18.07,18.07,0,0,0-1.14-2.54,9.2,9.2,0,0,0-1.58-2.18c-.61-.57-1.85-.84-2.36,0,0,0,0,.2.08.13,1.39-1.4,3,1.69,3.46,2.64a17.53,17.53,0,0,1,1,2.28c.3.85.53,1.71.81,2.57a27.66,27.66,0,0,1,.84,2.82s0,0,0,0A7.39,7.39,0,0,0,169.27,121.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.76,130.59c-.1-4.27-.08-8.54.1-12.81s.51-8.44,1-12.64a121.75,121.75,0,0,1,2.21-12.44,97.3,97.3,0,0,1,3.65-12.17c.2-.54.44-1.07.66-1.6,0-.08.1,0,.08,0-1.39,4-2.68,8.06-3.68,12.18a124.77,124.77,0,0,0-2.33,12.43c-.58,4.22-1,8.46-1.18,12.71s-.27,8.5-.2,12.75.26,8.48.54,12.72c0,.53.07,1.05.1,1.58,0,.23-.34.27-.36,0Q169.91,137,169.76,130.59Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.52,101.54a2.73,2.73,0,0,0-3.45-.43,7.84,7.84,0,0,0-2.66,3.23c-2.31,4.06-4.42,8.31-5.11,13a21.09,21.09,0,0,0-.25,2.85,11.12,11.12,0,0,0,.35-1.62,33.44,33.44,0,0,1,1.93-6.59c.44-1,1-2,1.47-3s1.1-2.17,1.69-3.23a14.45,14.45,0,0,1,2.27-3.49c.92-.91,2.56-1.52,3.7-.63C181.51,101.67,181.54,101.57,181.52,101.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.78,79c-.11,0-.31.24-.42.16s-.07-.18-.08-.27-.05-.24-.09-.36a3.77,3.77,0,0,1-.17-.81c0-.16,0-.37.17-.42a.4.4,0,0,1,.31.07,1.41,1.41,0,0,1,.17-.32.31.31,0,0,1,.18-.16.26.26,0,0,1,.27.15.77.77,0,0,1,.07.34.23.23,0,0,1,.3,0,.34.34,0,0,1,.11.3.72.72,0,0,1-.11.31.24.24,0,0,1,.18.16.4.4,0,0,1-.08.42.77.77,0,0,1-.38.25C178.07,78.85,177.92,78.89,177.78,79Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.19,79.3a1,1,0,0,1,.69-.79.31.31,0,0,1,.25,0,.2.2,0,0,1,.09.22,1.19,1.19,0,0,1,.53-.23.38.38,0,0,1,.21,0,.2.2,0,0,1,.13.15c0,.11-.12.19-.22.24a.54.54,0,0,1,.39.06.22.22,0,0,1,.12.24c0,.08-.1.12-.18.15a2.45,2.45,0,0,1-1.08,0,1.44,1.44,0,0,0-1,.25C177.12,79.54,177.15,79.42,177.19,79.3Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.19,79.3a1,1,0,0,1,.69-.79.31.31,0,0,1,.25,0,.2.2,0,0,1,.09.22,1.19,1.19,0,0,1,.53-.23.38.38,0,0,1,.21,0,.2.2,0,0,1,.13.15c0,.11-.12.19-.22.24a.54.54,0,0,1,.39.06.22.22,0,0,1,.12.24c0,.08-.1.12-.18.15a2.45,2.45,0,0,1-1.08,0,1.44,1.44,0,0,0-1,.25C177.12,79.54,177.15,79.42,177.19,79.3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.21,79.65a2.15,2.15,0,0,0,.2-.59,1.47,1.47,0,0,0-.12-1,.28.28,0,0,0-.19-.16.2.2,0,0,0-.21.19,1.28,1.28,0,0,0-.21-.46c-.08-.1-.2-.2-.32-.17a.28.28,0,0,0-.14.37c.05.14.15.26.2.4a.14.14,0,0,0-.21,0,.22.22,0,0,0-.07.21.53.53,0,0,0,.11.21c.15.19.34.35.49.54a1,1,0,0,1,.24.65C177.07,79.84,177.14,79.76,177.21,79.65Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.21,79.65a2.15,2.15,0,0,0,.2-.59,1.47,1.47,0,0,0-.12-1,.28.28,0,0,0-.19-.16.2.2,0,0,0-.21.19,1.28,1.28,0,0,0-.21-.46c-.08-.1-.2-.2-.32-.17a.28.28,0,0,0-.14.37c.05.14.15.26.2.4a.14.14,0,0,0-.21,0,.22.22,0,0,0-.07.21.53.53,0,0,0,.11.21c.15.19.34.35.49.54a1,1,0,0,1,.24.65C177.07,79.84,177.14,79.76,177.21,79.65Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.8,79.21c.1,0,.19.07.09.16a1.24,1.24,0,0,1-.34.22.72.72,0,0,1,.71.29,1.65,1.65,0,0,1-.49,0,1.34,1.34,0,0,0-.77.21,1.18,1.18,0,0,0-.65-.73.56.56,0,0,1,.56.06l0-.28c0-.1,0-.18.16-.14a.38.38,0,0,1,.12.09.48.48,0,0,1,.08.35c0-.1.33-.17.41-.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.8,81.91a.89.89,0,0,0-.15-.33.25.25,0,0,0-.28-.12c-.1,0-.14.17-.16.27,0-.1-.16-.14-.27-.14a.07.07,0,0,0-.06,0s0,0,0,0a1.3,1.3,0,0,0,0,.52.21.21,0,0,0-.3,0,.33.33,0,0,0,0,.33.94.94,0,0,0,.2.29l.35.39a.4.4,0,0,0,.18.14.33.33,0,0,0,.22-.06,1.09,1.09,0,0,0,.29-.61A1.66,1.66,0,0,0,175.8,81.91Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.8,81.91a.89.89,0,0,0-.15-.33.25.25,0,0,0-.28-.12c-.1,0-.14.17-.16.27,0-.1-.16-.14-.27-.14a.07.07,0,0,0-.06,0s0,0,0,0a1.3,1.3,0,0,0,0,.52.21.21,0,0,0-.3,0,.33.33,0,0,0,0,.33.94.94,0,0,0,.2.29l.35.39a.4.4,0,0,0,.18.14.33.33,0,0,0,.22-.06,1.09,1.09,0,0,0,.29-.61A1.66,1.66,0,0,0,175.8,81.91Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.37,81.78a.23.23,0,0,1,.08.26.36.36,0,0,1,.23,0,.22.22,0,0,1,.12.21.48.48,0,0,1-.09.25.19.19,0,0,1,.22.1.23.23,0,0,1,0,.25.32.32,0,0,1-.22.13c.07,0,.1.09.08.15a.27.27,0,0,1-.13.13,4.34,4.34,0,0,1-1,.22c-.08,0-.25.14-.32.09a.16.16,0,0,1,0-.07,1.31,1.31,0,0,1,.23-1.16.9.9,0,0,1,.21-.27c.09-.08.15-.19.26-.25a.4.4,0,0,1,.35-.06Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.37,81.78a.23.23,0,0,1,.08.26.36.36,0,0,1,.23,0,.22.22,0,0,1,.12.21.48.48,0,0,1-.09.25.19.19,0,0,1,.22.1.23.23,0,0,1,0,.25.32.32,0,0,1-.22.13c.07,0,.1.09.08.15a.27.27,0,0,1-.13.13,4.34,4.34,0,0,1-1,.22c-.08,0-.25.14-.32.09a.16.16,0,0,1,0-.07,1.31,1.31,0,0,1,.23-1.16.9.9,0,0,1,.21-.27c.09-.08.15-.19.26-.25a.4.4,0,0,1,.35-.06Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.42,83.31a2.44,2.44,0,0,1,0-1.2.21.21,0,0,1,.07-.13c.08,0,.17,0,.23.08,0-.11-.05-.22-.06-.33a.74.74,0,0,1,0-.33.34.34,0,0,1,.24-.21.23.23,0,0,1,.27.13.79.79,0,0,1,.31-.17.28.28,0,0,1,.27.12c.13.17,0,.36,0,.53A.23.23,0,0,1,177,82a.37.37,0,0,1-.12.31,1.08,1.08,0,0,1-.29.18c.13,0,.21.18.17.3a.56.56,0,0,1-.28.29c-.2.11-.39.24-.59.34a.53.53,0,0,0-.2.13s-.16.19-.14.24A2.6,2.6,0,0,1,175.42,83.31Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,82.88a.56.56,0,0,1,.17-.09.12.12,0,0,1,.08,0c.1,0,.13.12.14.22a1.28,1.28,0,0,1,.57-.31.59.59,0,0,1,.23,0,.28.28,0,0,1,.19.23.32.32,0,0,1-.09.28.7.7,0,0,1,.63,0,.44.44,0,0,1,.2.18.25.25,0,0,1,0,.25.35.35,0,0,1-.13.08,1.73,1.73,0,0,1-.55.15c.08,0,.15.07.15.15a.23.23,0,0,1-.16.18,1.2,1.2,0,0,1-.53.07,3.7,3.7,0,0,1-.57-.07,2.58,2.58,0,0,0-.48,0c-.09,0-.45,0-.47.17a3,3,0,0,1,.4-1.17A.82.82,0,0,1,176,82.88Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,82.88a.56.56,0,0,1,.17-.09.12.12,0,0,1,.08,0c.1,0,.13.12.14.22a1.28,1.28,0,0,1,.57-.31.59.59,0,0,1,.23,0,.28.28,0,0,1,.19.23.32.32,0,0,1-.09.28.7.7,0,0,1,.63,0,.44.44,0,0,1,.2.18.25.25,0,0,1,0,.25.35.35,0,0,1-.13.08,1.73,1.73,0,0,1-.55.15c.08,0,.15.07.15.15a.23.23,0,0,1-.16.18,1.2,1.2,0,0,1-.53.07,3.7,3.7,0,0,1-.57-.07,2.58,2.58,0,0,0-.48,0c-.09,0-.45,0-.47.17a3,3,0,0,1,.4-1.17A.82.82,0,0,1,176,82.88Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.85,83.33s0-.06,0-.09a.42.42,0,0,0-.11-.29c-.08-.07-.23-.07-.27,0a1.88,1.88,0,0,0-.12-.48c0-.11-.1-.23-.21-.23a.2.2,0,0,0-.19.14.53.53,0,0,0,0,.25,1,1,0,0,0-.59-.38.31.31,0,0,0-.31.07.24.24,0,0,0,0,.26.92.92,0,0,0,.17.22,5.53,5.53,0,0,1,.46.52.73.73,0,0,0-.39,0,.05.05,0,0,0-.05,0s0,0,0,.06c.07.18.27.26.44.34a3,3,0,0,1,.67.45.45.45,0,0,0,.14.1c.23.07.29-.37.34-.51A1.75,1.75,0,0,0,175.85,83.33Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.85,83.33s0-.06,0-.09a.42.42,0,0,0-.11-.29c-.08-.07-.23-.07-.27,0a1.88,1.88,0,0,0-.12-.48c0-.11-.1-.23-.21-.23a.2.2,0,0,0-.19.14.53.53,0,0,0,0,.25,1,1,0,0,0-.59-.38.31.31,0,0,0-.31.07.24.24,0,0,0,0,.26.92.92,0,0,0,.17.22,5.53,5.53,0,0,1,.46.52.73.73,0,0,0-.39,0,.05.05,0,0,0-.05,0s0,0,0,.06c.07.18.27.26.44.34a3,3,0,0,1,.67.45.45.45,0,0,0,.14.1c.23.07.29-.37.34-.51A1.75,1.75,0,0,0,175.85,83.33Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,90.16a3.38,3.38,0,0,0-.42-.13,4.06,4.06,0,0,1-.59-.19.25.25,0,0,1-.15-.15c0-.07.05-.16.12-.13a2.91,2.91,0,0,1-.74-.39s-.09-.09-.06-.14,0,0,.06,0a1.29,1.29,0,0,1,.64-.13,5.17,5.17,0,0,1-.51-.42.05.05,0,0,1,0,0s0-.09.09-.1a1.68,1.68,0,0,1,1.54.46,3.11,3.11,0,0,1-.6-1.29.85.85,0,0,1,0-.42.52.52,0,0,1,.25-.33.45.45,0,0,1,.42,0s.29.26.25.31a.47.47,0,0,1,.6-.06,1,1,0,0,1,.38.53,2.9,2.9,0,0,1,.12,1.34,4.83,4.83,0,0,1-.29,1.07,1.77,1.77,0,0,1-.23.48c-.14.16-.35,0-.51,0Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.52,89.05a1.53,1.53,0,0,1,1.06-.53.4.4,0,0,1,.38.13c.1.13,0,.32-.05.46a3.68,3.68,0,0,1,1.34-.38c.06,0,.14,0,.15.07a.11.11,0,0,1,0,.07.93.93,0,0,1-.28.28,1.71,1.71,0,0,1,.81,0,.72.72,0,0,1,.25.12.3.3,0,0,1,.1.26c-.05.18-.29.26-.44.31a2.29,2.29,0,0,1-.64.14.24.24,0,0,1,.05.2.13.13,0,0,1-.06.07.62.62,0,0,1-.29.12c-.75.18-1.54.15-2.29.31a5.72,5.72,0,0,1-.57.11H174a.09.09,0,0,1,0-.08A2.07,2.07,0,0,1,174.52,89.05Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.52,89.05a1.53,1.53,0,0,1,1.06-.53.4.4,0,0,1,.38.13c.1.13,0,.32-.05.46a3.68,3.68,0,0,1,1.34-.38c.06,0,.14,0,.15.07a.11.11,0,0,1,0,.07.93.93,0,0,1-.28.28,1.71,1.71,0,0,1,.81,0,.72.72,0,0,1,.25.12.3.3,0,0,1,.1.26c-.05.18-.29.26-.44.31a2.29,2.29,0,0,1-.64.14.24.24,0,0,1,.05.2.13.13,0,0,1-.06.07.62.62,0,0,1-.29.12c-.75.18-1.54.15-2.29.31a5.72,5.72,0,0,1-.57.11H174a.09.09,0,0,1,0-.08A2.07,2.07,0,0,1,174.52,89.05Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.29,87.79a1.37,1.37,0,0,1,.13-.2,1.54,1.54,0,0,1,1.14-.64.3.3,0,0,1,.21.07.23.23,0,0,1,.06.24,1,1,0,0,1-.11.23,1.33,1.33,0,0,1,.85-.2c.11,0,.25.07.23.18a.14.14,0,0,1-.05.1,2,2,0,0,1-.43.43c.11,0,.25,0,.32,0s0,.22,0,.31c-.33.45-1,.48-1.44.83.1,0,.24,0,.24.14s-.11.14-.2.17a3,3,0,0,0-.6.21c-.08,0-.16.1-.24.15a.85.85,0,0,1-.25.13c-.14,0-.09-.33-.1-.42a6,6,0,0,1,.1-1.2A2.25,2.25,0,0,1,174.29,87.79Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.29,87.79a1.37,1.37,0,0,1,.13-.2,1.54,1.54,0,0,1,1.14-.64.3.3,0,0,1,.21.07.23.23,0,0,1,.06.24,1,1,0,0,1-.11.23,1.33,1.33,0,0,1,.85-.2c.11,0,.25.07.23.18a.14.14,0,0,1-.05.1,2,2,0,0,1-.43.43c.11,0,.25,0,.32,0s0,.22,0,.31c-.33.45-1,.48-1.44.83.1,0,.24,0,.24.14s-.11.14-.2.17a3,3,0,0,0-.6.21c-.08,0-.16.1-.24.15a.85.85,0,0,1-.25.13c-.14,0-.09-.33-.1-.42a6,6,0,0,1,.1-1.2A2.25,2.25,0,0,1,174.29,87.79Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.55,88.65c.21.3.39.61.59.91a4.41,4.41,0,0,1,.47,1,.32.32,0,0,0,.09.16c.17.12.31-.23.35-.33a3.51,3.51,0,0,0,.34-1.83.32.32,0,0,0-.08-.23c-.06-.06-.19,0-.2,0a1.42,1.42,0,0,0-.1-1c0-.06-.1-.12-.17-.11s-.12.09-.14.16a1,1,0,0,0-.06.35,1.23,1.23,0,0,0-.19-.31.54.54,0,0,0-.27-.18.42.42,0,0,0-.43.36,1.14,1.14,0,0,0,.1.6c-.1-.07-.22-.13-.32-.07a.21.21,0,0,0-.08.21A1,1,0,0,0,172.55,88.65Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.55,88.65c.21.3.39.61.59.91a4.41,4.41,0,0,1,.47,1,.32.32,0,0,0,.09.16c.17.12.31-.23.35-.33a3.51,3.51,0,0,0,.34-1.83.32.32,0,0,0-.08-.23c-.06-.06-.19,0-.2,0a1.42,1.42,0,0,0-.1-1c0-.06-.1-.12-.17-.11s-.12.09-.14.16a1,1,0,0,0-.06.35,1.23,1.23,0,0,0-.19-.31.54.54,0,0,0-.27-.18.42.42,0,0,0-.43.36,1.14,1.14,0,0,0,.1.6c-.1-.07-.22-.13-.32-.07a.21.21,0,0,0-.08.21A1,1,0,0,0,172.55,88.65Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.82,90.9a4.68,4.68,0,0,0-1.16.41c-.41-.31-.75-.7-1.17-1-.07,0-.14-.14-.09-.21a.14.14,0,0,1,.11,0,1.39,1.39,0,0,1,.7.09c0-.27-.31-.51-.22-.78a.93.93,0,0,1,.53.31,2.18,2.18,0,0,1,.33.52,2.23,2.23,0,0,1,1-.4c.05,0,.1,0,.13,0s0,.15-.06.2a4,4,0,0,1-.45.37,1.2,1.2,0,0,1,1,.1c.05,0,.14.16.08.22a.22.22,0,0,1-.12,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.42,93.74a1.63,1.63,0,0,0-.31-.65.54.54,0,0,0-.57-.22c-.2.09-.26.34-.3.55-.07-.2-.32-.27-.54-.27a.33.33,0,0,0-.13,0s0,.08,0,.12a2.57,2.57,0,0,0,.07,1,.43.43,0,0,0-.6.11.67.67,0,0,0,0,.66,2,2,0,0,0,.41.55c.25.25.49.5.73.76a.77.77,0,0,0,.37.25.53.53,0,0,0,.43-.13,2.27,2.27,0,0,0,.54-1.21A3.41,3.41,0,0,0,172.42,93.74Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.42,93.74a1.63,1.63,0,0,0-.31-.65.54.54,0,0,0-.57-.22c-.2.09-.26.34-.3.55-.07-.2-.32-.27-.54-.27a.33.33,0,0,0-.13,0s0,.08,0,.12a2.57,2.57,0,0,0,.07,1,.43.43,0,0,0-.6.11.67.67,0,0,0,0,.66,2,2,0,0,0,.41.55c.25.25.49.5.73.76a.77.77,0,0,0,.37.25.53.53,0,0,0,.43-.13,2.27,2.27,0,0,0,.54-1.21A3.41,3.41,0,0,0,172.42,93.74Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.53,93.37a.44.44,0,0,1,.17.5.65.65,0,0,1,.45-.05.43.43,0,0,1,.26.41,1,1,0,0,1-.16.49.4.4,0,0,1,.45.18.49.49,0,0,1,0,.51.74.74,0,0,1-.43.28c.13,0,.21.16.17.28a.55.55,0,0,1-.26.28,8.8,8.8,0,0,1-2,.5c-.14,0-.47.29-.62.19a.22.22,0,0,1-.08-.13,2.66,2.66,0,0,1,.36-2.32,2.22,2.22,0,0,1,.4-.55,4.93,4.93,0,0,1,.5-.52.78.78,0,0,1,.69-.13A.35.35,0,0,1,175.53,93.37Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.53,93.37a.44.44,0,0,1,.17.5.65.65,0,0,1,.45-.05.43.43,0,0,1,.26.41,1,1,0,0,1-.16.49.4.4,0,0,1,.45.18.49.49,0,0,1,0,.51.74.74,0,0,1-.43.28c.13,0,.21.16.17.28a.55.55,0,0,1-.26.28,8.8,8.8,0,0,1-2,.5c-.14,0-.47.29-.62.19a.22.22,0,0,1-.08-.13,2.66,2.66,0,0,1,.36-2.32,2.22,2.22,0,0,1,.4-.55,4.93,4.93,0,0,1,.5-.52.78.78,0,0,1,.69-.13A.35.35,0,0,1,175.53,93.37Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.76,96.54a4.84,4.84,0,0,1,0-2.39.35.35,0,0,1,.14-.25c.14-.09.32,0,.45.13,0-.22-.1-.43-.14-.65a1.29,1.29,0,0,1,0-.65.7.7,0,0,1,.45-.45.47.47,0,0,1,.55.26c.18-.13.38-.35.61-.37a.61.61,0,0,1,.55.22c.26.32.1.7,0,1a.44.44,0,0,1,.49.36.69.69,0,0,1-.21.62,2.17,2.17,0,0,1-.56.39c.27,0,.44.33.36.58a1.13,1.13,0,0,1-.54.58c-.38.23-.76.51-1.15.72a1.21,1.21,0,0,0-.39.28c-.05.07-.3.39-.26.47A5.78,5.78,0,0,1,171.76,96.54Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.94,95.63a1.63,1.63,0,0,1,.34-.19.45.45,0,0,1,.16,0c.19,0,.26.25.29.43a2.29,2.29,0,0,1,1.12-.64.82.82,0,0,1,.44,0,.57.57,0,0,1,.4.43.64.64,0,0,1-.16.58,1.32,1.32,0,0,1,1.25-.1.86.86,0,0,1,.4.33.47.47,0,0,1,0,.5.78.78,0,0,1-.24.16,3.61,3.61,0,0,1-1.09.33.28.28,0,0,1,.3.3.46.46,0,0,1-.29.38,2.91,2.91,0,0,1-1.06.17,8.32,8.32,0,0,1-1.12-.1,4.5,4.5,0,0,0-1,0c-.16,0-.89.11-.91.37a5.64,5.64,0,0,1,.72-2.36A1.78,1.78,0,0,1,172.94,95.63Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.94,95.63a1.63,1.63,0,0,1,.34-.19.45.45,0,0,1,.16,0c.19,0,.26.25.29.43a2.29,2.29,0,0,1,1.12-.64.82.82,0,0,1,.44,0,.57.57,0,0,1,.4.43.64.64,0,0,1-.16.58,1.32,1.32,0,0,1,1.25-.1.86.86,0,0,1,.4.33.47.47,0,0,1,0,.5.78.78,0,0,1-.24.16,3.61,3.61,0,0,1-1.09.33.28.28,0,0,1,.3.3.46.46,0,0,1-.29.38,2.91,2.91,0,0,1-1.06.17,8.32,8.32,0,0,1-1.12-.1,4.5,4.5,0,0,0-1,0c-.16,0-.89.11-.91.37a5.64,5.64,0,0,1,.72-2.36A1.78,1.78,0,0,1,172.94,95.63Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.62,96.55c0-.07,0-.13,0-.2a.85.85,0,0,0-.25-.55.35.35,0,0,0-.53.07,4.07,4.07,0,0,0-.26-1c-.08-.2-.22-.43-.45-.43a.43.43,0,0,0-.36.29,1.39,1.39,0,0,0,0,.5,2,2,0,0,0-1.18-.72.65.65,0,0,0-.63.17.49.49,0,0,0,0,.52,1.74,1.74,0,0,0,.35.42,9.85,9.85,0,0,1,.94,1,1.59,1.59,0,0,0-.78,0s-.08,0-.09.07a.12.12,0,0,0,0,.13,1.58,1.58,0,0,0,.9.64,5.55,5.55,0,0,1,1.35.84.91.91,0,0,0,.29.19c.46.13.56-.76.64-1A3.13,3.13,0,0,0,172.62,96.55Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.62,96.55c0-.07,0-.13,0-.2a.85.85,0,0,0-.25-.55.35.35,0,0,0-.53.07,4.07,4.07,0,0,0-.26-1c-.08-.2-.22-.43-.45-.43a.43.43,0,0,0-.36.29,1.39,1.39,0,0,0,0,.5,2,2,0,0,0-1.18-.72.65.65,0,0,0-.63.17.49.49,0,0,0,0,.52,1.74,1.74,0,0,0,.35.42,9.85,9.85,0,0,1,.94,1,1.59,1.59,0,0,0-.78,0s-.08,0-.09.07a.12.12,0,0,0,0,.13,1.58,1.58,0,0,0,.9.64,5.55,5.55,0,0,1,1.35.84.91.91,0,0,0,.29.19c.46.13.56-.76.64-1A3.13,3.13,0,0,0,172.62,96.55Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,97.21a.39.39,0,0,1,.15-.06,1.59,1.59,0,0,1,.89.09l-.5-.77a.33.33,0,0,1-.07-.31.26.26,0,0,1,.22-.12,1.59,1.59,0,0,1,1.27.52,1.76,1.76,0,0,1,.48-1.09.83.83,0,0,1,.38-.23.38.38,0,0,1,.39.13.51.51,0,0,1,.07.32c0,.15,0,.31,0,.46a1,1,0,0,0,0,.34c.17,0,.32-.15.48-.2a2.54,2.54,0,0,1,.55-.1c.19,0,.62,0,.66.26a.35.35,0,0,1-.16.27,5,5,0,0,1-.92.59c.27,0,.58-.09.81.06a.26.26,0,0,1,.11.14c0,.14-.11.25-.23.32a5.39,5.39,0,0,0-1.25.55l-.13.11-.49.46a5.19,5.19,0,0,1,1.24-.06,9.87,9.87,0,0,0,1.63,0,2.89,2.89,0,0,0,1.68-.56c.13-.12.16.13.09.21a2.73,2.73,0,0,1-1.11.82,5.11,5.11,0,0,1-1.39.27c-.59,0-1.18,0-1.76.07a1.64,1.64,0,0,0-.54.13c-.2.1-.36.25-.56.36s-.29,0-.34,0a0,0,0,0,1,0,0,3,3,0,0,0-.15-.84,1.93,1.93,0,0,0-.3-.65,11.8,11.8,0,0,0-1-1,.83.83,0,0,1-.19-.23A.24.24,0,0,1,170,97.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.34,107.25q.34,0,.69.06a4.51,4.51,0,0,0,1,.11.41.41,0,0,0,.32-.11c.07-.09,0-.27-.09-.28a4.18,4.18,0,0,0,1.32-.09c.08,0,.19-.08.18-.17a.22.22,0,0,0,0-.11,2,2,0,0,0-.85-.59,6.1,6.1,0,0,0,1-.29s.06,0,.07,0,0-.15-.08-.19a2.57,2.57,0,0,0-2.51-.32,5.16,5.16,0,0,0,1.69-1.49,1.57,1.57,0,0,0,.24-.62.85.85,0,0,0-.15-.64.76.76,0,0,0-.61-.29c-.07,0-.58.2-.55.3a.77.77,0,0,0-.85-.47,1.56,1.56,0,0,0-.88.53,4.43,4.43,0,0,0-1,1.86,6.78,6.78,0,0,0-.26,1.74,2.16,2.16,0,0,0,0,.84c.11.32.48.28.76.27A4.56,4.56,0,0,1,172.34,107.25Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.86,104.66a2.49,2.49,0,0,0-1.2-1.44.67.67,0,0,0-.64-.06.72.72,0,0,0-.22.71,1.37,1.37,0,0,0-1-.53c-.07,0-.17,0-.21.08a.29.29,0,0,0,0,.16,2.49,2.49,0,0,0,.14.44,1,1,0,0,0-.81-.16,1.29,1.29,0,0,0-.47.11.57.57,0,0,0-.29.37.54.54,0,0,0,.14.43,1.74,1.74,0,0,0,.36.3c.53.36,1,.76,1.59,1.07s1,.55,1.48.88c.25.18.49.37.75.53a.17.17,0,0,0,.1,0s.08,0,.1-.09A3.34,3.34,0,0,0,170.86,104.66Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.86,104.66a2.49,2.49,0,0,0-1.2-1.44.67.67,0,0,0-.64-.06.72.72,0,0,0-.22.71,1.37,1.37,0,0,0-1-.53c-.07,0-.17,0-.21.08a.29.29,0,0,0,0,.16,2.49,2.49,0,0,0,.14.44,1,1,0,0,0-.81-.16,1.29,1.29,0,0,0-.47.11.57.57,0,0,0-.29.37.54.54,0,0,0,.14.43,1.74,1.74,0,0,0,.36.3c.53.36,1,.76,1.59,1.07s1,.55,1.48.88c.25.18.49.37.75.53a.17.17,0,0,0,.1,0s.08,0,.1-.09A3.34,3.34,0,0,0,170.86,104.66Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.68,103a2.1,2.1,0,0,0,0-.79,1.86,1.86,0,0,0-.95-1.25.48.48,0,0,0-.35,0,.37.37,0,0,0-.24.31.94.94,0,0,0,0,.41,2.18,2.18,0,0,0-1.1-.84c-.17,0-.41,0-.47.12a.49.49,0,0,0,0,.17,2.83,2.83,0,0,0,.36.9c-.14-.11-.33-.23-.49-.15s-.17.31-.13.48c.19.87,1.14,1.34,1.56,2.13-.15,0-.37-.09-.44.06s.07.27.19.36a6,6,0,0,1,.72.7c.21.24.37.56.59.77a3.18,3.18,0,0,0,.31-.78,8.34,8.34,0,0,0,.26-.89A13.34,13.34,0,0,0,171.68,103Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,105.34l-1.43,1a7,7,0,0,0-1.33,1.16.39.39,0,0,1-.23.17c-.32.07-.29-.52-.3-.69a5.69,5.69,0,0,1,.68-2.88.55.55,0,0,1,.26-.28c.13,0,.3.07.26.19a2.32,2.32,0,0,1,.76-1.32c.1-.06.23-.11.32,0a.31.31,0,0,1,.1.32,1.54,1.54,0,0,1-.14.55,2.27,2.27,0,0,1,.48-.33.83.83,0,0,1,.51-.08.65.65,0,0,1,.38.79,1.91,1.91,0,0,1-.52.81c.18,0,.41-.06.51.09a.34.34,0,0,1,0,.36A1,1,0,0,1,174,105.34Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,105.34l-1.43,1a7,7,0,0,0-1.33,1.16.39.39,0,0,1-.23.17c-.32.07-.29-.52-.3-.69a5.69,5.69,0,0,1,.68-2.88.55.55,0,0,1,.26-.28c.13,0,.3.07.26.19a2.32,2.32,0,0,1,.76-1.32c.1-.06.23-.11.32,0a.31.31,0,0,1,.1.32,1.54,1.54,0,0,1-.14.55,2.27,2.27,0,0,1,.48-.33.83.83,0,0,1,.51-.08.65.65,0,0,1,.38.79,1.91,1.91,0,0,1-.52.81c.18,0,.41-.06.51.09a.34.34,0,0,1,0,.36A1,1,0,0,1,174,105.34Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.24,107.16a7.91,7.91,0,0,1,1.42,1.34c.79-.2,1.54-.53,2.34-.72.13,0,.29-.1.26-.23a.22.22,0,0,0-.13-.14,2.29,2.29,0,0,0-1.08-.31c.21-.38.79-.55.82-1a1.45,1.45,0,0,0-1,.11,4.47,4.47,0,0,0-.82.54,3.36,3.36,0,0,0-1.15-1.19.23.23,0,0,0-.21,0c-.12.06-.09.23,0,.34a7.68,7.68,0,0,0,.41.81,1.94,1.94,0,0,0-1.46-.47c-.1,0-.32.15-.26.28a.29.29,0,0,0,.13.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.38,84.54a.74.74,0,0,0,.2.23,1.68,1.68,0,0,1,.25.29.81.81,0,0,1,.1.18.71.71,0,0,1,0,.21,2.36,2.36,0,0,1,0,.46c.12,0,.24-.13.36-.19a3.08,3.08,0,0,1,1.21-.14,2,2,0,0,0,1.35-.55s0-.11,0-.09a2,2,0,0,1-1.39.21,5.19,5.19,0,0,0-.68-.05.46.46,0,0,1,.16-.07,6.49,6.49,0,0,0,.75-.23c.07,0,.14-.09.13-.16a.13.13,0,0,0-.06-.07c-.11-.08-.26,0-.4,0a3.24,3.24,0,0,0,.47-.28s.09-.08.09-.14-.23-.14-.33-.14a1.35,1.35,0,0,0-.28,0c-.08,0-.16.07-.24.09a.33.33,0,0,1,0-.17,1.69,1.69,0,0,0,0-.23.23.23,0,0,0,0-.16.22.22,0,0,0-.2-.08.39.39,0,0,0-.19.12.9.9,0,0,0-.27.53.79.79,0,0,0-.63-.28s-.09,0-.11.06,0,.11,0,.16l.24.39a.87.87,0,0,0-.45-.06s0,0-.07,0A.11.11,0,0,0,174.38,84.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.12,123.09a20.39,20.39,0,0,1,.7-2.74,17.34,17.34,0,0,1,1-2.58,8.82,8.82,0,0,1,1.47-2.25c.59-.6,1.81-.93,2.36-.1,0,0,0,.2-.07.14-1.45-1.34-2.91,1.82-3.34,2.79a19,19,0,0,0-.87,2.32c-.26.86-.44,1.74-.68,2.6s-.55,1.89-.72,2.87c0,0,0,0,0,0A7.24,7.24,0,0,1,170.12,123.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.6,123.36a2.29,2.29,0,0,0-.28.09,1.11,1.11,0,0,1-.25,0,1,1,0,0,1-.46-.08,1.08,1.08,0,0,1-.36-.24.91.91,0,0,1-.13-.16c-.07-.11-.1-.23-.17-.33a.14.14,0,0,0-.19-.06.38.38,0,0,0,0,.41,1,1,0,0,0,.19.32,1.6,1.6,0,0,0,.55.45,1.57,1.57,0,0,0,.71.16,1.86,1.86,0,0,0,.33,0,.63.63,0,0,0,.37-.19C171,123.59,170.76,123.35,170.6,123.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.11,122.53c-.06-.07-.2-.16-.29-.08s-.21,0-.26,0l-.4,0a2.1,2.1,0,0,1-.63-.24,1.77,1.77,0,0,1-.68-.85s-.07-.1-.13-.07-.07.15-.05.15,0,.26,0,.29a1.33,1.33,0,0,0,.11.24,1.23,1.23,0,0,0,.22.29,1.93,1.93,0,0,0,.57.41,2.48,2.48,0,0,0,.76.23,3,3,0,0,0,.42,0c.11,0,.25,0,.34-.06A.23.23,0,0,0,171.11,122.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.56,124.66c-.11-.08-.28-.13-.37,0h0s0,0,0,0H170l-.08,0a.76.76,0,0,1-.2-.06l-.15-.06-.05,0h0l0,0a.18.18,0,0,1-.07,0v0s0,0,0,0h0a.29.29,0,0,1,0-.09.3.3,0,0,0-.24-.22.16.16,0,0,0-.18.17.93.93,0,0,0,.25.57,1.26,1.26,0,0,0,.53.32c.29.11.7.22,1,0C170.74,124.91,170.66,124.73,170.56,124.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.89,122.42a2.62,2.62,0,0,0-.48.56,3.45,3.45,0,0,1-.51.5,2.06,2.06,0,0,1-.86.43,2.57,2.57,0,0,0-.27-.62,1.35,1.35,0,0,0-.73-.6,1,1,0,0,0-.44,0c-.22,0-.19.3-.16.46a1.39,1.39,0,0,0,.45.76,1.69,1.69,0,0,0,.41.29l0,0-.1,0c-.2.1-.39.22-.58.34a3.92,3.92,0,0,0-.93.84,1,1,0,0,0-.2.57.51.51,0,0,0,.44.53,1.36,1.36,0,0,0,1.1-.5,3.62,3.62,0,0,0,.76-1,.37.37,0,0,0,0-.11,2.9,2.9,0,0,1-.09,1.34,8.19,8.19,0,0,1-.82,1.51,2.88,2.88,0,0,0,0,3.24c.07.1.12-.06.1-.12a3.87,3.87,0,0,1-.13-1.66,4.08,4.08,0,0,1,.69-1.57,3.91,3.91,0,0,0,.62-1.47,3,3,0,0,0-.21-1.73.05.05,0,0,0,0,0,2.35,2.35,0,0,0,1.18-.5,3.64,3.64,0,0,0,.54-.57l.21-.3a1,1,0,0,0,.14-.41C171.11,122.5,171,122.34,170.89,122.42Zm-2.46,2.27a3.46,3.46,0,0,1-.75,1,1.58,1.58,0,0,1-.48.33.65.65,0,0,1-.2,0s0,0,0,0a1,1,0,0,1,.33-.52,4.73,4.73,0,0,1,.53-.46,4.35,4.35,0,0,1,.57-.38Zm.06-.84-.17-.1-.07,0,0,0,0,0-.11-.1,0,0h0l0,0-.07-.11a.25.25,0,0,1,0-.07s0,0,0,0h0l0-.13v0h.1s0,0,0,0H168s.07,0,0,0l.07,0,.06,0h0l0,0,.06,0h0l.05,0,0,0,0,0v0l0,0,0,.08,0,.08h0l0,0,.06.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.89,122.65a.71.71,0,0,0,.64-.23,2.83,2.83,0,0,0,.44-.59,5.1,5.1,0,0,0,.32-.71,1.52,1.52,0,0,0,.09-.73s0,0,0,0a1.12,1.12,0,0,0-.13.24c-.05.11-.09.21-.14.31a2.52,2.52,0,0,1-.33.6,3.15,3.15,0,0,1-.41.48,2.2,2.2,0,0,1-.25.17,1.55,1.55,0,0,1-.31.06c-.09,0-.11.14-.09.21A.27.27,0,0,0,168.89,122.65Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M172.27,118.35l0-.1-.72.1a21.13,21.13,0,0,0-.77,2c-.21.67-.4,1.36-.55,2.05h-.11l0,0c0-.3,0-.61,0-.92.05-.11.11-.22.15-.33a1.52,1.52,0,0,0,.09-.73s0,0,0,0a1.12,1.12,0,0,0-.13.24c0,.06-.05.11-.07.16,0-.36,0-.72,0-1.08s.15-.77.23-1.14a.36.36,0,0,0,0-.1c-.37,0-.74,0-1.12,0,0,.21,0,.43,0,.65,0-.22-.11-.44-.16-.65l-.53,0c.12.54.23,1.08.33,1.63-.15-.48-.32-1-.49-1.43l-.09-.22-.72-.07c.08.21.17.42.24.63.29.83.52,1.67.79,2.5a1,1,0,0,0,0,.19.75.75,0,0,0,.06.13c0,.14.08.28.13.42h-.11c-.09,0-.11.14-.09.21a.3.3,0,0,0,.15.18s-.05,0-.08,0a.38.38,0,0,0,0,.41,1,1,0,0,0,.19.32,1.83,1.83,0,0,0,.35.33.57.57,0,0,0,0,.13,2.34,2.34,0,0,1-.24.09,2.57,2.57,0,0,0-.27-.62,1.35,1.35,0,0,0-.73-.6,1,1,0,0,0-.44,0c-.22,0-.19.3-.16.46a1.39,1.39,0,0,0,.45.76,1.69,1.69,0,0,0,.41.29l0,0-.1,0c-.2.1-.39.22-.58.34a3.92,3.92,0,0,0-.93.84,1,1,0,0,0-.2.57.51.51,0,0,0,.44.53,1.36,1.36,0,0,0,1.1-.5,3.62,3.62,0,0,0,.76-1,.37.37,0,0,0,0-.11,2.9,2.9,0,0,1-.09,1.34,8.19,8.19,0,0,1-.82,1.51,2.88,2.88,0,0,0,0,3.24c.07.1.12-.06.1-.12a3.87,3.87,0,0,1-.13-1.66,4.08,4.08,0,0,1,.69-1.57,4,4,0,0,0,.62-1.47,3,3,0,0,0-.09-1.4h0a.49.49,0,0,0,.14.11c0,1,.06,2,.07,3.06,0,1.91,0,3.82,0,5.74,0,2.29,0,4.59-.06,6.88,0,.12.14.18.16,0a54.62,54.62,0,0,0,.42-5.71c.12,2.84.27,5.68.48,8.51,0,.22.38.18.36,0,0-.53-.07-1.05-.1-1.58-.28-4.24-.47-8.48-.54-12.72,0-1.09,0-2.17,0-3.26,0-.19.09-.39.14-.58a.55.55,0,0,0,.43-.17c.09-.11,0-.29-.09-.36a.44.44,0,0,0-.2-.08l.18-.66a.54.54,0,0,0,.34-.18c.08-.13,0-.3-.19-.35v0l.06-.06.21-.3s0-.08,0-.12a.2.2,0,0,0,.12-.06.23.23,0,0,0,0-.3l0,0a.16.16,0,0,0-.14-.1c.15-.57.29-1.15.46-1.73A19,19,0,0,1,172.27,118.35ZM169.12,123c-.07-.11-.1-.23-.17-.33s0,0,0,0H169l.12.41Zm-.69,1.67a3.46,3.46,0,0,1-.75,1,1.58,1.58,0,0,1-.48.33.65.65,0,0,1-.2,0s0,0,0,0a1,1,0,0,1,.32-.52,6,6,0,0,1,.54-.46,4.35,4.35,0,0,1,.57-.38Zm.06-.84-.17-.1-.07,0,0,0,0,0-.11-.1,0,0h0l0,0-.07-.11a.25.25,0,0,1,0-.07s0,0,0,0h0l0-.13v0h.1s0,0,0,0H168l.05,0,.07,0,.06,0h0l0,0,.06,0h0l.05,0,0,0,0,0v0l0,0,0,.08,0,.08h0l0,0,.06.22Zm1.63-.76,0,.1c0-.14,0-.27,0-.4h.07C170.16,122.9,170.13,123,170.12,123.09Z",
    style: {
      fill: "#FF725E",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Towels--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.61,160.83v3.76a1.67,1.67,0,0,0,.83,1.44l27,15.58a1.57,1.57,0,0,0,1.59.17l28.64-16.53a1.4,1.4,0,0,0,.59-1.27,4.67,4.67,0,0,0-2.18-3.62l-27.82-16.07Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.43,176.89l-27.82-16.06v3.76a1.67,1.67,0,0,0,.83,1.44l27,15.58c1.2.7,2.18.2,2.18-1.1A4.68,4.68,0,0,0,135.43,176.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.16,177.73a1.55,1.55,0,0,1,.72,1.21c0,.43-.32.59-.72.36L107.61,164V162.4Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.61,155.71v3.76a1.67,1.67,0,0,0,.83,1.44l27,15.58a1.6,1.6,0,0,0,1.59.17l28.64-16.53a1.4,1.4,0,0,0,.59-1.27,4.67,4.67,0,0,0-2.18-3.62l-27.82-16.07Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.43,171.77l-27.82-16.06v3.76a1.67,1.67,0,0,0,.83,1.44l27,15.58c1.2.7,2.18.2,2.18-1.1A4.67,4.67,0,0,0,135.43,171.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.16,172.61a1.55,1.55,0,0,1,.72,1.2c0,.44-.32.6-.72.37l-26.55-15.32v-1.58Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.61,150.26V154a1.65,1.65,0,0,0,.83,1.43l27,15.59a1.6,1.6,0,0,0,1.59.17l28.64-16.54a1.39,1.39,0,0,0,.59-1.27,4.7,4.7,0,0,0-2.18-3.62l-27.82-16.06Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.25,134,164,150a4.45,4.45,0,0,1,2.08,3.44,1.19,1.19,0,0,1-.48,1.09L136.92,171a.89.89,0,0,1-.47.12,1.92,1.92,0,0,1-.92-.29l-27-15.58a1.47,1.47,0,0,1-.72-1.26v-3.65L136.25,134m0-.24-28.64,16.53V154a1.65,1.65,0,0,0,.83,1.43l27,15.59a2.12,2.12,0,0,0,1,.31,1.15,1.15,0,0,0,.57-.14l28.64-16.54a1.39,1.39,0,0,0,.59-1.27,4.7,4.7,0,0,0-2.18-3.62l-27.82-16.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.43,166.32l-27.82-16.06V154a1.65,1.65,0,0,0,.83,1.43l27,15.59c1.2.69,2.18.2,2.18-1.11A4.7,4.7,0,0,0,135.43,166.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.16,167.16a1.58,1.58,0,0,1,.72,1.21c0,.44-.32.6-.72.37l-26.55-15.33v-1.57Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.25,138.93l-28.64,16.55,2.24,1.29,28.63-16.55Z",
    style: {
      fill: "#FF725E"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-3",
    cx: 87.2,
    cy: 186.87,
    rx: 12.59,
    ry: 7.27,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-3",
    d: "M107.68,182.52c4.92,2.84,4.92,7.44,0,10.28s-12.88,2.84-17.8,0-4.92-7.44,0-10.28S102.77,179.68,107.68,182.52Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Candle--inject-3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 98.78,
    cy: 175.83,
    rx: 11.05,
    ry: 6.38,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 98.78,
    cy: 175.83,
    rx: 11.05,
    ry: 6.38,
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--candle--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.74,162.31c0-1.44-1-2.89-2.88-4a15.36,15.36,0,0,0-13.91,0c-1.91,1.1-2.87,2.55-2.88,4h0V182c0,1.44,1,2.88,2.88,4a15.55,15.55,0,0,0,13.91,0,6.68,6.68,0,0,0,2.17-1.86,3.63,3.63,0,0,0,.72-2.12V162.31Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.74,162.31c0-1.44-1-2.89-2.88-4a15.36,15.36,0,0,0-13.91,0c-1.91,1.1-2.87,2.55-2.88,4h0V182c0,1.44,1,2.88,2.88,4a15.55,15.55,0,0,0,13.91,0,6.68,6.68,0,0,0,2.17-1.86,3.63,3.63,0,0,0,.72-2.12V162.31Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.86,158.32c3.85,2.22,3.85,5.82,0,8a15.36,15.36,0,0,1-13.91,0c-3.84-2.21-3.84-5.81,0-8A15.36,15.36,0,0,1,105.86,158.32Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.86,158.32c3.85,2.22,3.85,5.82,0,8a15.36,15.36,0,0,1-13.91,0c-3.84-2.21-3.84-5.81,0-8A15.36,15.36,0,0,1,105.86,158.32Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.62,162.7a4.57,4.57,0,0,0-2.53-3.2,13.66,13.66,0,0,0-12.36,0,4.53,4.53,0,0,0-2.53,3.21c-.18-1.42.66-2.86,2.53-3.94a13.66,13.66,0,0,1,12.36,0C107,159.85,107.79,161.29,107.62,162.7Z",
    style: {
      fill: "#FF725E",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.09,159.5a13.66,13.66,0,0,0-12.36,0,4.58,4.58,0,0,0-2.54,3.2,4.59,4.59,0,0,0,2.54,3.21,13.66,13.66,0,0,0,12.36,0,4.58,4.58,0,0,0,2.53-3.21A4.56,4.56,0,0,0,105.09,159.5Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.23,162.67c-1,0-2-.45-3-2s-2.3-2.89-4.32-2.89-3.29,1.3-4.33,2.89-2,2-3,2c0,0,.74,3.23,7.29,3.23S106.23,162.67,106.23,162.67Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.23,162.67c-1,0-2-.45-3-2s-2.3-2.89-4.32-2.89-3.29,1.3-4.33,2.89-2,2-3,2c0,0,.74,3.23,7.29,3.23S106.23,162.67,106.23,162.67Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.5,159.53a7.08,7.08,0,0,0-2.07-1.62,3.81,3.81,0,0,0-2-.27,4.62,4.62,0,0,0-2.08.83,9.57,9.57,0,0,0-1.76,1.94c-.29.38-.58.77-.9,1.13a3.8,3.8,0,0,1-.47.43c-.18.13-.38.21-.56.33,0,0,0,.1,0,.11.66.09,1.24-.55,1.61-1,.56-.68,1.07-1.41,1.66-2.05A4.14,4.14,0,0,1,99.79,158a6.32,6.32,0,0,1,2.69,1.56S102.51,159.55,102.5,159.53Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.5,159.53a7.08,7.08,0,0,0-2.07-1.62,3.81,3.81,0,0,0-2-.27,4.62,4.62,0,0,0-2.08.83,9.57,9.57,0,0,0-1.76,1.94c-.29.38-.58.77-.9,1.13a3.8,3.8,0,0,1-.47.43c-.18.13-.38.21-.56.33,0,0,0,.1,0,.11.66.09,1.24-.55,1.61-1,.56-.68,1.07-1.41,1.66-2.05A4.14,4.14,0,0,1,99.79,158a6.32,6.32,0,0,1,2.69,1.56S102.51,159.55,102.5,159.53Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.94,159.61a2.27,2.27,0,0,1-2.06,0c-.58-.32-.58-.85,0-1.18a2.33,2.33,0,0,1,2.06,0C100.51,158.76,100.51,159.29,99.94,159.61Z",
    style: {
      fill: "#FF725E",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Flame--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99,156.05c1.49-.11,2.57-1.75,1.53-4.06s-1.68-3.55-1.3-5.87a14.39,14.39,0,0,0-1.73,3.45,12.86,12.86,0,0,0-.79,3.32C96.52,155,97.57,156.05,99,156.05Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,156.05c1.49-.11,2.57-1.75,1.53-4.06s-1.68-3.55-1.3-5.87a14.39,14.39,0,0,0-1.73,3.45,12.86,12.86,0,0,0-.79,3.32C96.52,155,97.57,156.05,99,156.05Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,155.91c.48,0,1-.61,1.2-1.06a3.13,3.13,0,0,0-.17-2.63l-.16-.36a12.85,12.85,0,0,1-1.22-3.52,14.23,14.23,0,0,0-.59,1.42,12.16,12.16,0,0,0-.76,3.18,2.89,2.89,0,0,0,.45,2.13A2.18,2.18,0,0,0,99,155.91Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,155.84a1.49,1.49,0,0,0,.58-1.56c-.14-.75-.86-1.74-.86-2.07a6.06,6.06,0,0,0-.68,1.95A1.55,1.55,0,0,0,99,155.84Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,155.84a1.49,1.49,0,0,0,.58-1.56c-.14-.75-.86-1.74-.86-2.07a6.06,6.06,0,0,0-.68,1.95A1.55,1.55,0,0,0,99,155.84Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,159.31a.41.41,0,0,0,.33-.27,1.37,1.37,0,0,0,.11-.36,2.59,2.59,0,0,0,.07-.73,4.18,4.18,0,0,0-.07-.72c0-.23-.09-.46-.14-.69-.1-.45-.22-.88-.29-1.33a6.72,6.72,0,0,1-.06-1.35h0a5.79,5.79,0,0,0-.16,1.38c0,.47.07.94.12,1.39,0,.22.05.44.06.67a4.56,4.56,0,0,1,0,.64c0,.22,0,.42-.08.63s0,.21-.06.3a.41.41,0,0,0,.07.37Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--jar--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108,179.37a7.73,7.73,0,0,1-1.37,1,13.74,13.74,0,0,1-4.86,1.62,18.44,18.44,0,0,1-5.93,0,6.19,6.19,0,0,1-.94-.17,10.68,10.68,0,0,1-1.59-.44,12.31,12.31,0,0,1-2.32-1A8.2,8.2,0,0,1,89.21,179a4.49,4.49,0,0,1-1.48-3.18v10.62a4.47,4.47,0,0,0,1.38,3.06l-.11-.1a1,1,0,0,0,.21.21l.19.21c.09.07.17.16.27.23a2.39,2.39,0,0,0,.33.25.83.83,0,0,0,.21.16l.25.17.5.32c.33.18.66.35,1,.51h0a8.63,8.63,0,0,0,1.31.5c.52.17,1,.32,1.59.44a18.54,18.54,0,0,0,7.53.06h0l.1,0c.29-.07.59-.13.88-.21l.19,0a6.31,6.31,0,0,0,.87-.28l.18-.05c.33-.12.66-.26,1-.4s.66-.32,1-.49c2.16-1.24,3.23-2.88,3.23-4.51V176.14A4.9,4.9,0,0,1,108,179.37Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,179.37a7.73,7.73,0,0,1-1.37,1,13.74,13.74,0,0,1-4.86,1.62,18.44,18.44,0,0,1-5.93,0,6.19,6.19,0,0,1-.94-.17,10.68,10.68,0,0,1-1.59-.44,12.31,12.31,0,0,1-2.32-1A8.2,8.2,0,0,1,89.21,179a4.49,4.49,0,0,1-1.48-3.18v10.62a4.47,4.47,0,0,0,1.38,3.06l-.11-.1a1,1,0,0,0,.21.21l.19.21c.09.07.17.16.27.23a2.39,2.39,0,0,0,.33.25.83.83,0,0,0,.21.16l.25.17.5.32c.33.18.66.35,1,.51h0a8.63,8.63,0,0,0,1.31.5c.52.17,1,.32,1.59.44a18.54,18.54,0,0,0,7.53.06h0l.1,0c.29-.07.59-.13.88-.21l.19,0a6.31,6.31,0,0,0,.87-.28l.18-.05c.33-.12.66-.26,1-.4s.66-.32,1-.49c2.16-1.24,3.23-2.88,3.23-4.51V176.14A4.9,4.9,0,0,1,108,179.37Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,180.85v10.62h0c-.34-.16-.67-.33-1-.51l-.5-.32-.46-.33a7.81,7.81,0,0,1-.79-.69V179A8.2,8.2,0,0,0,91,180.34,8.68,8.68,0,0,0,92,180.85Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.28,181.35a10.68,10.68,0,0,0,1.59.44v10.62c-.54-.12-1.07-.27-1.59-.44Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.83,176.14v10.31c0,1.63-1.07,3.27-3.23,4.51-.3.17-.63.34-1,.49s-.65.28-1,.4l-.18.05a6.31,6.31,0,0,1-.87.28l-.19,0c-.29.08-.59.14-.88.21l-.1,0h0a18.54,18.54,0,0,1-7.53-.06c-.54-.12-1.07-.27-1.59-.44a8.63,8.63,0,0,1-1.31-.5h0c-.34-.16-.67-.33-1-.51l-.5-.32-.25-.17a.83.83,0,0,1-.21-.16,2.39,2.39,0,0,1-.33-.25c-.1-.07-.18-.16-.27-.23l-.19-.21a1,1,0,0,1-.21-.21l.11.1.1.09A8.5,8.5,0,0,0,92,191a11,11,0,0,0,1.31.37c.51.13,1,.23,1.59.32a18.31,18.31,0,0,0,2.44.17,14.21,14.21,0,0,0,2.66-.25c3.8-.74,6.11-3.17,6.11-4.9V182.5c-.31.13-.61.27-.93.38a19.31,19.31,0,0,1-10.28.71,16.09,16.09,0,0,1-1.59-.41,6.07,6.07,0,0,1-.88-.3,3.2,3.2,0,0,1-.43-.17,11.27,11.27,0,0,1-1.48-.72,9.24,9.24,0,0,1-1.28-.88,6.34,6.34,0,0,1-1.48-1.67v-3.61A4.49,4.49,0,0,0,89.21,179,8.2,8.2,0,0,0,91,180.34a12.31,12.31,0,0,0,2.32,1,10.68,10.68,0,0,0,1.59.44,6.19,6.19,0,0,0,.94.17,18.44,18.44,0,0,0,5.93,0,13.74,13.74,0,0,0,4.86-1.62,7.73,7.73,0,0,0,1.37-1A4.9,4.9,0,0,0,109.83,176.14Z",
    style: {
      fill: "#FF725E",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.83,176.14v10.31c0,1.63-1.07,3.27-3.23,4.51-.3.17-.63.34-1,.49s-.65.28-1,.4l-.18.05a6.31,6.31,0,0,1-.87.28l-.19,0c-.29.08-.59.14-.88.21a8.65,8.65,0,0,0,4-2.32,4.64,4.64,0,0,0,1.43-2.88v-7.87A4.9,4.9,0,0,0,109.83,176.14Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.54,190.12a5.45,5.45,0,0,1-.58.33,17.28,17.28,0,0,1-8.65,1.44,16.11,16.11,0,0,1-2.44-.34,13.74,13.74,0,0,1-1.59-.42,11.89,11.89,0,0,1-1.31-.51l-.37-.17a6.18,6.18,0,0,1-2.39-1.92,2.75,2.75,0,0,1,0-3.38,6.08,6.08,0,0,1,2.39-1.91l.37-.17.43-.19c.28-.11.57-.22.88-.32a13.71,13.71,0,0,1,1.59-.41c.31-.08.63-.14.94-.19a18.44,18.44,0,0,0,5.93,0,15.5,15.5,0,0,1,3.41.92q.42.17.81.36s.08,0,.12.08a6.35,6.35,0,0,1,1.89,1.36C109.62,186.45,109.15,188.58,106.54,190.12Z",
    style: {
      fill: "#FF725E",
      opacity: 0.30000000000000004
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--candle--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.19,193.25a17.29,17.29,0,0,1-15.63,0c-4.32-2.49-4.32-6.53,0-9a17.29,17.29,0,0,1,15.63,0C92.51,186.72,92.51,190.76,88.19,193.25Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.19,193.25a17.29,17.29,0,0,1-15.63,0c-4.32-2.49-4.32-6.53,0-9a17.29,17.29,0,0,1,15.63,0C92.51,186.72,92.51,190.76,88.19,193.25Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--candle--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.34,184c0-1.45-1-2.89-2.88-4a15.36,15.36,0,0,0-13.91,0c-1.91,1.1-2.87,2.54-2.88,4h0V195c0,1.44,1,2.87,2.89,4a15.48,15.48,0,0,0,13.91,0,6.62,6.62,0,0,0,2.16-1.86,3.61,3.61,0,0,0,.72-2.11V184Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.34,184c0-1.45-1-2.89-2.88-4a15.36,15.36,0,0,0-13.91,0c-1.91,1.1-2.87,2.54-2.88,4h0V195c0,1.44,1,2.87,2.89,4a15.48,15.48,0,0,0,13.91,0,6.62,6.62,0,0,0,2.16-1.86,3.61,3.61,0,0,0,.72-2.11V184Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.5,
    cy: 184.04,
    rx: 9.84,
    ry: 5.68,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.5,
    cy: 184.04,
    rx: 9.84,
    ry: 5.68,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.21,184.39a4.55,4.55,0,0,0-2.53-3.19,13.66,13.66,0,0,0-12.36,0,4.54,4.54,0,0,0-2.53,3.2c-.18-1.41.67-2.85,2.53-3.93a13.66,13.66,0,0,1,12.36,0C88.55,181.55,89.39,183,89.21,184.39Z",
    style: {
      fill: "#FF725E",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.68,181.2a13.66,13.66,0,0,0-12.36,0,3.29,3.29,0,0,0,0,6.4,13.66,13.66,0,0,0,12.36,0,4.56,4.56,0,0,0,2.54-3.2A4.56,4.56,0,0,0,86.68,181.2Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.83,184.37c-1,0-2-.46-3-2.05s-2.31-2.89-4.33-2.89-3.28,1.3-4.32,2.89-2,2.05-3,2.05c0,0,.73,3.23,7.28,3.23S87.83,184.37,87.83,184.37Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.83,184.37c-1,0-2-.46-3-2.05s-2.31-2.89-4.33-2.89-3.28,1.3-4.32,2.89-2,2.05-3,2.05c0,0,.73,3.23,7.28,3.23S87.83,184.37,87.83,184.37Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.09,181.23A7.08,7.08,0,0,0,82,179.61a3.8,3.8,0,0,0-2-.27,4.55,4.55,0,0,0-2.08.83,9.24,9.24,0,0,0-1.75,1.94c-.3.38-.58.77-.91,1.13a3.2,3.2,0,0,1-.47.43c-.18.13-.37.21-.55.33s0,.1,0,.1c.65.09,1.24-.55,1.61-1,.56-.68,1.06-1.41,1.66-2.06a4.19,4.19,0,0,1,3.87-1.34,6.4,6.4,0,0,1,2.69,1.57S84.1,181.24,84.09,181.23Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.09,181.23A7.08,7.08,0,0,0,82,179.61a3.8,3.8,0,0,0-2-.27,4.55,4.55,0,0,0-2.08.83,9.24,9.24,0,0,0-1.75,1.94c-.3.38-.58.77-.91,1.13a3.2,3.2,0,0,1-.47.43c-.18.13-.37.21-.55.33s0,.1,0,.1c.65.09,1.24-.55,1.61-1,.56-.68,1.06-1.41,1.66-2.06a4.19,4.19,0,0,1,3.87-1.34,6.4,6.4,0,0,1,2.69,1.57S84.1,181.24,84.09,181.23Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.54,181.31a2.29,2.29,0,0,1-2.07,0c-.57-.33-.57-.85,0-1.18a2.29,2.29,0,0,1,2.07,0C82.11,180.46,82.11,181,81.54,181.31Z",
    style: {
      fill: "#FF725E",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--flame--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.57,177.75c1.48-.11,2.57-1.75,1.53-4.06s-1.69-3.55-1.3-5.87a13.72,13.72,0,0,0-1.73,3.45,12.45,12.45,0,0,0-.8,3.32C78.11,176.71,79.16,177.75,80.57,177.75Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.57,177.75c1.48-.11,2.57-1.75,1.53-4.06s-1.69-3.55-1.3-5.87a13.72,13.72,0,0,0-1.73,3.45,12.45,12.45,0,0,0-.8,3.32C78.11,176.71,79.16,177.75,80.57,177.75Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.55,177.61c.47,0,1-.61,1.2-1.07a3.14,3.14,0,0,0-.17-2.62l-.17-.37A13.14,13.14,0,0,1,80.19,170c-.19.41-.39.88-.58,1.42a12.09,12.09,0,0,0-.77,3.17,2.92,2.92,0,0,0,.45,2.14A2.27,2.27,0,0,0,80.55,177.61Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.62,177.53a1.46,1.46,0,0,0,.57-1.55c-.14-.75-.86-1.74-.86-2.07a6.06,6.06,0,0,0-.68,2A1.54,1.54,0,0,0,80.62,177.53Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.62,177.53a1.46,1.46,0,0,0,.57-1.55c-.14-.75-.86-1.74-.86-2.07a6.06,6.06,0,0,0-.68,2A1.54,1.54,0,0,0,80.62,177.53Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.57,181a.4.4,0,0,0,.33-.27,2.53,2.53,0,0,0,.12-.36,2.59,2.59,0,0,0,.07-.73,5.82,5.82,0,0,0-.08-.73c0-.23-.08-.45-.13-.68-.1-.45-.22-.89-.29-1.33a6.09,6.09,0,0,1-.07-1.35h0a5.78,5.78,0,0,0-.15,1.38,12.43,12.43,0,0,0,.11,1.38c0,.23,0,.45.06.68a3.43,3.43,0,0,1,0,.64q0,.31-.09.63c0,.1,0,.2-.06.3a.49.49,0,0,0,.07.37Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--jar--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.56,192.27a7.76,7.76,0,0,1-1.37,1,14.15,14.15,0,0,1-4.86,1.62,18.37,18.37,0,0,1-5.92,0,9.2,9.2,0,0,1-.94-.17,11.77,11.77,0,0,1-1.6-.44,8.13,8.13,0,0,1-1.3-.5,10.57,10.57,0,0,1-1-.51,8,8,0,0,1-1.76-1.33,4.5,4.5,0,0,1-1.48-3.18v10.62a4.47,4.47,0,0,0,1.38,3.06,1.09,1.09,0,0,0-.11-.1l.21.21.19.2.27.24a3.59,3.59,0,0,0,.33.25,1.66,1.66,0,0,0,.21.16l.26.17a4.78,4.78,0,0,0,.5.32q.48.27,1,.51h0a10.61,10.61,0,0,0,1.3.5c.53.17,1,.32,1.6.44a18.67,18.67,0,0,0,7.52.06H84l.1,0c.29-.06.58-.12.87-.21l.2,0a8.63,8.63,0,0,0,.86-.28l.19-.05c.33-.12.65-.26,1-.41a9.55,9.55,0,0,0,1-.48c2.16-1.25,3.24-2.88,3.24-4.51V189A4.83,4.83,0,0,1,89.56,192.27Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.56,192.27a7.76,7.76,0,0,1-1.37,1,14.15,14.15,0,0,1-4.86,1.62,18.37,18.37,0,0,1-5.92,0,9.2,9.2,0,0,1-.94-.17,11.77,11.77,0,0,1-1.6-.44,8.13,8.13,0,0,1-1.3-.5,10.57,10.57,0,0,1-1-.51,8,8,0,0,1-1.76-1.33,4.5,4.5,0,0,1-1.48-3.18v10.62a4.47,4.47,0,0,0,1.38,3.06,1.09,1.09,0,0,0-.11-.1l.21.21.19.2.27.24a3.59,3.59,0,0,0,.33.25,1.66,1.66,0,0,0,.21.16l.26.17a4.78,4.78,0,0,0,.5.32q.48.27,1,.51h0a10.61,10.61,0,0,0,1.3.5c.53.17,1,.32,1.6.44a18.67,18.67,0,0,0,7.52.06H84l.1,0c.29-.06.58-.12.87-.21l.2,0a8.63,8.63,0,0,0,.86-.28l.19-.05c.33-.12.65-.26,1-.41a9.55,9.55,0,0,0,1-.48c2.16-1.25,3.24-2.88,3.24-4.51V189A4.83,4.83,0,0,1,89.56,192.27Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.57,193.76v10.62h0q-.51-.24-1-.51a4.78,4.78,0,0,1-.5-.32l-.47-.33a7.81,7.81,0,0,1-.79-.69V191.92a8,8,0,0,0,1.76,1.33A10.57,10.57,0,0,0,73.57,193.76Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.87,194.26a11.77,11.77,0,0,0,1.6.44v10.62c-.55-.12-1.07-.27-1.6-.44Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.43,189v10.32c0,1.63-1.08,3.26-3.24,4.51a9.55,9.55,0,0,1-1,.48c-.32.15-.64.29-1,.41l-.19.05a8.63,8.63,0,0,1-.86.28l-.2,0c-.29.09-.58.15-.87.21l-.1,0H84a18.67,18.67,0,0,1-7.52-.06c-.55-.12-1.07-.27-1.6-.44a10.61,10.61,0,0,1-1.3-.5h0q-.51-.24-1-.51a4.78,4.78,0,0,1-.5-.32l-.26-.17a1.66,1.66,0,0,1-.21-.16,3.59,3.59,0,0,1-.33-.25l-.27-.24-.19-.2-.21-.21a1.09,1.09,0,0,1,.11.1.87.87,0,0,0,.1.08,8.77,8.77,0,0,0,2.77,1.44,10.32,10.32,0,0,0,1.3.37,15.62,15.62,0,0,0,1.6.31,18.08,18.08,0,0,0,2.44.17,14.2,14.2,0,0,0,2.65-.24c3.81-.74,6.11-3.17,6.11-4.9v-4.24a9.47,9.47,0,0,1-.93.37,19.18,19.18,0,0,1-10.27.71,15.58,15.58,0,0,1-1.6-.4,6.55,6.55,0,0,1-.88-.31,1.68,1.68,0,0,1-.42-.17,10.79,10.79,0,0,1-1.49-.71A12.39,12.39,0,0,1,70.8,194a7.08,7.08,0,0,1-1.48-1.67v-3.61a4.5,4.5,0,0,0,1.48,3.18,8,8,0,0,0,1.76,1.33,10.57,10.57,0,0,0,1,.51,8.13,8.13,0,0,0,1.3.5,11.77,11.77,0,0,0,1.6.44,9.2,9.2,0,0,0,.94.17,18.37,18.37,0,0,0,5.92,0,14.15,14.15,0,0,0,4.86-1.62,7.76,7.76,0,0,0,1.37-1A4.83,4.83,0,0,0,91.43,189Z",
    style: {
      fill: "#FF725E",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.43,189v10.32c0,1.63-1.08,3.26-3.24,4.51a9.55,9.55,0,0,1-1,.48c-.32.15-.64.29-1,.41l-.19.05a8.63,8.63,0,0,1-.86.28l-.2,0c-.29.09-.58.15-.87.21a8.57,8.57,0,0,0,4-2.31,4.61,4.61,0,0,0,1.43-2.88v-7.88A4.83,4.83,0,0,0,91.43,189Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.13,203a4.61,4.61,0,0,1-.58.33,17.11,17.11,0,0,1-8.64,1.43,16.11,16.11,0,0,1-2.44-.34,13.37,13.37,0,0,1-1.6-.41,11.72,11.72,0,0,1-1.3-.51,3.34,3.34,0,0,1-.38-.17,6.27,6.27,0,0,1-2.39-1.92,2.76,2.76,0,0,1,0-3.39,6.15,6.15,0,0,1,2.39-1.9,3.34,3.34,0,0,1,.38-.17l.42-.2.88-.31a13.39,13.39,0,0,1,1.6-.42c.3-.07.62-.13.94-.18a18.37,18.37,0,0,0,5.92,0,15.91,15.91,0,0,1,3.41.91c.28.11.55.24.81.37l.12.07a6.41,6.41,0,0,1,1.89,1.37C91.22,199.36,90.74,201.49,88.13,203Z",
    style: {
      fill: "#FF725E",
      opacity: 0.30000000000000004
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-3",
    cx: 408.28,
    cy: 323.44,
    rx: 62.38,
    ry: 36.02,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-3",
    d: "M309.23,399.72c-23.42,13.52-23.42,35.45,0,49s61.4,13.52,84.82,0,23.43-35.45,0-49S332.66,386.19,309.23,399.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-3",
    points: "175.89 476.43 92.3 428.17 338.89 285.81 422.47 334.07 175.89 476.43",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-3",
    d: "M47.94,391.3c-11.92,6.88-11.92,18,0,24.93s31.25,6.88,43.17,0,11.92-18.05,0-24.93S59.86,384.42,47.94,391.3Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.08,405c-9.57-9.87-15.19-46.37-5.85-54.2H93.71c9.33,7.83,3.72,44.31-5.85,54.19l-.26.27-.33.33c-.27.26-.56.52-.86.78l-.23.18c-.24.18-.47.37-.72.55a13,13,0,0,1-1.24.8c-7.87,4.59-20.63,4.59-28.5,0h0a13.26,13.26,0,0,1-1.25-.81c-.24-.16-.45-.34-.67-.51l-.28-.22q-.45-.37-.84-.75l-.38-.38Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.59,347.66c10.83,6.33,10.83,16.59,0,22.91s-28.4,6.33-39.24,0-10.83-16.58,0-22.9S78.75,341.34,89.59,347.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.38,350.71c8,4.64,8,12.17,0,16.82s-20.86,4.64-28.82,0-8-12.18,0-16.82S76.42,346.06,84.38,350.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.56,358.69c8-4.64,20.86-4.64,28.82,0a13.25,13.25,0,0,1,4.76,4.42,13.25,13.25,0,0,1-4.76,4.42c-8,4.64-20.86,4.64-28.82,0a13.25,13.25,0,0,1-4.76-4.42A13.25,13.25,0,0,1,55.56,358.69Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M54.87,266a4.54,4.54,0,0,1,0-.77c0-.26,0-.53-.08-.79-.06-.53-.14-1.06-.24-1.58-.2-1.05-.47-2.09-.77-3.11a2.18,2.18,0,0,0-.18-.6l-.2-.6c-.13-.41-.27-.81-.4-1.22l-.61-1.74a12.81,12.81,0,0,1-.55-1.69,3,3,0,0,0-.17-.65,1.42,1.42,0,0,1-.1-.29c-.07-.28-.11-.57-.18-.85-.12-.57-.25-1.14-.4-1.7a34.45,34.45,0,0,0-1.06-3.31c-.32-.86-.67-1.71-1-2.54A8.83,8.83,0,0,0,46,240.7a1.18,1.18,0,0,0-1.15-.22c-.39.2-.47.72-.5,1.16q-.24,3.72-.5,7.44a22,22,0,0,0,0,4.59,11,11,0,0,0,2.55,5.6,21.7,21.7,0,0,0,3,2.73c.81.65,1.64,1.27,2.42,1.95A10.6,10.6,0,0,0,54.87,266Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5,250.35c-.06-.36-.13-.71-.22-1.06a7.32,7.32,0,0,0-.92-2.15c-.2-.33-.31-.71-.5-1a3.78,3.78,0,0,0-.76-.93,1.49,1.49,0,0,0-.64-.35.67.67,0,0,0-.66.2,1.08,1.08,0,0,0-.18.59,20.51,20.51,0,0,1-.78,3.94,12.92,12.92,0,0,1-.68,1.89,3.45,3.45,0,0,1-.35.5,1.68,1.68,0,0,0-.21.37,12.11,12.11,0,0,1-1,1.78,10.23,10.23,0,0,1-1,1.18c-1.15,1.16-2.6,2-3.48,3.43-1.31,2.07-1.09,4.73-1.14,7.07,0,.4,0,.81,0,1.21,0,3.22-.52,6,.31,9.17.06.22.29.77.63.56l.36-.24c1.78-1.27,2.78-3.37,3.6-5.33.22-.53.42-1.06.63-1.59a4.39,4.39,0,0,1,.76-1,36.65,36.65,0,0,0,2.12-3.23,32.06,32.06,0,0,0,3.42-6.92,18,18,0,0,0,.95-5.54A14,14,0,0,0,69.5,250.35Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2,275.71c.61,0,1.23.05,1.84.06,1.25,0,2.5,0,3.75,0,.63,0,1.25,0,1.88,0,.22,0,.42-.05.64,0a5.53,5.53,0,0,0,.91,0,.34.34,0,0,0,.17-.05.32.32,0,0,0,.09-.27,5.22,5.22,0,0,0-.6-2.48,5.37,5.37,0,0,0-.71-1.07,10,10,0,0,0-3.23-2.54,16.94,16.94,0,0,0-3.78-1.11L38,266c-.47-.1-1-.17-1.36.19a1.22,1.22,0,0,0-.25.74,7.53,7.53,0,0,0,3.47,6.59A14.59,14.59,0,0,0,47.2,275.71Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.41,288.25a6.19,6.19,0,0,0-1.2-1.5,7.86,7.86,0,0,0-2.39-1.59,26.5,26.5,0,0,0-4.61-1.36,54.51,54.51,0,0,1-10.46-3.73,1.41,1.41,0,0,0-.71-.2c-.6.06-.84.8-.87,1.4a8.68,8.68,0,0,0,4.58,8c2.81,1.46,6.16,1.23,9.34,1.12h.13a26.15,26.15,0,0,1,3.43.06,13.36,13.36,0,0,1,1.68.27c.47.1,1.32.61,1.62,0a1.26,1.26,0,0,0,0-.72,5.66,5.66,0,0,0-.57-1.68Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.87,289.15a2.3,2.3,0,0,1-.47.35.88.88,0,0,1-.41.12.58.58,0,0,1-.52-.27,2.38,2.38,0,0,1-.18-.3,4.76,4.76,0,0,1-.29-.65,8,8,0,0,1-.34-1.38c0-.11,0-.22,0-.33-.07-.53-.11-1.06-.17-1.59,0-.26-.05-.53-.09-.8a1.63,1.63,0,0,1,0-.58,4.48,4.48,0,0,0,0-1,7.86,7.86,0,0,1,0-1.19c.3-3.52,2.86-6.34,5-9.17a44,44,0,0,0,4.85-8.24c.29-.65.76-1.42,1.46-1.31s.85.68,1,1.22a18.63,18.63,0,0,1-.29,11.71,25.85,25.85,0,0,1-3.22,6.3,33,33,0,0,1-2.17,2.82c-.23.27-.44.54-.68.8-.73.78-1.47,1.56-2.23,2.32l-.93.93Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.41,298.87a29.41,29.41,0,0,0-7.24-1.43,16.81,16.81,0,0,1-7-2.1,1.3,1.3,0,0,0-.72-.29c-.51,0-.77.61-.84,1.12a7,7,0,0,0,1.17,4.33,13,13,0,0,0,12.94,5.9h0c1.6-.27,3.14-.84,4.76-1a7.85,7.85,0,0,1,1.19,0c.25,0,.66.17.86-.05.43-.46-.08-1.08-.19-1.54a5.22,5.22,0,0,0-.7-1.56,8.26,8.26,0,0,0-2.47-2.42A10.56,10.56,0,0,0,55.41,298.87Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.56,313.31c-2.43-.61-5-.73-7.36-1.58-1.06-.38-2.06-.89-3.1-1.32-.3-.12-.67-.21-.89,0a.84.84,0,0,0-.16.54,8.23,8.23,0,0,0,3.73,6.75,13.66,13.66,0,0,0,7.62,2.16c1.61,0,3.22-.13,4.82,0a3.55,3.55,0,0,1,1.12.18c.19.08.3.28.49.34.71.25.81-.78.73-1.21a5.85,5.85,0,0,0-1-2.34,4.69,4.69,0,0,0-.82-1,1.31,1.31,0,0,0-.4-.22c-.69-.34-1.27-.92-2-1.28A12.35,12.35,0,0,0,55.56,313.31Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.57,304.38a9.8,9.8,0,0,1,1.86.93c.61.41,1.12.95,1.69,1.42.28,4,.47,8,.63,12.08a6.43,6.43,0,0,0-.86-.76,7.42,7.42,0,0,0-2.64-1.23c-2.35-.61-4.84-.26-7.14-1-.11,0-.16.21,0,.25,2.1.86,4.35.91,6.53,1.44a9.32,9.32,0,0,1,2.52,1,5,5,0,0,1,1,.79,5.54,5.54,0,0,1,.66.87c.27,6.53.55,13.05,1.27,19.55a112,112,0,0,0,1.75,11.08c.39,1.81.86,3.61,1.39,5.39.31,1.05.65,2.09,1,3.12a15.21,15.21,0,0,0,1,2.16h1.18A14.85,14.85,0,0,0,69.1,360c-.26-.89-.53-1.77-.79-2.65q-.7-2.43-1.25-4.89-1.14-5-1.79-10.14c-.88-6.85-1.19-13.75-1.48-20.64s-.59-13.86-1.32-20.75q-.66-6.25-1.78-12.44a21.78,21.78,0,0,1,2.66-5.9,50.76,50.76,0,0,0,4.05-7.42c0-.1-.06-.29-.14-.14-1.32,2.56-3.4,4.64-5,7a16.91,16.91,0,0,0-2,4c-.39-2.05-.81-4.08-1.28-6.11-.29-1.28-.61-2.55-1-3.83.11-.7.22-1.4.28-2.11a25.83,25.83,0,0,1,.38-2.62,26.52,26.52,0,0,1,1.6-5c1.33-3.16,3.61-5.88,4.66-9.16,0-.16-.15-.41-.25-.17a19.84,19.84,0,0,1-3,4.83,20.1,20.1,0,0,0-4.35,9.74c-.08.47-.15.94-.2,1.41a123.76,123.76,0,0,0-6.05-16.53c-.09-.18-.24.08-.21.2,1.8,5.92,3.49,11.89,5,17.9l-.32-.22A11.73,11.73,0,0,0,53,273.09c-2.33-.81-4.74-1.36-7.09-2.08-.13,0-.19.32-.07.36,2.19.76,4.36,1.56,6.52,2.36a19,19,0,0,1,2.54,1.09,7.47,7.47,0,0,1,1.14.79l.2.2q1.7,7,2.92,14.12a10.52,10.52,0,0,0-5.91-3.23c-1.61-.32-3.25-.39-4.87-.61a15.16,15.16,0,0,1-4.54-1.41c-.08,0-.11.16-.06.2,2.21,2,5.83,2.11,8.64,2.58a11.8,11.8,0,0,1,4.37,1.48,9.66,9.66,0,0,1,2.66,2.71c.38,2.38.73,4.76,1,7.16.25,2.21.45,4.43.62,6.64a7.67,7.67,0,0,0-2.5-1.74,16,16,0,0,0-4.31-1.25c-3-.48-6.19-.59-8.76-2.41,0,0-.08.05-.05.08,2.15,2.06,5.15,2.61,8,3.17A24.09,24.09,0,0,1,57.57,304.38Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.57,304.38a9.8,9.8,0,0,1,1.86.93c.61.41,1.12.95,1.69,1.42.28,4,.47,8,.63,12.08a6.43,6.43,0,0,0-.86-.76,7.42,7.42,0,0,0-2.64-1.23c-2.35-.61-4.84-.26-7.14-1-.11,0-.16.21,0,.25,2.1.86,4.35.91,6.53,1.44a9.32,9.32,0,0,1,2.52,1,5,5,0,0,1,1,.79,5.54,5.54,0,0,1,.66.87c.27,6.53.55,13.05,1.27,19.55a112,112,0,0,0,1.75,11.08c.39,1.81.86,3.61,1.39,5.39.31,1.05.65,2.09,1,3.12a15.21,15.21,0,0,0,1,2.16h1.18A14.85,14.85,0,0,0,69.1,360c-.26-.89-.53-1.77-.79-2.65q-.7-2.43-1.25-4.89-1.14-5-1.79-10.14c-.88-6.85-1.19-13.75-1.48-20.64s-.59-13.86-1.32-20.75q-.66-6.25-1.78-12.44a21.78,21.78,0,0,1,2.66-5.9,50.76,50.76,0,0,0,4.05-7.42c0-.1-.06-.29-.14-.14-1.32,2.56-3.4,4.64-5,7a16.91,16.91,0,0,0-2,4c-.39-2.05-.81-4.08-1.28-6.11-.29-1.28-.61-2.55-1-3.83.11-.7.22-1.4.28-2.11a25.83,25.83,0,0,1,.38-2.62,26.52,26.52,0,0,1,1.6-5c1.33-3.16,3.61-5.88,4.66-9.16,0-.16-.15-.41-.25-.17a19.84,19.84,0,0,1-3,4.83,20.1,20.1,0,0,0-4.35,9.74c-.08.47-.15.94-.2,1.41a123.76,123.76,0,0,0-6.05-16.53c-.09-.18-.24.08-.21.2,1.8,5.92,3.49,11.89,5,17.9l-.32-.22A11.73,11.73,0,0,0,53,273.09c-2.33-.81-4.74-1.36-7.09-2.08-.13,0-.19.32-.07.36,2.19.76,4.36,1.56,6.52,2.36a19,19,0,0,1,2.54,1.09,7.47,7.47,0,0,1,1.14.79l.2.2q1.7,7,2.92,14.12a10.52,10.52,0,0,0-5.91-3.23c-1.61-.32-3.25-.39-4.87-.61a15.16,15.16,0,0,1-4.54-1.41c-.08,0-.11.16-.06.2,2.21,2,5.83,2.11,8.64,2.58a11.8,11.8,0,0,1,4.37,1.48,9.66,9.66,0,0,1,2.66,2.71c.38,2.38.73,4.76,1,7.16.25,2.21.45,4.43.62,6.64a7.67,7.67,0,0,0-2.5-1.74,16,16,0,0,0-4.31-1.25c-3-.48-6.19-.59-8.76-2.41,0,0-.08.05-.05.08,2.15,2.06,5.15,2.61,8,3.17A24.09,24.09,0,0,1,57.57,304.38Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.76,324.37a25.8,25.8,0,0,0-3.6-1.71l-8.22-3.38a1.31,1.31,0,0,0-1.21-.08,1.23,1.23,0,0,0-.38.87,8.48,8.48,0,0,0,.49,3.49c1.54,4.77,5.65,8.78,10.6,9.54,2.07.32,4.21.09,6.25.57.81.19,2.14.45,2.16-.78a1.91,1.91,0,0,0-.34-.88c-.2-.4-.3-.86-.46-1.28a13,13,0,0,0-2.9-4.47A12.83,12.83,0,0,0,45.76,324.37Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,338.3A20.23,20.23,0,0,0,44.8,337l-4.73-.74c-.61-.1-1.22-.18-1.83-.29a.82.82,0,0,1-.26-.06,1.39,1.39,0,0,0-.77-.18c-.35.06-.41.3-.44.61a5.31,5.31,0,0,0,.18,1.86,6.86,6.86,0,0,0,2,3.24,11.83,11.83,0,0,0,5.71,2.61,21.26,21.26,0,0,0,5.1.41c1.43-.05,2.87-.36,3.58-1.75.61-1.22-.46-2.35-1.32-3.12A8.53,8.53,0,0,0,50,338.3Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.35,328.32a2.23,2.23,0,0,1,.1-1,1.19,1.19,0,0,1,1.19-.58,2.3,2.3,0,0,1,1.23.62c1.45,1.31,1.82,3.41,2,5.36a18.13,18.13,0,0,1-.22,6c-.35,1.43-1,3.27-2.63,3.61a2.81,2.81,0,0,1-3-1.4c-.92-1.66-.12-3.85.3-5.54a26.35,26.35,0,0,0,1-6.29C55.37,328.82,55.37,328.57,55.35,328.32Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9,349.35A22.92,22.92,0,0,0,45.65,348l-2.37-.29a1.2,1.2,0,0,0-.5,0c-.52.16-.56.89-.39,1.4.71,2.24,3.15,3.44,5.46,3.88s4.73.39,6.9,1.3c.5.21,1.29.56,1.62-.09.26-.49-.21-.9-.43-1.32a7.28,7.28,0,0,0-2.32-2.55A9,9,0,0,0,51.9,349.35Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6,346.55c.74-1.84,2.33-3.32,2.65-5.27a1,1,0,0,1,1,.45,2.92,2.92,0,0,1,.42,1.12,21.45,21.45,0,0,1,.72,4.56,7.35,7.35,0,0,1-1.19,4.39,2.59,2.59,0,0,1-1.9,1.22,2.23,2.23,0,0,1-1.78-.7c-.71-.78-.49-1.92-.45-2.89A8.55,8.55,0,0,1,56.6,346.55Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.48,342.61c.65.14,1.27.34,1.9.53.56,3,1.16,6,1.75,9,.07.33.13.66.19,1a4.62,4.62,0,0,0-.5-.37,6.65,6.65,0,0,0-1.46-.73,2.89,2.89,0,0,0-.81-.19c-.26,0-.51,0-.77,0s-.2.37,0,.41a9.62,9.62,0,0,1,1.49.49,8.71,8.71,0,0,1,1.29.66,6.58,6.58,0,0,1,1,.76c.42,2.24.84,4.48,1.4,6.68a22.69,22.69,0,0,0,1.37,4.1,11.4,11.4,0,0,0,.64,1.2H60.4a25.77,25.77,0,0,1-1.83-5.13c-.57-2.26-1-4.56-1.43-6.85a6.65,6.65,0,0,1,.37-1.46,16.39,16.39,0,0,1,.66-1.55c.12-.26.26-.5.39-.75a3.63,3.63,0,0,0,.31-1.16s0-.13-.07-.11c-.64.22-1,.86-1.3,1.4a10,10,0,0,0-.76,1.49c-.52-2.61-1-5.22-1.56-7.82h0c.1-.43.17-.86.31-1.28.26-.83.68-1.59,1-2.39a11.17,11.17,0,0,0,.8-2.64,7.26,7.26,0,0,0,.19-2.58c0-.23-.24,0-.21.16.14.94-.64,1.83-1.05,2.62s-.77,1.45-1.14,2.18c-.17.34-.34.69-.49,1a25.36,25.36,0,0,0-2.07-7.2,11.85,11.85,0,0,0-2.71-3.42,12.47,12.47,0,0,0-2.15-1.45,19.63,19.63,0,0,0-2.57-1c-.09,0-.14.18-.07.22.65.43,1.25.93,1.91,1.35a18.52,18.52,0,0,1,2,1.47,7.84,7.84,0,0,1,2.29,3.17A40.93,40.93,0,0,1,53.16,342a20.54,20.54,0,0,0-3.72-.64,11.45,11.45,0,0,1-3.88-1.11c-.16-.09-.23.28-.12.37a9.1,9.1,0,0,0,3.93,1.55C50.08,342.31,50.78,342.45,51.48,342.61Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.48,342.61c.65.14,1.27.34,1.9.53.56,3,1.16,6,1.75,9,.07.33.13.66.19,1a4.62,4.62,0,0,0-.5-.37,6.65,6.65,0,0,0-1.46-.73,2.89,2.89,0,0,0-.81-.19c-.26,0-.51,0-.77,0s-.2.37,0,.41a9.62,9.62,0,0,1,1.49.49,8.71,8.71,0,0,1,1.29.66,6.58,6.58,0,0,1,1,.76c.42,2.24.84,4.48,1.4,6.68a22.69,22.69,0,0,0,1.37,4.1,11.4,11.4,0,0,0,.64,1.2H60.4a25.77,25.77,0,0,1-1.83-5.13c-.57-2.26-1-4.56-1.43-6.85a6.65,6.65,0,0,1,.37-1.46,16.39,16.39,0,0,1,.66-1.55c.12-.26.26-.5.39-.75a3.63,3.63,0,0,0,.31-1.16s0-.13-.07-.11c-.64.22-1,.86-1.3,1.4a10,10,0,0,0-.76,1.49c-.52-2.61-1-5.22-1.56-7.82h0c.1-.43.17-.86.31-1.28.26-.83.68-1.59,1-2.39a11.17,11.17,0,0,0,.8-2.64,7.26,7.26,0,0,0,.19-2.58c0-.23-.24,0-.21.16.14.94-.64,1.83-1.05,2.62s-.77,1.45-1.14,2.18c-.17.34-.34.69-.49,1a25.36,25.36,0,0,0-2.07-7.2,11.85,11.85,0,0,0-2.71-3.42,12.47,12.47,0,0,0-2.15-1.45,19.63,19.63,0,0,0-2.57-1c-.09,0-.14.18-.07.22.65.43,1.25.93,1.91,1.35a18.52,18.52,0,0,1,2,1.47,7.84,7.84,0,0,1,2.29,3.17A40.93,40.93,0,0,1,53.16,342a20.54,20.54,0,0,0-3.72-.64,11.45,11.45,0,0,1-3.88-1.11c-.16-.09-.23.28-.12.37a9.1,9.1,0,0,0,3.93,1.55C50.08,342.31,50.78,342.45,51.48,342.61Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.62,255.54c1.91-4,5.4-7.26,6.81-11.5a1.29,1.29,0,0,1,.31-.59.83.83,0,0,1,1.07.12,2.25,2.25,0,0,1,.52,1.06,17.73,17.73,0,0,1,.4,9.68,32.81,32.81,0,0,1-1.73,4.22,80.34,80.34,0,0,1-3.27,7.34,14.33,14.33,0,0,1-2.74,3.5c-.81.74-2.24,2-3.1.65a3.71,3.71,0,0,1-.34-2c0-.81,0-1.63,0-2.45a32.88,32.88,0,0,1,.45-4.85,20.58,20.58,0,0,1,1.35-4.6Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.12,270.8a20.66,20.66,0,0,0-2.66-6.12q-2.17-3.8-4.33-7.59c-.11-.2-.26-.42-.49-.44s-.42.21-.55.42c-2,3.33-2,7.65-.6,11.32A30.52,30.52,0,0,0,89,278.05a1.21,1.21,0,0,0,1.31.49,1.72,1.72,0,0,0,.86-1.34,2.24,2.24,0,0,0-.06-.52,7.16,7.16,0,0,1,.09-1.46c.05-.6.1-1.2.11-1.8A12.75,12.75,0,0,0,91.12,270.8Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.16,268.12l4.19-2.07a.52.52,0,0,1,.36-.09c.2,0,.3.28.35.48a6.49,6.49,0,0,1-.74,4.37,14.28,14.28,0,0,1-2.82,3.52,35,35,0,0,1-3.54,3,32.91,32.91,0,0,1-3.95,2.5,28.76,28.76,0,0,1-4.26,1.86,25.79,25.79,0,0,1-4.48,1.13c-.81.13-1.89.27-2-.79a4.7,4.7,0,0,1,.82-2.78,12.15,12.15,0,0,1,2.62-2.92,35.42,35.42,0,0,1,3.87-2.93c1.36-.89,2.76-1.71,4.19-2.49s2.89-1.52,4.36-2.25Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.21,284a28.57,28.57,0,0,0-1.41-3.51,60,60,0,0,1-3-8.45c-.47-.05-.85.35-1.14.72a14.38,14.38,0,0,0-3.06,7.95,10.62,10.62,0,0,0,2.88,7.9c1.47,1.49,3.48,2.51,4.54,4.33.19.34.39.73.76.85a.56.56,0,0,0,.61-.27c.11-.22-.06-.44,0-.67.08-.73.19-1.45.26-2.18a22.16,22.16,0,0,0,.08-4.31A12.57,12.57,0,0,0,83.21,284Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,289.74c2.16-1.78,5.08-2.3,7.86-2.65s5.68-.62,8.09-2a1.89,1.89,0,0,1,.86-.35c.82,0,1.17,1.07,1,1.87a7.41,7.41,0,0,1-1.57,3.08,14.35,14.35,0,0,1-2.32,2.54c-3.07,2.53-7.39,2.74-11.37,2.84l-2.86.07-1.45,0a12.9,12.9,0,0,1-1.39,0c-.72-.08-.15-.94,0-1.28.39-.71.78-1.41,1.24-2.08A10.07,10.07,0,0,1,88,289.74Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2,300.18a17.92,17.92,0,0,0-1.73-3.41L72,291c-.36-.6-.84-1.28-1.54-1.3-1.65,4.42-2.55,9.53-.44,13.74a21.16,21.16,0,0,0,2.68,3.82l2.93,3.58c.4.49,1.15,1,1.81.66.31-.16.36-.55.42-.85a9.2,9.2,0,0,0,.17-1.47,4.41,4.41,0,0,0,0-1.09,15.39,15.39,0,0,1-.24-3.18A15,15,0,0,0,77.2,300.18Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.55,302.21a12.39,12.39,0,0,1,3.1-1.18c1.26-.27,2.56-.28,3.84-.44,2.11-.25,4.14-.91,6.24-1.22a1,1,0,0,1,.64,0,1,1,0,0,1,.41.84,7.27,7.27,0,0,1-1.08,4.06,14.61,14.61,0,0,1-9.76,7.14,35.47,35.47,0,0,1-5.64.47c-1,.05-1.89.11-2.83.24-.47.07-.94.16-1.4.27a1.34,1.34,0,0,1-.86.06c-.46-.21-.49-.85-.44-1.28a4.89,4.89,0,0,1,.69-1.91A17.12,17.12,0,0,1,87,302.5Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.54,313a38.38,38.38,0,0,0-.57,5.85,19,19,0,0,0,1,7.31,25.76,25.76,0,0,0,4.41,6.75.73.73,0,0,0,.38.3c.34.08.6-.3.73-.62a17.1,17.1,0,0,0,1-9.2,17.84,17.84,0,0,0-1.4-4.56c-.31-.66-.76-1.26-1-1.94-.06-.16-.09-.33-.15-.49a11.79,11.79,0,0,0-.81-1.42,19.66,19.66,0,0,1-1.4-3.19,1.75,1.75,0,0,0-.6-1,.66.66,0,0,0-.68,0c-.25.14-.21.36-.31.59a6.22,6.22,0,0,0-.37.78A7.86,7.86,0,0,0,67.54,313Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.28,320.31a10.55,10.55,0,0,1,3-3.44,13.14,13.14,0,0,1,3.27-1.39l8.56-2.76c.54,3.13-.93,6.35-3.1,8.68a30.81,30.81,0,0,1-7.34,5.37c-1.89,1.1-3.82,1.92-4.87,2.63-.47.32-.94.65-1.39,1-.3.23-1,.83-1.38.43-.18-.2-.07-.54,0-.76s.13-.66.22-1,.23-.82.34-1.23.23-.81.32-1.22c0-.2.07-.41.11-.61a18.81,18.81,0,0,1,.86-2.95A20.43,20.43,0,0,1,78.28,320.31Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.67,276.8a72.38,72.38,0,0,0-7.51,3.67c-.47.25-1,.52-1.5.83l.12-.21a74.35,74.35,0,0,0,5.92-11.67,64.33,64.33,0,0,0,2-6.31,65.88,65.88,0,0,0,1.27-6.67c0-.26-.25-.45-.32-.13-.48,2-1.21,4-1.85,6s-1.36,3.86-2.15,5.74a87.61,87.61,0,0,1-5.38,10.58L90.49,280v-.89a18.69,18.69,0,0,0-.34-3.73,22.49,22.49,0,0,0-.92-3.4,7.85,7.85,0,0,0-1.6-3.15c-.12-.11-.22.1-.2.21a22.75,22.75,0,0,0,1.13,3.11,20.18,20.18,0,0,1,.76,3.34,23,23,0,0,1,.17,3.42,23.2,23.2,0,0,0-.16,3c-1.46,2.43-2.91,4.85-4.23,7.36-.59,1.14-1.15,2.29-1.7,3.45a.83.83,0,0,0,0-.15A21.42,21.42,0,0,0,82,288.69c-1.29-2.86-2.78-5.64-3.26-8.78,0-.16-.18,0-.18.07a24.35,24.35,0,0,0,2,7.85c.5,1.37,1,2.74,1.32,4.14a16.09,16.09,0,0,1,.4,2.07c0,.36.06.7.12,1l-.18.42a3.69,3.69,0,0,0-.53,1.24c-.37.89-.74,1.79-1.09,2.69q-1.89,4.89-3.32,9.94a21.9,21.9,0,0,0-1-3.66,20.87,20.87,0,0,0-1.66-3.55,12.15,12.15,0,0,0-2.37-3.33c-.12-.1-.17.2-.14.27.51,1.15,1.28,2.16,1.78,3.32s.92,2.26,1.29,3.42A51.21,51.21,0,0,1,76.47,312a134.14,134.14,0,0,0-2.8,13.76C73,324,72,322.27,71.14,320.55c-.11-.22-.3.12-.24.27A35.62,35.62,0,0,1,73,327.33c.09.45.17.91.24,1.36-.64,4.94-1,9.92-1.18,14.89,0,.75.09,5.29.17,8.09a46.65,46.65,0,0,0,.65,7,22.34,22.34,0,0,0,.95,3.37h1.32a11.59,11.59,0,0,0-.23-1.55,61.12,61.12,0,0,1-1.1-11.65c0-1.25,0-2.51,0-3.76q.14-5.82.7-11.62a14.32,14.32,0,0,1,1.56-3c1.77-2.57,4.5-4.25,6.35-6.74.11-.13.06-.68-.21-.52a30.3,30.3,0,0,0-4.18,3.15A15.85,15.85,0,0,0,75,329.44c.28-2.26.61-4.51,1-6.75.44-2.5,1-5,1.54-7.44a13.67,13.67,0,0,0,.93-1.11c.41-.53.8-1.08,1.24-1.59a12.94,12.94,0,0,1,2.92-2.45,11.91,11.91,0,0,1,3.16-1.4,14.87,14.87,0,0,1,1.6-.38,5.7,5.7,0,0,0,1.68-.38c.07,0,.11-.23,0-.28-1.13-.59-2.85-.27-4,0a12.06,12.06,0,0,0-6.56,3.9q1.41-5.2,3.29-10.28c.75-2,1.57-4,2.44-5.91a9.53,9.53,0,0,1,2.23-1.29,31.27,31.27,0,0,1,3.4-1.09,20.76,20.76,0,0,0,3.17-1.27c.13-.07.16-.43,0-.38-1.31.36-2.73.46-4.07.72a17.57,17.57,0,0,0-3.64,1c1.3-2.74,2.71-5.43,4.2-8.08a13.54,13.54,0,0,1,1.64-1.92,20.31,20.31,0,0,1,3.1-1.88,74.72,74.72,0,0,0,6.53-4C100.92,277.14,100.88,276.72,100.67,276.8Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.67,276.8a72.38,72.38,0,0,0-7.51,3.67c-.47.25-1,.52-1.5.83l.12-.21a74.35,74.35,0,0,0,5.92-11.67,64.33,64.33,0,0,0,2-6.31,65.88,65.88,0,0,0,1.27-6.67c0-.26-.25-.45-.32-.13-.48,2-1.21,4-1.85,6s-1.36,3.86-2.15,5.74a87.61,87.61,0,0,1-5.38,10.58L90.49,280v-.89a18.69,18.69,0,0,0-.34-3.73,22.49,22.49,0,0,0-.92-3.4,7.85,7.85,0,0,0-1.6-3.15c-.12-.11-.22.1-.2.21a22.75,22.75,0,0,0,1.13,3.11,20.18,20.18,0,0,1,.76,3.34,23,23,0,0,1,.17,3.42,23.2,23.2,0,0,0-.16,3c-1.46,2.43-2.91,4.85-4.23,7.36-.59,1.14-1.15,2.29-1.7,3.45a.83.83,0,0,0,0-.15A21.42,21.42,0,0,0,82,288.69c-1.29-2.86-2.78-5.64-3.26-8.78,0-.16-.18,0-.18.07a24.35,24.35,0,0,0,2,7.85c.5,1.37,1,2.74,1.32,4.14a16.09,16.09,0,0,1,.4,2.07c0,.36.06.7.12,1l-.18.42a3.69,3.69,0,0,0-.53,1.24c-.37.89-.74,1.79-1.09,2.69q-1.89,4.89-3.32,9.94a21.9,21.9,0,0,0-1-3.66,20.87,20.87,0,0,0-1.66-3.55,12.15,12.15,0,0,0-2.37-3.33c-.12-.1-.17.2-.14.27.51,1.15,1.28,2.16,1.78,3.32s.92,2.26,1.29,3.42A51.21,51.21,0,0,1,76.47,312a134.14,134.14,0,0,0-2.8,13.76C73,324,72,322.27,71.14,320.55c-.11-.22-.3.12-.24.27A35.62,35.62,0,0,1,73,327.33c.09.45.17.91.24,1.36-.64,4.94-1,9.92-1.18,14.89,0,.75.09,5.29.17,8.09a46.65,46.65,0,0,0,.65,7,22.34,22.34,0,0,0,.95,3.37h1.32a11.59,11.59,0,0,0-.23-1.55,61.12,61.12,0,0,1-1.1-11.65c0-1.25,0-2.51,0-3.76q.14-5.82.7-11.62a14.32,14.32,0,0,1,1.56-3c1.77-2.57,4.5-4.25,6.35-6.74.11-.13.06-.68-.21-.52a30.3,30.3,0,0,0-4.18,3.15A15.85,15.85,0,0,0,75,329.44c.28-2.26.61-4.51,1-6.75.44-2.5,1-5,1.54-7.44a13.67,13.67,0,0,0,.93-1.11c.41-.53.8-1.08,1.24-1.59a12.94,12.94,0,0,1,2.92-2.45,11.91,11.91,0,0,1,3.16-1.4,14.87,14.87,0,0,1,1.6-.38,5.7,5.7,0,0,0,1.68-.38c.07,0,.11-.23,0-.28-1.13-.59-2.85-.27-4,0a12.06,12.06,0,0,0-6.56,3.9q1.41-5.2,3.29-10.28c.75-2,1.57-4,2.44-5.91a9.53,9.53,0,0,1,2.23-1.29,31.27,31.27,0,0,1,3.4-1.09,20.76,20.76,0,0,0,3.17-1.27c.13-.07.16-.43,0-.38-1.31.36-2.73.46-4.07.72a17.57,17.57,0,0,0-3.64,1c1.3-2.74,2.71-5.43,4.2-8.08a13.54,13.54,0,0,1,1.64-1.92,20.31,20.31,0,0,1,3.1-1.88,74.72,74.72,0,0,0,6.53-4C100.92,277.14,100.88,276.72,100.67,276.8Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8,353.2a16.22,16.22,0,0,0-.58-3.92,8.73,8.73,0,0,0-2.63-4.7,3.41,3.41,0,0,0-2.64-.74l.81,5.58.09.6a10,10,0,0,0,1.3,4.06,5.11,5.11,0,0,0,.72.75,9.4,9.4,0,0,0,1.64,1.32l.28.16a1,1,0,0,0,.44.14c.52,0,.46-.83.49-1.18a14.48,14.48,0,0,0,.09-1.86C81.81,353.34,81.8,353.27,81.8,353.2Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.71,346.17a15.63,15.63,0,0,0,3-1.7c.2-.15.47-.31.69-.18a.56.56,0,0,1,.23.36c.38,1.36-.37,2.77-1.22,3.9a14.79,14.79,0,0,1-3.6,3.46,10.7,10.7,0,0,1-4.53,1.8c-1,.12-3.08.3-2.68-1.27a5.35,5.35,0,0,1,.94-1.7A16.07,16.07,0,0,1,85,349.05c1.38-1.37,3.3-1.91,5.06-2.62Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,336a16.13,16.13,0,0,1,10.4.36,4.53,4.53,0,0,1,2.24,1.38,1.8,1.8,0,0,1-.13,2.41,2.77,2.77,0,0,1-1,.41l-16.17,4a3.76,3.76,0,0,1-1.29.13c-.22,0-.4-.14-.61-.17s-.33.07-.45-.13a.68.68,0,0,1-.06-.4,4.67,4.67,0,0,1,.08-1,2.18,2.18,0,0,1,.16-.45c.18-.35.32-.72.5-1.09a10.51,10.51,0,0,1,3.58-4.05A11.38,11.38,0,0,1,91,336Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.84,326.28c2.77-1.46,6-1.59,9.15-1.69a.65.65,0,0,1,.51.12.61.61,0,0,1,.14.35,4.79,4.79,0,0,1-1.49,3.76,12.3,12.3,0,0,1-4,2.95,25.75,25.75,0,0,1-4.57,1.42l-4.19,1c-.27.07-.9.4-1.16.21s0-1.06,0-1.33a10.13,10.13,0,0,1,.79-1.58,12.94,12.94,0,0,1,1.77-2.83A10.4,10.4,0,0,1,93.84,326.28Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.69,335.22c-.08-.06-.18-.12-.27-.08a.24.24,0,0,0-.11.2,2.64,2.64,0,0,0-.13.68,1.08,1.08,0,0,0,0,.18,2.15,2.15,0,0,1-.11.55A5.47,5.47,0,0,0,78,338a6.74,6.74,0,0,0,.17,1.35,9.45,9.45,0,0,0,1.31,3,4.68,4.68,0,0,0,.45.62c.19.22.41.4.61.61a8.55,8.55,0,0,1,1.15,1.52c.09.15.22.33.4.3a.43.43,0,0,0,.25-.21,2,2,0,0,0,.4-.64,6.92,6.92,0,0,0,.14-.77.49.49,0,0,0,0-.12,8.56,8.56,0,0,0-4.15-8.44Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.18,339.37a7.8,7.8,0,0,0-4,.08,19.69,19.69,0,0,0-4.26,1.26,10.73,10.73,0,0,0-2.37,1.46,25.6,25.6,0,0,1,3.73-5.91,29.61,29.61,0,0,1,6-5.65c.09-.05.1-.37,0-.31a22.14,22.14,0,0,0-6.09,3.93,22.58,22.58,0,0,0-4.48,6,26.24,26.24,0,0,0-1.41,3.16c-.06-.21-.12-.43-.19-.63a10.83,10.83,0,0,0-.88-1.89,6.44,6.44,0,0,0-.59-.88c-.14-.17-.32-.48-.58-.44,0,0-.07.08-.07.12a2.33,2.33,0,0,0,.38.94l.4.78A13.3,13.3,0,0,1,81.3,343c.19.59.3,1.18.43,1.77a23.46,23.46,0,0,0-.57,2.34,31.11,31.11,0,0,0-.51,4.61c-.12-.33-.26-.66-.41-1a12.6,12.6,0,0,0-1.57-2.45c-.12-.16-.24.19-.15.3a13,13,0,0,1,1.92,5.15c.06.32.11.64.17.95,0,.53,0,1.05,0,1.57,0,1.9,0,3.79,0,5.69,0,1.34-.15,2.67-.24,4h1.25a27,27,0,0,0,.63-6.81c0-1.75,0-3.52,0-5.28l.07-.06a4.69,4.69,0,0,1,.94-.43,12.27,12.27,0,0,0,2-.88,12.66,12.66,0,0,0,3.39-2.6c.07-.07,0-.31-.07-.2a7.79,7.79,0,0,1-3.77,2l-2.2.63-.33.12c0-.82.07-1.63.15-2.45a23.78,23.78,0,0,1,.77-4.22c.58-.6,1-1.38,1.6-2a10.75,10.75,0,0,1,2.75-1.93,18.3,18.3,0,0,1,3.51-1.31l1.89-.51a5.86,5.86,0,0,1,2.17-.42C95.26,339.67,95.3,339.41,95.18,339.37Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.18,339.37a7.8,7.8,0,0,0-4,.08,19.69,19.69,0,0,0-4.26,1.26,10.73,10.73,0,0,0-2.37,1.46,25.6,25.6,0,0,1,3.73-5.91,29.61,29.61,0,0,1,6-5.65c.09-.05.1-.37,0-.31a22.14,22.14,0,0,0-6.09,3.93,22.58,22.58,0,0,0-4.48,6,26.24,26.24,0,0,0-1.41,3.16c-.06-.21-.12-.43-.19-.63a10.83,10.83,0,0,0-.88-1.89,6.44,6.44,0,0,0-.59-.88c-.14-.17-.32-.48-.58-.44,0,0-.07.08-.07.12a2.33,2.33,0,0,0,.38.94l.4.78A13.3,13.3,0,0,1,81.3,343c.19.59.3,1.18.43,1.77a23.46,23.46,0,0,0-.57,2.34,31.11,31.11,0,0,0-.51,4.61c-.12-.33-.26-.66-.41-1a12.6,12.6,0,0,0-1.57-2.45c-.12-.16-.24.19-.15.3a13,13,0,0,1,1.92,5.15c.06.32.11.64.17.95,0,.53,0,1.05,0,1.57,0,1.9,0,3.79,0,5.69,0,1.34-.15,2.67-.24,4h1.25a27,27,0,0,0,.63-6.81c0-1.75,0-3.52,0-5.28l.07-.06a4.69,4.69,0,0,1,.94-.43,12.27,12.27,0,0,0,2-.88,12.66,12.66,0,0,0,3.39-2.6c.07-.07,0-.31-.07-.2a7.79,7.79,0,0,1-3.77,2l-2.2.63-.33.12c0-.82.07-1.63.15-2.45a23.78,23.78,0,0,1,.77-4.22c.58-.6,1-1.38,1.6-2a10.75,10.75,0,0,1,2.75-1.93,18.3,18.3,0,0,1,3.51-1.31l1.89-.51a5.86,5.86,0,0,1,2.17-.42C95.26,339.67,95.3,339.41,95.18,339.37Z",
    style: {
      opacity: 0.5
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Characters--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--characters--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.55,310.17c-.27,0-.66,3,.81,4.22,1.69,1.44,6.65,3.8,13.18,2.92s10.06-2.92,12.66-5.13,6.25-5.31,9.21-6c2.74-.62,5.71-1.88,6.59-2.73s.73-4.63.73-4.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.37,284.32s.49,0,.67.89c.2,1,.44,4.06.88,5.76a30.6,30.6,0,0,1,.69,9.17c-.35,1.93-4.81,3.3-7.67,4.41a36.51,36.51,0,0,0-9.23,5.9c-3.06,2.55-9.51,5.13-13.77,5.22-6.5.13-10.72-1.61-12-3.94-1.63-2.88-.37-4.56,7.08-8.07C372.4,303,377.35,300,379,299a38.27,38.27,0,0,0,5.06-3.81,28.6,28.6,0,0,0,2.27-2.27,10.22,10.22,0,0,0,1.88-2.43c.08-.2.14-.43.21-.63a10.65,10.65,0,0,0,.48-1.76c.12-.62.19-1.52.78-1.9a5,5,0,0,1,2.67-.33,20.13,20.13,0,0,1,2.88.39c1.1.24,2.37.33,3,1.36a5.37,5.37,0,0,1,.63,2.7c0,.44,0,.88,0,1.32,0,.18-.07.52.19.44s.52-.73.61-.95c.21-.49.34-1,.56-1.5a8.26,8.26,0,0,1,.92-1.58,7.57,7.57,0,0,1,1.18-1.22,11.1,11.1,0,0,0,1.27-.83A3,3,0,0,0,404.37,284.32Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.79,304.24c9.41.59,12.41,6.39,12.83,10a22.54,22.54,0,0,1-6.68,1.44c-6.5.13-11-1.61-12.3-3.94C362.11,309,363.13,306.81,369.79,304.24Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.9,304.25a.46.46,0,0,0,.29-.1.47.47,0,0,0,.06-.65,11.06,11.06,0,0,0-8.53-3.31.46.46,0,0,0,.1.92,10.23,10.23,0,0,1,7.72,3A.45.45,0,0,0,383.9,304.25Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.94,301.87a.48.48,0,0,0,.29-.11.45.45,0,0,0,.06-.64,11,11,0,0,0-8.53-3.31.45.45,0,0,0-.4.51.44.44,0,0,0,.5.4,10.21,10.21,0,0,1,7.72,3A.48.48,0,0,0,387.94,301.87Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.68,299.15A.46.46,0,0,0,392,299a.45.45,0,0,0,.06-.64,11,11,0,0,0-8.53-3.31.46.46,0,0,0-.4.51.44.44,0,0,0,.5.4,10.26,10.26,0,0,1,7.72,3A.48.48,0,0,0,391.68,299.15Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.25,336.34c-.09,4.45.36,7.44,1.73,10.16s4.26,3.77,7.32,3.25,7.06-2.25,8.23-6,1.87-6.33,1.52-10.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.41,305.29c1.23.2,1.12,6.17,1.36,12.18.26,6.43,2,9.22,2.22,14.51.31,6-.89,8.63-3.27,12.07s-10.08,6.4-13.32.94c-2.64-4.46-2.39-9.14-1.65-15.09a131.2,131.2,0,0,0,.81-15.15c.11-4.49-.52-9.08.59-9.49,0,.66.05,1.5.09,2.15a10.84,10.84,0,0,0,.2,2.42c.1.34.35.71.51.18a3.76,3.76,0,0,0,.09-1.11c-.05-1.66.79-1.73,1.24-1.82a54.87,54.87,0,0,1,5.8-.36c.95,0,4.23.13,4.61.7a3.71,3.71,0,0,1,.27,1.76c0,.91.19,1.58.24,1.3.11-.64.12-2.32.14-2.73s0-.92,0-1.31S437.41,305.68,437.41,305.29Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.06,335.47a15,15,0,0,1-3,8.89c-2.38,3.45-10.68,6.37-13.92.9-1.61-2.72-1.85-5.8-1.86-8.92C424.76,332.52,437.88,331.8,441.06,335.47Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.47,330.06l.15,0c.05,0,6-1.93,11.43-.19a.47.47,0,0,0,.58-.3.46.46,0,0,0-.3-.58,21.56,21.56,0,0,0-12,.22.46.46,0,0,0,.18.89Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.13,325.35a.45.45,0,0,0,.41-.28.46.46,0,0,0-.24-.6c-5.39-2.32-11.77,0-12,.11a.46.46,0,0,0-.24.61.47.47,0,0,0,.6.24c.05,0,6.27-2.28,11.28-.12A.48.48,0,0,0,437.13,325.35Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.26,321.14a.47.47,0,0,0,.41-.27.45.45,0,0,0-.23-.61c-5.92-2.67-12-.06-12.23.06a.46.46,0,0,0,.41.82c.06,0,5.93-2.53,11.45,0A.65.65,0,0,0,437.26,321.14Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.05,134.37c-4.39,13.72-6.24,37-6.06,52.67.18,15,4.71,45.78,5.87,65.74s2.75,37.59,2.75,37.59a19.57,19.57,0,0,0,11,3.51c6.21-.11,8.33-2.91,8.33-2.91s1.94-12.76,2.64-21.51,2.2-19.87,2.47-26.89.52-17.48-.93-22.89l.19-7.33s3.08,25.55,4.06,39.3,7.48,59.47,7.48,59.47,1.14,3.1,9.47,3,8.86-3.26,8.86-3.26,1.16-26,2.06-35.51-.09-30.47-1.31-35.49,1.27-24.73,1.47-32.59,3.8-32.17,2.53-47.82-6.67-25-6.67-25C428.55,144,401.48,143,384.05,134.37Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.29,212.35s-2.37-26.39-2.83-37.83c-5.6-.72-12-5.81-15.6-10.36,1.82,7,9,11.55,12.45,12.75l4.95,36,.84,6.81Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.13,175.36c-.18-11.18-1.33-22.45-4.63-33.18-.41-1.33-.84-2.66-1.31-4-.05-.16-.19,0-.15.09a128,128,0,0,1,5,30.56,6.83,6.83,0,0,1-4.82-2.14,12.44,12.44,0,0,1-2.91-5.55c-.58-2.12-.95-4.31-1.38-6.47-.47-2.34-.92-4.68-1.42-7-.6-2.8-1.24-5.59-1.86-8.38,0-.12-.16-.07-.14,0,.43,2.56.85,5.11,1.31,7.66s1,5.18,1.49,7.76c.82,4.2,1.32,9.12,4.48,12.32a7.64,7.64,0,0,0,5.28,2.41c0,1,.1,2,.13,3A314.82,314.82,0,0,1,439,206.14c-.88,11.42-2.06,22.86-2.05,34.32,0,11.76,1.66,23.42,2.43,35.14.79,11.89.36,23.79.08,35.69,0,.22,0,.44,0,.65a3,3,0,0,0,.5-.59,262.33,262.33,0,0,0,.49-31.47c-.53-11.84-2.26-23.6-2.59-35.46s.86-23.51,1.78-35.22C440.49,198,441.3,186.66,441.13,175.36Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.37,140.58a60,60,0,0,1,2.6-10s7.76,5.61,25.23,7.11c20.92,1.79,28-3.31,28-3.31a46.23,46.23,0,0,1,3.28,7.89C431.39,151,399.65,150.64,382.37,140.58Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.37,140.58a60,60,0,0,1,2.6-10s7.76,5.61,25.23,7.11c20.92,1.79,28-3.31,28-3.31a46.23,46.23,0,0,1,3.28,7.89C431.39,151,399.65,150.64,382.37,140.58Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--massage-table--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.3,420V289.66h6.2V420h0a1.54,1.54,0,0,1-.91,1.26,4.83,4.83,0,0,1-4.38,0A1.54,1.54,0,0,1,114.3,420Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.61 388.9 117.4 348.37 117.4 302.33 187.61 342.86 187.61 388.9",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.5,460.56V330.19h6.21V460.56h0a1.54,1.54,0,0,1-.91,1.27,4.85,4.85,0,0,1-4.39,0A1.56,1.56,0,0,1,184.5,460.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.44,366.83V236.46h6.21V366.83h0a1.54,1.54,0,0,1-.91,1.26,4.85,4.85,0,0,1-4.39,0A1.56,1.56,0,0,1,206.44,366.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.75 335.7 209.55 295.17 209.55 249.13 279.75 289.66 279.75 335.7",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.65,407.36V277h6.21V407.36h0a1.56,1.56,0,0,1-.91,1.27,4.85,4.85,0,0,1-4.39,0A1.54,1.54,0,0,1,276.65,407.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.86 315.44 244.65 274.9 244.65 228.86 314.86 269.39 314.86 315.44",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.55,346.56V216.19h6.2V346.56h0a1.54,1.54,0,0,1-.91,1.27,4.83,4.83,0,0,1-4.38,0A1.54,1.54,0,0,1,241.55,346.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.75,387.09V256.73H318V387.09h0a1.54,1.54,0,0,1-.91,1.27,4.85,4.85,0,0,1-4.39,0A1.56,1.56,0,0,1,311.75,387.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.69,293.36V163h6.21V293.36h0a1.52,1.52,0,0,1-.91,1.26,4.85,4.85,0,0,1-4.39,0A1.54,1.54,0,0,1,333.69,293.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "407 262.24 336.8 221.7 336.8 175.66 407 216.19 407 262.24",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.9,333.89V203.52h6.21V333.89h0a1.56,1.56,0,0,1-.91,1.27,4.85,4.85,0,0,1-4.39,0A1.54,1.54,0,0,1,403.9,333.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.88,198.29l-69.63-40.2a10.34,10.34,0,0,0-9.35,0L227.39,223.62c-2.58,1.5-4.68,3.84-4.68,5.24v2.53l79,45.6,122.87-70.93v-2.54C424.56,202.12,422.46,199.78,419.88,198.29Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.88,198.29l-69.63-40.2a10.34,10.34,0,0,0-9.35,0L227.39,223.62c-2.58,1.5-4.68,3.84-4.68,5.24v2.53l79,45.6,122.87-70.93v-2.54C424.56,202.12,422.46,199.78,419.88,198.29Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,269.22,227.39,229c-2.58-1.5-2.58-3.91,0-5.41L340.9,158.09a10.34,10.34,0,0,1,9.35,0l69.63,40.2c2.58,1.49,2.58,3.91,0,5.4L306.37,269.22A10.28,10.28,0,0,1,297,269.22Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "424.56 206.06 424.56 211.12 301.69 282.06 301.69 276.99 424.56 206.06",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.71 231.39 222.71 236.46 301.69 282.06 301.69 276.99 222.71 231.39",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.63,271.76,223,231.56a10.34,10.34,0,0,0-9.35,0L100.14,297.09c-2.58,1.49-4.68,3.84-4.68,5.24v2.53l79,45.6,122.87-70.94V277C297.31,275.59,295.21,273.25,292.63,271.76Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.63,271.76,223,231.56a10.34,10.34,0,0,0-9.35,0L100.14,297.09c-2.58,1.49-4.68,3.84-4.68,5.24v2.53l79,45.6,122.87-70.94V277C297.31,275.59,295.21,273.25,292.63,271.76Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.77,342.69l-69.63-40.2c-2.58-1.49-2.58-3.91,0-5.4l113.51-65.53a10.34,10.34,0,0,1,9.35,0l69.63,40.2c2.58,1.49,2.58,3.91,0,5.4L179.12,342.69A10.34,10.34,0,0,1,169.77,342.69Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.31 279.52 297.31 284.59 174.44 355.53 174.44 350.46 297.31 279.52",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.46 304.86 95.46 309.93 174.44 355.53 174.44 350.46 95.46 304.86",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.61,421.89a1.11,1.11,0,0,0,.7-.25l92.14-121a1.08,1.08,0,1,0-1.4-1.64L186.91,420a1.07,1.07,0,0,0-.12,1.52A1,1,0,0,0,187.61,421.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.61,354.07a1.1,1.1,0,0,0,.31,0l92.14,14.62a1.08,1.08,0,1,0-.62-2.07L187.3,352a1.08,1.08,0,0,0-.73,1.35A1.09,1.09,0,0,0,187.61,354.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.86,348.43a1.13,1.13,0,0,0,.7-.26l92.14-121a1.08,1.08,0,0,0-1.4-1.65l-92.14,121a1.08,1.08,0,0,0,.7,1.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.86,280.6a1.1,1.1,0,0,0,.31,0l92.14,14.62a1.08,1.08,0,1,0-.62-2.07l-92.15-14.62a1.08,1.08,0,0,0,.32,2.11Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pillow--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.31,188.38c0-2.13,3.19-5.7,7.12-8l15.84-9.15a10.74,10.74,0,0,1,5.48-1.77h0c3.41,0,17,6.58,23.72,10.43S401.76,193.08,404,197c.74,1.29-25.57,20.4-28.79,19.73-7.17-1.5-20.12-7.67-26.76-11.72-10.85-6.62-17-12.13-19.16-14.48A2.76,2.76,0,0,1,328.31,188.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.22,206l-15.84,9.14c-3.93,2.28-7.13,2.39-7.13.26s3.2-5.71,7.13-8l15.84-9.14c3.94-2.28,7.13-2.39,7.13-.26S401.16,203.69,397.22,206Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.49,290.79c1.74,5.08,6.07,9.56,11.39,10.6,3.94.76,8.33-2.21,11.87-3.63,5.27-2.09,11-2.82,16.38-4.53a93.6,93.6,0,0,0,9.07-3.55l27.26-11.75A139.65,139.65,0,0,1,189,292.7c-4.92,3.74-11.62,9.15-18.2,8.9a24.9,24.9,0,0,1-6.42-1.29,3.8,3.8,0,0,0-2.3-.21,3.13,3.13,0,0,0-1.35,1.1c-5.11,6.48,1.59,17.19,9.14,17.81,2.8.24,5.29-1.6,7.63-3.15,12.14-8,27.33-9.89,40-16.87,2.49-1.37,4.84-2.94,7.18-4.49,2-1.27,3.49-2.66,5.34-4.06,3.69-2.79,8.2-4.29,12.57-5.72,3.66-1.2,7.29-2.5,10.94-3.74a33.69,33.69,0,0,1,5.48-1.78c1.66-.24,3.61.25,5.29.42a11.55,11.55,0,0,1,1.94.32c.73.21,1.41.56,2.14.77A12,12,0,0,0,272,281a16.79,16.79,0,0,0,6-.95,24.68,24.68,0,0,0,4.26-2.7,27.24,27.24,0,0,1,8.15-3.81c2.61-.73,4.76-2.75,7-4.25,3.27-2.17,7-3.5,10.53-5.15a74.4,74.4,0,0,0,10.4-6.36c7.48-5.1,14.35-11,21.45-16.59,5.9-4.64,13.62-9.26,15.27-17.27,1-5-1.07-10.4-2.05-15.25-.52-2.59-.6-4.75,2.19-5.57a32.43,32.43,0,0,1,6-.68A21.9,21.9,0,0,0,374,196.5c1.6-1.53,3.06-3.36,4.52-4.82a10.85,10.85,0,0,0,3-6.59,10.39,10.39,0,0,0-2.5-7.37c-1.88-2.41-3.47-5.05-5.32-7.48a12.86,12.86,0,0,0-7.41-5.19,18.58,18.58,0,0,0-9.5.38,46,46,0,0,0-9.82,4.13c-4,2.21-7.43,6.06-7.62,10.62-.06,1.57.25,3.12.33,4.68a6.79,6.79,0,0,1-1.07,4.47,4.34,4.34,0,0,1-3.46,1.65,10.41,10.41,0,0,1-3.17-.84,27.28,27.28,0,0,0-7.22-1.54,9.66,9.66,0,0,0-6.44,1.21c-4.63,2.55-9.26,5.07-13.93,7.57-9.29,5-18.62,10-27.94,14.93-18.61,10-37.14,20.08-55.09,31.21l-3,1.85c-16.6,10.43-32.74,21.8-50.49,30.17-5.14,2.42-10.24,4.86-15.53,6.95-4.75,1.87-10.25,1.07-15-.38-2.07-.64-4.46-1-6.29.14a5.25,5.25,0,0,0-2.18,3.42,9.19,9.19,0,0,0,.26,4.13Q129.32,290.29,129.49,290.79Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Legs--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.85,244.64a244.35,244.35,0,0,1-29.77,13.75C224,263,215,266.21,209.54,268.08s-8.37,6.28-14.53,9.75a85.61,85.61,0,0,1-22.89,9.1c-10.05,2.28-16.76,3.84-22.11,6.06-4.33,1.8-9,7.81-14,3.12-3.38-3.2-2.41-7.34-4.76-12-1.36-2.69-3-5.24-4.17-8a9.29,9.29,0,0,1-.61-3.5,6.9,6.9,0,0,1,.16-1.82c.14-.45.44-.85.6-1.29a6.64,6.64,0,0,0,.16-1.42,3,3,0,0,1,1.92-2.37.58.58,0,0,0,.53-.53A1.66,1.66,0,0,1,131.5,264a2.39,2.39,0,0,1,1.9-1.67,3.87,3.87,0,0,1,.87-2,2.79,2.79,0,0,1,1.95-1c.69,0,1,.6,1.38,1.12a7.32,7.32,0,0,1,.79,2.07,40,40,0,0,0,1.26,4.93c.57,1.41.82,3.08,1.49,4.45,1.19,2.45,2.47,6.16,5.77,6.73,2.72.47,12.68-5.71,23.26-13.16,10-7.06,19.23-13.31,25.54-17.64s44.58-25.31,44.58-25.31Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.31,269a5.75,5.75,0,0,1,3.29-2.14c.61-.18,1.22-.33,1.84-.46.42-.08.85-.16,1.28-.21a2.12,2.12,0,0,1,1.11.17c.11,0,.1.3,0,.31a20.23,20.23,0,0,0-3.84.83,11.69,11.69,0,0,0-3.54,1.7C128.3,269.31,128.26,269.1,128.31,269Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.48,272.59a6.9,6.9,0,0,1,.16-1.82c.14-.45.44-.85.6-1.29a4.89,4.89,0,0,0,.15-1.21.74.74,0,0,1,.27.1c.57.34.65,1.11.72,1.77.36,3.06,2,4.35,4.41,5.84,1.93,1.2,4.29,2.35,4.77,4.79.33,1.64-.55,3.46-.75,5.1-.3,2.35-1.24,4.73-.53,7.11,1,3.24,3.94,3.95,6.87,4-2.31,1.11-4.69,1.4-7.13-.91-3.38-3.2-2.41-7.34-4.76-12-1.36-2.69-3-5.24-4.17-8A9.29,9.29,0,0,1,126.48,272.59Z",
    style: {
      fill: "#f0997a",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.17,287.15c16.09-4.51,23.49-12.66,27.28-16.34s10.3-5.17,13.92-7.88,43-26.45,43.38-27l10.1,8.73-16.22,8.09c-4.08,1.86-8.63,3.78-13.55,5.66C224,263,215,266.21,209.54,268.08s-8.37,6.28-14.53,9.75a85.61,85.61,0,0,1-22.89,9.1l-1,.22Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.17,254.27a246.27,246.27,0,0,1-28.84,15.61c-11.81,5.39-20.54,9.14-25.87,11.35s-8,6.8-13.89,10.65-14.09,7.29-22.94,9.9c-9.89,2.91-16.57,6.32-20.21,9.27s-9.33,7.18-14.56,2.82c-3.57-3-2.86-7.18-5.5-11.66-3.54-6-7.17-9.54-6.05-17,.06-.35-.43-.94-.56-1.29a11.51,11.51,0,0,1-.48-1.51,5.17,5.17,0,0,1-.08-2.53,2.09,2.09,0,0,1,3.77-.68,1.73,1.73,0,0,0,.5.57,1.76,1.76,0,0,0,.69.12,2.66,2.66,0,0,1,2.12,1.44.81.81,0,0,0,.31.41.79.79,0,0,0,.48,0,2.19,2.19,0,0,1,1.89.67,2.91,2.91,0,0,0,.65.66,2.41,2.41,0,0,0,1,.14c3.19.11,3.9,3.77,5.18,6s3.1,5.82,5.69,6.95c2.29,1,12.49-8,22.56-15s18.35-14.5,24.38-19.22,42.88-28.08,42.88-28.08Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.44,284.26a8.57,8.57,0,0,1,4.79.5,15.26,15.26,0,0,1,2.32,1c.92.48,1.74,1.06,2.61,1.62.05,0,.05.19,0,.16-.78-.34-1.58-.63-2.36-1s-1.65-.7-2.5-1a13.67,13.67,0,0,0-2.35-.58c-.84-.12-1.68,0-2.51-.1C153.12,284.86,153.19,284.34,153.44,284.26Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.31,290.48c2.27,2,4.61,2.3,7.49,3a6.12,6.12,0,0,1,4.13,2.64c.93,1.71.4,3.86-.48,5.59s-2.13,3.32-2.66,5.19a4.7,4.7,0,0,0-.16,2.17,4.94,4.94,0,0,0,.87,1.89,9.37,9.37,0,0,0,8.38,3.8c-2.84,1.3-6,1.64-9-.87-3.57-3-2.86-7.18-5.5-11.66-3.1-5.26-6.26-8.62-6.25-14.41C153.33,288.31,154.67,289.9,155.31,290.48Z",
    style: {
      fill: "#f0997a",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.36,302.21c-1.7-3-3.82-5.77-5.1-9a14.54,14.54,0,0,1-1-5,15.6,15.6,0,0,1,.16-2.55,4.21,4.21,0,0,0,.06-.69,2.34,2.34,0,0,0-.27-.66,4.85,4.85,0,0,1-.29-.54l-.19-.61a7.48,7.48,0,0,1-.46-2.45,2.26,2.26,0,0,1,1-2,1.81,1.81,0,0,1,2.13.22,2.75,2.75,0,0,1,.4.43,1.76,1.76,0,0,0,.5.54,1.43,1.43,0,0,0,.73.17,2.83,2.83,0,0,1,.58.11,2.39,2.39,0,0,1,1,.61,1.93,1.93,0,0,1,.35.46c.11.14.13.38.42.62a1.18,1.18,0,0,0,.82.08,1.7,1.7,0,0,1,.55,0,1.86,1.86,0,0,1,1,.53c.13.13.25.31.42.5a1.33,1.33,0,0,0,.71.38c.53.07.88,0,1.28.12a3.48,3.48,0,0,1,2,1.26c1,1.29,1.51,3,2.35,4.53a38.56,38.56,0,0,0,2.72,4.44,10.22,10.22,0,0,0,1.85,1.93,5.94,5.94,0,0,0,1.16.72,1.48,1.48,0,0,0,.79.17,3.39,3.39,0,0,0,.72-.13,20.33,20.33,0,0,0,4.6-2.55c5.69-3.94,11-8.3,16.68-12.21S207,273.43,212.31,269c2.66-2.2,5.28-4.43,8-6.56s5.59-4,8.44-5.92c5.71-3.85,11.47-7.62,17.24-11.39l17.3-11.3c-11.7,7.27-23.38,14.59-34.89,22.16-2.88,1.91-5.77,3.77-8.52,5.89s-5.35,4.36-8,6.55c-5.31,4.38-10.7,8.66-16.36,12.57s-11,8.34-16.63,12.27a19.93,19.93,0,0,1-4.39,2.46,1.24,1.24,0,0,1-1,0,5.45,5.45,0,0,1-1-.64,9.48,9.48,0,0,1-1.73-1.79A39.63,39.63,0,0,1,168,289c-.81-1.45-1.31-3.17-2.46-4.59a4,4,0,0,0-2.32-1.44c-.45-.09-1-.07-1.29-.11s-.48-.33-.83-.7a2.42,2.42,0,0,0-1.26-.69,2.56,2.56,0,0,0-.73,0c-.26,0-.43.06-.45,0s-.14-.24-.27-.46a2.92,2.92,0,0,0-1.64-1.28c-.44-.17-1-.08-1.21-.21s-.46-.64-.84-.92a2.26,2.26,0,0,0-2.67-.24,2.69,2.69,0,0,0-1.2,2.4,7.34,7.34,0,0,0,.52,2.59l.2.62a5.39,5.39,0,0,0,.33.59,2.08,2.08,0,0,1,.23.52,3.61,3.61,0,0,1,0,.6,17.35,17.35,0,0,0-.11,2.6,14.64,14.64,0,0,0,1.11,5.06C154.44,296.53,156.61,299.25,158.36,302.21Z",
    style: {
      fill: "#f0997a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.23,187.06c-6.69-3.55-14.51-7.54-25.35-3.65-7.31,2.63-14.28,6.6-21.16,10.16-9.07,4.69-18.07,9.51-27.05,14.37a116,116,0,0,0-13.88,8.63c-3.2,2.38-6.67,4.71-9,8a4.71,4.71,0,0,0-.89,1.79c-.06.33-.06.67-.11,1-.16,1.12-.94,3,.05,3.92s3.18.37,4.34-.15c4-1.8,7.36-4.85,11.12-7.17a1.29,1.29,0,0,1,.65-.24c.23,0,.48.17.46.4a.63.63,0,0,1-.26.42c-1.7,1.54-5,4-4.55,6.64a1.17,1.17,0,0,0,.26.59c.44.45,1.19.14,1.72-.19,1.19-.74,2.37-1.5,3.53-2.29a20,20,0,0,0,3-2.35c1.82-1.83,2.94-4.24,4.63-6.19a16.24,16.24,0,0,1,2.55-2.35c6.48-4.87,25.18-12,30.77-14.44l24-10.35,14.3-6.16C327.45,187.39,328.13,187,328.23,187.06Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354.43,180.25l.16-.1a34.8,34.8,0,0,1,9.44-4.77,22.88,22.88,0,0,1,10.21-.46c3,.56,9.23,1.89,9.25,5.89,0,.83-.28,1.66-.2,2.49.17,1.75,1.87,2.87,3.07,4.16a6.83,6.83,0,0,1,1.9,3.8,4.58,4.58,0,0,1-1.37,3.92c-1,.87-2.36,1.21-3.26,2.16-1.25,1.3-1.24,3.3-1.4,5.1s-.86,3.88-2.61,4.34c-1.59.41-3.24-.79-4.85-.48s-2.63,2.12-3.94,3.27a6,6,0,0,1-5.91,1.09c-1.74-.65-2.82-1.34-4.78-1.3-2.7.06-5.48.65-7-2.13-.68-1.19-1.09-2.58-2.09-3.52a16.89,16.89,0,0,0-2.77-1.68c-3-1.89-4.11-5.92-3.42-9.4C345.91,187.13,349.94,183.17,354.43,180.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.09,193.9c-1.6.46-3.28.75-4.87,1.08-3.81.78-8.31,1.2-12,2.57,0-.35-1.89-21-2-26.11-.06-2.13.08-4.2-.69-6.2a6,6,0,0,1,1-5.42c2.27-3.16,6-5.66,9.9-5.46a20.69,20.69,0,0,1,8.67,2.47c2.7,1.57,8.14,5.23,10,7.77a17.59,17.59,0,0,1,2.71,9.66,13.16,13.16,0,0,1-3.57,8.7,1.93,1.93,0,0,0-.45.62,10,10,0,0,1-2.67,6.79A12.11,12.11,0,0,1,369.09,193.9Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,197.82c-3.87-1.13-3.29-4.21-3.29-4.21l-13.5,8.29c-6-.05-19.41-4.29-24.91-6.72,2.63-1.8,11.85-4.46,14.38-4.76l3-2.51a9.88,9.88,0,0,1-1.93-2.8,11.44,11.44,0,0,1-.55-4.62,16,16,0,0,1,2.19-6.75,20.56,20.56,0,0,1,9.25-8.18c1.48-.61.95-2.05,2.33-3.14a20,20,0,0,1,7.27-4c3.07-.48,4.13.85,6.4,4,1.7,2.33,8.18,4.19,7.86,9.56-3.9,2.66-3.77,7.85-3.17,10.09a13.05,13.05,0,0,0-3,2.31c-1,1.12-1.19,2.4.11,3,.82.36,2.38-.41,3.88-.47,2-.07,4.1,3.2,2.31,6.78A7.9,7.9,0,0,1,362,197.82Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.65,207.35c-1.25-4-2.09-6.9.48-8.48l-14.39-9.34c-1.68,1.38-3.27.19-5.54-1.25s-3.45-2.45-8.32-2.79c-7-.49-18.29-1.06-24.46,2.77-7.35,4.57-7.44,10.59-13.1,14.14s-15.68,3.06-27.29,8c-16.8,7.13-37.13,23.46-37.13,23.46l37.61,3.58-2.09,35.13s11.71-4.51,26-11.32,16.92-11,20.23-15.25c4.7-6,5.42-10.13,13.63-11.25,5.24-.7,13.1-1.15,20.72-4.35s14.28-8.1,15.27-11.09S350.91,211.37,349.65,207.35Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.72,187.91a16.34,16.34,0,0,0,9,5.08c4.49,1.12,10.11-.32,10.11-.32a12.6,12.6,0,0,1-6,2,16.75,16.75,0,0,1-9.5-1.56A43.29,43.29,0,0,1,336,189.3Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.79 172.17 347.29 178.11 356.85 170.41 344.79 172.17",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.87,182.32c.05-.09,0-.16-.18-.15a5.18,5.18,0,0,1-1.8-.09,4,4,0,0,1-1.68-1.15c-.21-.23-.36-.48-.55-.72a.34.34,0,0,0-.58.12c-.1.48.44,1,.76,1.34a3.64,3.64,0,0,0,2.8,1.09,2.25,2.25,0,0,0,.89-.15A.83.83,0,0,0,349.87,182.32Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.48,174.71l-2.1-3.39a1.92,1.92,0,0,1,2.72.57A2.1,2.1,0,0,1,362.48,174.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.28,164.2l3.79,1.38a1.93,1.93,0,0,0-1.13-2.57A2.11,2.11,0,0,0,351.28,164.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348,167.23c-.62.68.87.44,1.73,1.11s1.08,2.19,1.56,1.39a2,2,0,0,0-.77-2.54A1.78,1.78,0,0,0,348,167.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.51,177.46c-.51.77-.63-.73-1.5-1.41s-2.39-.5-1.73-1.15a2,2,0,0,1,2.65.11A1.78,1.78,0,0,1,359.51,177.46Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M308.9,185.42c11.13,2.89,20.28,13.12,23.94,23.94s2.79,17.17.86,21.92c-1.17,2-3.6,2.62-9.09,3.38s-11.44.61-14.18,2.28-4.12,4.27-7.32,8.39-4.12,8.39-14.64,13.72-33.1,14.72-34.15,14.87-.94-.45-.94-.45a27.2,27.2,0,0,0-9.12-28.6c-14.63-12.19-26.68-9.72-26.68-9.72l-1.33.76s-.68-.64,5.92-5.06,19.44-13.92,32.1-19.84,24.45-5.74,29.63-9.11,5.67-7,9.5-11.08S302.35,185,308.9,185.42Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.26,203.86c-9,3.18-11.55,6.5-18.85,12.47s-14.33,10-28,14.74S253.5,246,250.72,248.45c8.86-4.38,19.32-12.27,31.66-15.85a74.24,74.24,0,0,0,28.81-15.52C317,211.94,323.82,205.58,329.26,203.86Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.67,277.48c.77-.53,1.45-1.17,2.19-1.74s1.48-.95,2.18-1.47A10.64,10.64,0,0,1,285.3,273c.74-.29,1.52-.47,2.28-.71a15.58,15.58,0,0,0,2.85-1.22,9.42,9.42,0,0,0,2-1.61c.86-.81,1.42-1.91,2.29-2.68,2.21-2,13.86-6.49,15.27-7.33a126.81,126.81,0,0,0,15.89-11c4.12-3.31,4.12-3.5,13.89-10.58,9.2-6.69,9.84-8.27,11.5-12,2.21-5,.53-11.38-1.62-18.43-11.26,2.1-15.24,8.77-15.24,8.77S321,230.2,318.56,232.89s-6.86,4.53-15.59,12c-2.24,1.91-9.19,8.15-10.65,9-4.12,2.52-8.59,4.47-12.93,6.59a20.39,20.39,0,0,0-2.48,1.34,21.62,21.62,0,0,0-3.23,2.82l-7.13,7.09a5,5,0,0,0-1.31,2.15,1.1,1.1,0,0,0,.53,1.29,5,5,0,0,0-.69,1.27c-.11.74.51,1.24,1.21,1.49a5,5,0,0,0,2.38-.1.8.8,0,0,0,.36.89,4.29,4.29,0,0,0,3.59-.06l1.65-.71a9.21,9.21,0,0,0,1.11.4,4.2,4.2,0,0,0,3-.7Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.27,278c-1.21-1.33,2.5-4,3.35-5,1.53-1.41,3.07-3,5.06-3.77-2.6,1.81-4.58,4.3-7,6.29-.62.65-1.93,1.42-1.38,2.45Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.67,277.86c.22-1.36,1.4-2.31,2.24-3.32,2.74-2.85,5.53-6.08,9.28-7.6-3.43,2.08-6.07,5.18-9,7.9-.9,1-2.09,1.74-2.54,3Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.77,275.2c3-3.88,6.5-7.65,11-9.87-4,2.87-7.37,6.5-11,9.87Z",
    style: {
      fill: "#f0997a"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.65,145.64c-1.52,4.17-1.81,5.84-2.51,11.54a73.3,73.3,0,0,0-.88,9.5c.13,1.13,1.83.69,2.34-.61a28.43,28.43,0,0,0,1.28-5.4c.47-2.61.63-3,.77-2.61s-.73,8.77-.3,12.78c.21,1.93,1,2.25,2.13,1.92.08.73.31,1.39,1,1.44a2.42,2.42,0,0,0,2.48-2.08c1.5-.13,2.84-1.36,3.16-3.94s1.33-8.62,1.77-11.47,1.19-4.68,2-4.73,1.36,1.24,1.74,2.27,1.08,3.31,2.09,4.11,2.28,1.06,3,.47,0-1.77-.58-3.58-.78-4.06-1.67-6.15a25.62,25.62,0,0,0-3.43-5.49c-1.22-1.57-.82-4.21-.59-8.21",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.48,172.76a58.84,58.84,0,0,1,.72-14.93,124.18,124.18,0,0,0-.72,14.93Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,172.12c-1.28,0-.85-2.61-.88-3.47A81.16,81.16,0,0,1,342.41,157c-.52,3.87-.85,7.76-1.17,11.66a10.83,10.83,0,0,0,.05,2.9.65.65,0,0,0,.67.56Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.33,79.63c-4,.46-8.06,1.74-11.26,5.31s-16.26,28.82-16.26,28.82S347.25,129.05,344.13,132s-7.53,9.52-9.42,16.46a38.4,38.4,0,0,1,6.6-1.14c2.73-.12,12.16,1.81,12.16,1.81-1-2.85-2-3.71-.92-6.45.79-2.09,9.07-6.85,13.55-9.49s9.54-6.06,11.49-8.2,13.74-23.77,13.74-23.77Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.28,126.26c2.74-.07,9,4.68,9.48,11.11,8.14-4.7,14.48-9,16.74-10.29s2.53-1.9,6.49-8.39l9.06-14.86-.76-24.2c-7,1.05-9.73,2.11-13.52,7.75s-14.18,26.31-14.18,26.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.29,79.27c-4.1.61-7.64,1.34-9.86,3.46s-3.95,4.18-6.76,9.25-8.88,16.89-8.88,16.89,1.16,2.78,7.45,6.76,10.24,3.21,10.24,3.21l9-14.9Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.29,79.27c-4.1.61-7.64,1.34-9.86,3.46s-3.95,4.18-6.76,9.25-8.88,16.89-8.88,16.89,1.16,2.78,7.45,6.76,10.24,3.21,10.24,3.21l9-14.9Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.72,57.61c.19.3.36.62.53.94a8.83,8.83,0,0,0,3,3.87,11.1,11.1,0,0,0,3.28,1,12.65,12.65,0,0,1,4.68,1.83,6.65,6.65,0,0,1,2.85,4c.16.81.14,1.65.28,2.46a3,3,0,0,0,1.17,2.09,1.53,1.53,0,0,0,2.14-.43,2,2,0,0,1-1,1.84,5.74,5.74,0,0,1-2.07.72c1.37-.29,3.14,5,3.24,5.91a6.9,6.9,0,0,1-2.09,6c-1.45,1.33-3.26,2.22-4.68,3.59-2.1,2-3.17,4.94-5.33,6.89a8.89,8.89,0,0,1-6.35,2.2c-2.63-.13-4.46-2-7.13-.94-1.78.72-3.28,2-5,2.82a11.88,11.88,0,0,1-12.76-1.75c-1.93-1.72-3.31-4.1-5.59-5.3-1.6-.84-3.46-1-5.08-1.81a7.56,7.56,0,0,1-3.47-9.45c.54-1.26,1.45-2.37,1.72-3.72s-.18-2.87-.37-4.32a8.41,8.41,0,0,1,.85-5.18c1.3-2.3,3.8-3.59,6-5,4.71-3,5.36-8.68,10.3-11.61,4.16-2.47,9.91-3.68,14.54-1.85A12.62,12.62,0,0,1,431.72,57.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440.68,137.37c-2.21-8.64,1.82-26.59,2-31.82.36-11.4-1.32-19.34-4.19-21.24,0,0-5.53-2.8-9.89-4.61s-9.51-4.12-12.18-4.44c-6.66-.81-13.71,2.77-17,2.93-1.23.06-8.1,1.08-8.1,1.08s-2.64,4.12-6.37,11.57c-2.62,5.24-4.48,10.76-3.85,20.87.69,10.92,1.49,17.73,1.3,22.16C389.86,142.07,423.93,148.12,440.68,137.37Z",
    style: {
      fill: "#FF725E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M417.87,67.69c0-1.81,3.37-7.75,5-12s1.88-14.18-2.93-18.39c-.62-.54-.73-2.15-1-2.91a18.13,18.13,0,0,0-1.62-3.66,12.5,12.5,0,0,0-15.54-5c-1.2.51-2.31,1.2-3.54,1.65-2.23.8-4.67.72-7,.81A18.78,18.78,0,0,0,383,30a8.68,8.68,0,0,0-4.78,6.58,18.37,18.37,0,0,0,.42,4.29,4.11,4.11,0,0,1,0,1.71,5.69,5.69,0,0,1-.85,1.59,9.5,9.5,0,0,0-1.59,6.89,6,6,0,0,0,4.8,4.8,3.49,3.49,0,0,1-.89-3.17,6.94,6.94,0,0,0,5,3.55,20.19,20.19,0,0,0,5.49,0c1.64-.11,3.29,1,4.8,1.64l11.14,4.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.9,41.33c-2.39,4.43.17,10.86-.09,15.52,0,11.2,5.15,20.17,16,17.35.6,3,.23,3.54-2.42,4-2.25,5.1-2.34,12.9.14,16.63,7.36-2.62,24-12.37,26.45-16.21-5-2.47-7-3.52-7.4-7L417.3,61c3.87,2.4,8.19-3.14,7.82-7.77-.24-5.73-6.22-7-8.79-.9-.78,1.88-2.67,1.68-2.86.34-.36-1.12.16-2-.37-3-2-1-4.06-2.35-4.7-4.7-.55-1.73-.46-3.77-1.66-5.13C400.73,35.73,389.78,37.73,385.9,41.33Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.81,74.2c10-2.27,12.41-6.47,13.36-9.76a9.24,9.24,0,0,1-2.6,6.22,21.35,21.35,0,0,1-10.34,6Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.41,61.77l-5,2.47a2.72,2.72,0,0,0,3.68,1.34A2.9,2.9,0,0,0,403.41,61.77Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.26,63a3.07,3.07,0,0,0-2.64,2.82,2.71,2.71,0,0,0,1.52-.26A2.82,2.82,0,0,0,403.67,63Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.68,50l3.57-2.3a2,2,0,0,0-2.88-.69A2.22,2.22,0,0,0,386.68,50Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.42,47.54l-4-1.47a2.05,2.05,0,0,1,2.68-1.33A2.25,2.25,0,0,1,405.42,47.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.51 49.68 397.66 60.81 391.63 59.36 396.51 49.68",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.66,52.72a1.79,1.79,0,0,1-1.29,2.12,1.67,1.67,0,0,1-2.07-1.23,1.77,1.77,0,0,1,1.28-2.11A1.67,1.67,0,0,1,391.66,52.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.42,51a1.78,1.78,0,0,1-1.28,2.11,1.67,1.67,0,0,1-2.08-1.22,1.79,1.79,0,0,1,1.29-2.12A1.66,1.66,0,0,1,404.42,51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.92,85.3c4.43,2.17,6.9,4.67,8.4,8.13,1.73,4,2.4,7.22.29,18.25-1.95,10.23-6.39,29.42-7.38,33.27-1.75,6.82-2.12,8.66-8.89,12.05-5.66,2.83-25.31,12.25-28.21,14.05l-5.9-12.25L420,141.36l6.28-34.49S427.76,90.77,437.92,85.3Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.13,171.05a100.66,100.66,0,0,0-11.9,7c-3.78,2.69-5.14,3.09-10.51,5.75a80,80,0,0,1-9.06,4.15c-1.17.26-1.31-1.57-.21-2.52a30.35,30.35,0,0,1,4.88-3.13c2.41-1.36,2.75-1.66,2.31-1.66s-8.39,3.75-12.5,4.71c-2,.46-2.55-.16-2.63-1.44-.75.18-1.48.18-1.76-.48a2.53,2.53,0,0,1,1.19-3.17c-.39-1.52.36-3.27,2.8-4.47s8-4.3,10.69-5.71,4.2-2.79,4-3.62-1.69-.91-2.84-.93-3.63.08-4.77-.64-1.83-1.88-1.5-2.79,1.74-.6,3.73-.66,4.27-.63,6.65-.47,4.53.55,6.59.85c2.49.36,5.52-1.18,9-3",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.51,183.91A61.18,61.18,0,0,0,377,178.05a127.67,127.67,0,0,1-14.47,5.86Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.94,180.26c.43,1.27,2.87-.06,3.73-.33a83.64,83.64,0,0,0,11-5.34c-3.64,1.86-7.36,3.52-11.09,5.18a11.48,11.48,0,0,1-2.88,1,.69.69,0,0,1-.79-.47Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.6,84.74c-4.17,2.61-8.55,6.71-10.78,17s-7.35,39.35-7.35,39.35L399,156.81s3,1.13,5.18,5.69.52,7.88.52,7.88S427.7,159.44,432.13,157s5.34-3.88,7.3-10.13,6.77-30.22,8.2-37.25S451,91.13,437.6,84.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.32,83.73c4,1.7,8.27,4.64,10.36,8.63s2.09,10,0,20.72S443,133.79,443,133.79s-4.08,2.22-10.82,1A27.17,27.17,0,0,1,421.05,130s2.59-18.57,3.54-24.36S427.05,88.59,437.32,83.73Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.32,83.73c4,1.7,8.27,4.64,10.36,8.63s2.09,10,0,20.72S443,133.79,443,133.79s-4.08,2.22-10.82,1A27.17,27.17,0,0,1,421.05,130s2.59-18.57,3.54-24.36S427.05,88.59,437.32,83.73Z",
    style: {
      opacity: 0.30000000000000004
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.31,96a21.94,21.94,0,0,0,12.43-10.31l1.08-2.27a22,22,0,0,0-39-19.82l-1.19,2.21A22,22,0,0,0,351.31,96Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.9,97.8a23.88,23.88,0,0,0,16.17-26.18l5.73-4.69a1.39,1.39,0,0,0-.8-2.46l-7.4-.4A23.84,23.84,0,1,0,351.9,97.8ZM323.6,82a21.89,21.89,0,0,1,1-16.11l1.19-2.21a22,22,0,0,1,39,19.82l-1.08,2.27A22,22,0,0,1,323.6,82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.6,82a21.89,21.89,0,0,1,1-16.11l1.19-2.21a22,22,0,0,1,39,19.82l-1.08,2.27A22,22,0,0,1,323.6,82Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Flower--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.11,75.49s-2.91-2.36-1-3.85,5.85-.49,7.69.87a10.5,10.5,0,0,1-3.5-4.34c-.68-1.69-.45-2.49.18-2.94s2.81-.17,4.08.89c.19-2.17,1-4.28,2.73-4,2,.39,4.5,3.58,3.3,7.51,1.23-2.73,2.26-4,4.06-4.83,2.35-1,3.91.54,2.75,3.86,3.1-.6,5.34,2.22,4.58,4.07s-4.71,3.29-6.63,3.18c0,0,3.5.54,5,3.06s-2.76,4.19-4.77,2.78c1.48,2.59-.07,5-1.83,4.77s-4.27-3.08-4.82-5.65c.06,3-.11,5.77-2.51,7.46s-2.57-3.54-2.57-3.54-2.25,1.65-3.84,1.38-.47-4.72,2.34-6.91c-2.4,1.39-4.74,1.81-6.7,1.11S331.6,76,333.11,75.49Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.11,75.49s-2.91-2.36-1-3.85,5.85-.49,7.69.87a10.5,10.5,0,0,1-3.5-4.34c-.68-1.69-.45-2.49.18-2.94s2.81-.17,4.08.89c.19-2.17,1-4.28,2.73-4,2,.39,4.5,3.58,3.3,7.51,1.23-2.73,2.26-4,4.06-4.83,2.35-1,3.91.54,2.75,3.86,3.1-.6,5.34,2.22,4.58,4.07s-4.71,3.29-6.63,3.18c0,0,3.5.54,5,3.06s-2.76,4.19-4.77,2.78c1.48,2.59-.07,5-1.83,4.77s-4.27-3.08-4.82-5.65c.06,3-.11,5.77-2.51,7.46s-2.57-3.54-2.57-3.54-2.25,1.65-3.84,1.38-.47-4.72,2.34-6.91c-2.4,1.39-4.74,1.81-6.7,1.11S331.6,76,333.11,75.49Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.05,78a2.44,2.44,0,0,1-1.69-1.15c-1.16-2.12,2.54-4.62,4.37-4.76s4.17,1.73,3.22,3.77C347.24,77.34,344.14,78.44,342.05,78Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--table--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--table--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--table--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353,405.39a4.17,4.17,0,0,0-3.8,0,1.33,1.33,0,0,0-.78,1.1l.78,43.57h0a.93.93,0,0,0,.55.76,3,3,0,0,0,2.69,0,1,1,0,0,0,.55-.76h0l.79-43.57A1.33,1.33,0,0,0,353,405.39Zm-42.56-4.8a4.23,4.23,0,0,0-3.8,0,1.13,1.13,0,0,0-.63,1.1l-1.73,32.87h0a1.18,1.18,0,0,0,.66.76,3,3,0,0,0,2.69,0,.82.82,0,0,0,.45-.76h0l3.3-32.87A1.65,1.65,0,0,0,310.46,400.59Zm84.94,1.1a1.13,1.13,0,0,0-.63-1.1,4.23,4.23,0,0,0-3.8,0,1.6,1.6,0,0,0-.94,1.1l3.3,32.87h0a.8.8,0,0,0,.45.76,3,3,0,0,0,2.68,0,1.12,1.12,0,0,0,.66-.76h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.31,380.49h-.05c0-8.9-5.82-17.79-17.58-24.57-23.5-13.57-61.61-13.57-85.12,0C296.81,362.7,291,371.59,291,380.49h-.06v4.77h0c.14,8.78,6,17.53,17.63,24.23,23.51,13.57,61.62,13.57,85.12,0,11.6-6.7,17.49-15.45,17.63-24.23h0Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.31,380.49h-.05c0-8.9-5.82-17.79-17.58-24.57-23.5-13.57-61.61-13.57-85.12,0C296.81,362.7,291,371.59,291,380.49h-.06v4.77h0c.14,8.78,6,17.53,17.63,24.23,23.51,13.57,61.62,13.57,85.12,0,11.6-6.7,17.49-15.45,17.63-24.23h0Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.56,355.92c-23.5,13.57-23.5,35.57,0,49.14s61.62,13.57,85.12,0,23.51-35.57,0-49.14S332.07,342.35,308.56,355.92Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.56,355.92c-23.5,13.57-23.5,35.57,0,49.14s61.62,13.57,85.12,0,23.51-35.57,0-49.14S332.07,342.35,308.56,355.92Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Incense--inject-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-3",
    points: "349.79 404.88 307.85 380.66 320.09 373.57 362.09 397.77 349.79 404.88",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.61 402.86 310.39 380.21 310.39 378.95 320.19 373.29 359.48 395.92 359.48 397.19 349.61 402.86",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.61 401.59 310.39 378.95 320.19 373.29 359.48 395.92 349.61 401.59",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-3",
    d: "M348.56,395.33a.63.63,0,0,0,0,1.19,2.29,2.29,0,0,0,2.07,0,.63.63,0,0,0,0-1.19A2.29,2.29,0,0,0,348.56,395.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.6,396.38a.44.44,0,0,1-.33-.15l-31.06-33a.45.45,0,0,1,0-.64.46.46,0,0,1,.64,0l31.06,33a.46.46,0,0,1,0,.64A.43.43,0,0,1,349.6,396.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.8,361.05c-1.83-1.81-4-7.46-.81-11.9,2.69-3.72,4.81-4.58,5.65-7.76.5-1.91.19-3.94-.64-4.89a4.79,4.79,0,0,0-4.47-1.64c3.62-2,9.09.84,8.86,6.12-.2,4.67-2.41,6.2-5.55,9.3C317.91,353.15,316,357.28,317.8,361.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.73,361.67c-.4-1.39-1.19-4.68.48-7s6.12-5.25,7.19-8.12c-.2,2.56-1.1,4.2-4.1,7.17S318.37,358.73,318.73,361.67Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--moisturizing-mask--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-3",
    d: "M349.57,358.92c-5.58,3.22-5.58,8.45,0,11.68s14.64,3.22,20.23,0,5.58-8.46,0-11.68S355.16,355.69,349.57,358.92Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-3",
    d: "M374.38,375.22c-5.59,3.23-5.59,8.45,0,11.68s14.64,3.22,20.22,0,5.59-8.45,0-11.68S380,372,374.38,375.22Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--jar--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.76,356.73a10,10,0,0,1-1.68,1.17c-3.85,2.23-9.46,2.82-14.25,1.78a16.73,16.73,0,0,1-1.94-.54,13.75,13.75,0,0,1-1.59-.61,11.83,11.83,0,0,1-1.23-.63,10,10,0,0,1-2.14-1.6,5.51,5.51,0,0,1-1.8-3.88V363a5.38,5.38,0,0,0,1.54,3.61h0l.15.17.34.32c.09.09.18.16.27.24a3.61,3.61,0,0,0,.3.25l.15.11.08.06.07.06,0,0,.08.05c.28.2.58.39.9.58l.6.33.63.29a13.8,13.8,0,0,0,1.59.62,17.28,17.28,0,0,0,1.94.53,22.92,22.92,0,0,0,9.15.07h0c.45-.09.9-.2,1.33-.31a13.55,13.55,0,0,0,1.32-.42l.62-.23,0,0,.59-.25.59-.29c.2-.1.39-.2.57-.31C371.71,367,373,365,373,363V352.42A5.76,5.76,0,0,1,370.76,356.73Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.76,356.73a10,10,0,0,1-1.68,1.17c-3.85,2.23-9.46,2.82-14.25,1.78a16.73,16.73,0,0,1-1.94-.54,13.75,13.75,0,0,1-1.59-.61,11.83,11.83,0,0,1-1.23-.63,10,10,0,0,1-2.14-1.6,5.51,5.51,0,0,1-1.8-3.88V363a5.38,5.38,0,0,0,1.54,3.61h0l.15.17.34.32c.09.09.18.16.27.24a3.61,3.61,0,0,0,.3.25l.15.11.08.06.07.06,0,0,.08.05c.28.2.58.39.9.58l.6.33.63.29a13.8,13.8,0,0,0,1.59.62,17.28,17.28,0,0,0,1.94.53,22.92,22.92,0,0,0,9.15.07h0c.45-.09.9-.2,1.33-.31a13.55,13.55,0,0,0,1.32-.42l.62-.23,0,0,.59-.25.59-.29c.2-.1.39-.2.57-.31C371.71,367,373,365,373,363V352.42A5.76,5.76,0,0,1,370.76,356.73Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.07,357.9a11.83,11.83,0,0,0,1.23.63v10.55l-.63-.29-.6-.33c-.32-.19-.62-.38-.9-.58l-.08-.05-.2-.15a10,10,0,0,1-1-.84V356.3A10,10,0,0,0,350.07,357.9Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.83,359.68v10.55c-.67-.15-1.31-.33-1.94-.53V359.14A16.73,16.73,0,0,0,354.83,359.68Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,352.42V363c0,2-1.31,4-3.94,5.49-.18.11-.37.21-.57.31l-.59.29-.59.25,0,0-.62.23a13.55,13.55,0,0,1-1.32.42c-.43.11-.88.22-1.33.31h0a22.92,22.92,0,0,1-9.15-.07,17.28,17.28,0,0,1-1.94-.53,13.8,13.8,0,0,1-1.59-.62l-.63-.29-.6-.33c-.32-.19-.62-.38-.9-.58l-.08-.05,0,0-.07-.06-.23-.17a3.61,3.61,0,0,1-.3-.25c-.09-.08-.18-.15-.27-.24l-.34-.32-.15-.17.25.22a10.86,10.86,0,0,0,3.37,1.75c.51.16,1,.32,1.59.45s1.28.27,1.94.36a18.85,18.85,0,0,0,6.19-.08c4.63-.91,7.43-3.86,7.43-6v-4a23.07,23.07,0,0,1-13.62,1.32c-.66-.14-1.31-.3-1.94-.5a13.6,13.6,0,0,1-1.59-.57,13.77,13.77,0,0,1-1.81-.88,11.8,11.8,0,0,1-1.56-1.06,8.19,8.19,0,0,1-1.8-2v-3.19a5.51,5.51,0,0,0,1.8,3.88,10,10,0,0,0,2.14,1.6,11.83,11.83,0,0,0,1.23.63,13.75,13.75,0,0,0,1.59.61,16.73,16.73,0,0,0,1.94.54c4.79,1,10.4.45,14.25-1.78a10,10,0,0,0,1.68-1.17A5.76,5.76,0,0,0,373,352.42Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,352.42V363c0,2-1.31,4-3.94,5.49-.18.11-.37.21-.57.31l-.59.29-.59.25,0,0-.62.23c-.42.16-.87.29-1.32.42s-.88.22-1.33.31c5-1.38,6.74-4.82,6.74-6.36v-7.2A5.76,5.76,0,0,0,373,352.42Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.31,367.85c-4.82,2.42-12.64,2.42-17.47,0s-4.82-6.36,0-8.78,12.65-2.42,17.47,0S373.14,365.42,368.31,367.85Z",
    style: {
      fill: "#FF725E",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,361.92c-5.1,1.61-11.62,1.17-15.94-1.33-2.63-1.51-3.94-3.5-3.94-5.49v5c0,2,1.31,4,3.94,5.49,4.31,2.5,10.83,2.93,15.93,1.32Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.09,357.9c-5.26,3-13.77,3-19,0s-5.25-7.94,0-11,13.76-3,19,0S374.34,354.87,369.09,357.9Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.23,352.2a9.12,9.12,0,0,1-1.44,1,18.24,18.24,0,0,1-12.31,1.53,13,13,0,0,1-1.68-.46,12.53,12.53,0,0,1-1.37-.53c-.37-.17-.73-.35-1.06-.54a8.94,8.94,0,0,1-1.85-1.39,4.72,4.72,0,0,1-1.55-3.35v3.14a4.68,4.68,0,0,0,1.33,3.12h0l.14.15.29.28.23.21.26.2.13.1.07.06s0,0,.06,0l0,0,.07.05c.24.17.5.33.78.5l.52.28.54.26a12.53,12.53,0,0,0,1.37.53,17.21,17.21,0,0,0,1.68.46,19.64,19.64,0,0,0,7.9.05h0c.39-.07.77-.16,1.15-.26s.77-.23,1.14-.36l.53-.2,0,0,.52-.22.51-.25c.17-.08.33-.17.49-.26,2.27-1.31,3.4-3,3.4-4.74v-3.14A5,5,0,0,1,369.23,352.2Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.23,352.2a9.12,9.12,0,0,1-1.44,1,18.24,18.24,0,0,1-12.31,1.53,13,13,0,0,1-1.68-.46,12.53,12.53,0,0,1-1.37-.53c-.37-.17-.73-.35-1.06-.54a8.94,8.94,0,0,1-1.85-1.39,4.72,4.72,0,0,1-1.55-3.35v3.14a4.68,4.68,0,0,0,1.33,3.12h0l.14.15.29.28.23.21.26.2.13.1.07.06s0,0,.06,0l0,0,.07.05c.24.17.5.33.78.5l.52.28.54.26a12.53,12.53,0,0,0,1.37.53,17.21,17.21,0,0,0,1.68.46,19.64,19.64,0,0,0,7.9.05h0c.39-.07.77-.16,1.15-.26s.77-.23,1.14-.36l.53-.2,0,0,.52-.22.51-.25c.17-.08.33-.17.49-.26,2.27-1.31,3.4-3,3.4-4.74v-3.14A5,5,0,0,1,369.23,352.2Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.37,353.21c.33.19.69.37,1.06.54v3.14l-.54-.26-.52-.28c-.28-.17-.54-.33-.78-.5l-.07-.05-.17-.13a8.59,8.59,0,0,1-.83-.72v-3.13A8.94,8.94,0,0,0,351.37,353.21Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.48,354.74v3.14c-.58-.13-1.14-.29-1.68-.46v-3.14A13,13,0,0,0,355.48,354.74Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.19,348.47v3.14c0,1.71-1.13,3.43-3.4,4.74-.16.09-.32.18-.49.26l-.51.25-.52.22,0,0-.53.2q-.56.19-1.14.36c-.38.1-.76.19-1.15.26h0a19.64,19.64,0,0,1-7.9-.05,17.21,17.21,0,0,1-1.68-.46,12.53,12.53,0,0,1-1.37-.53l-.54-.26-.52-.28c-.28-.17-.54-.33-.78-.5l-.07-.05,0,0s-.05,0-.06,0l-.2-.16-.26-.2-.23-.21-.29-.28-.14-.15.22.19a9.34,9.34,0,0,0,2.91,1.51c.44.14.9.28,1.37.39s1.11.24,1.68.32a23.54,23.54,0,0,0,6.09.11c4.44-.75,5.67-1.95,5.67-2.8v-.27a19.88,19.88,0,0,1-11.76,1.4c-.57-.12-1.14-.26-1.68-.43a12.35,12.35,0,0,1-1.37-.49,12.53,12.53,0,0,1-1.56-.76,11,11,0,0,1-1.35-.92,7,7,0,0,1-1.55-1.76v-2.75a4.72,4.72,0,0,0,1.55,3.35,8.94,8.94,0,0,0,1.85,1.39c.33.19.69.37,1.06.54a12.53,12.53,0,0,0,1.37.53,13,13,0,0,0,1.68.46,18.24,18.24,0,0,0,12.31-1.53,9.12,9.12,0,0,0,1.44-1A5,5,0,0,0,371.19,348.47Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.19,348.47v3.14c0,1.71-1.13,3.43-3.4,4.74-.16.09-.32.18-.49.26l-.51.25-.52.22,0,0-.53.2q-.56.19-1.14.36c-.38.1-.76.19-1.15.26,4.34-1.18,5.81-3,5.81-4.33V352.2A5,5,0,0,0,371.19,348.47Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.79,353.21c-4.53,2.62-11.89,2.62-16.42,0s-4.54-6.86,0-9.48,11.89-2.62,16.42,0S372.33,350.59,367.79,353.21Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.25,349.74a5.39,5.39,0,0,1-2.35,2.38,13.94,13.94,0,0,1-12.64,0,5.34,5.34,0,0,1-2.35-2.38c-.75-1.71,0-3.59,2.35-4.92a13.94,13.94,0,0,1,12.64,0C368.21,346.15,369,348,368.25,349.74Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.25,349.74a5.39,5.39,0,0,1-2.35,2.38,13.94,13.94,0,0,1-12.64,0,5.34,5.34,0,0,1-2.35-2.38c-.75-1.71,0-3.59,2.35-4.92a13.94,13.94,0,0,1,12.64,0C368.21,346.15,369,348,368.25,349.74Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.25,349.74a5.39,5.39,0,0,1-2.35,2.38,13.94,13.94,0,0,1-12.64,0,5.34,5.34,0,0,1-2.35-2.38,5.4,5.4,0,0,1,2.35-2.39,14,14,0,0,1,12.64,0A5.4,5.4,0,0,1,368.25,349.74Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.25,349.74a5.39,5.39,0,0,1-2.35,2.38,13.94,13.94,0,0,1-12.64,0,5.34,5.34,0,0,1-2.35-2.38s0,0,0-.05c1.56-1.8,3.52-1.95,5.73-2.94a7.13,7.13,0,0,0,1.45-.84,2.57,2.57,0,0,0,1.08-2.32,3.16,3.16,0,0,1,1.87,2.32,4.39,4.39,0,0,1,.1,1.22s4.8.22,7,2.45A.8.8,0,0,1,368.25,349.74Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.15,347.39a17.21,17.21,0,0,0-1.88-.23c-.33,1.91-2.25,1.91-2.47,3s2.39,1.31,2.89.73c0,0-1.72.29-1.89-.61S362.29,349.2,363.15,347.39Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M371,375.15c0-2,1.32-4,3.94-5.49,5.25-3,13.77-3,19,0,2.62,1.52,3.94,3.5,3.94,5.49h0V380h0c0,2-1.32,4-3.94,5.49-5.25,3-13.77,3-19,0C372.36,384,371,382,371,380h0v-4.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M391.55,386.57c.22-.07.43-.16.65-.24v-6.56h-.65Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M396.69,383.22v-6.4h-.64v7.11A8.37,8.37,0,0,0,396.69,383.22Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M388.78,387.32l.65-.13v-6.63h-.65Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M385.83,387.7c.22,0,.43,0,.65-.06V381h-.65Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M394.7,385v-6.48h-.64v6.89Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M397.61,381.64a4.68,4.68,0,0,0,.33-1.67h0v-4.82h0a4.56,4.56,0,0,0-.15-1.1h-.18Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M379.83,387.25l.64.13v-6.77h-.64Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M377,386.42c.21.09.43.16.65.23V379.9H377Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M382.81,387.67l.64,0V381h-.64Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M375.1,385.52v-6.7h-.65v6.3c.18.12.34.23.53.34Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M372.85,383.85V377.1h-.64v6A7.12,7.12,0,0,0,372.85,383.85Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M371.37,374.6h-.28a5.11,5.11,0,0,0,0,.55V380a4.68,4.68,0,0,0,.33,1.67Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M381.27,387.5c6.66,0,10.17-3.63,11.23-5.39.82-1.34,1-1.17,1-3.63,0,0,.75-5.58.6-5.6s1.6-.38,2.89-.65a5,5,0,0,1,1,2.92h0V380h0c0,2-1.32,4-3.94,5.49C390.55,387.46,385.69,388.13,381.27,387.5Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,380.64c-5.25,3-13.77,3-19,0s-5.25-7.95,0-11,13.77-3,19,0S399.25,377.61,394,380.64Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.26,380.18c-4.5-3.05-4.27-7.63.72-10.52a19.22,19.22,0,0,1,9.25-2.26,14.92,14.92,0,0,1,4.91,1.67c4.54,2.59,4.54,7.77,0,10.37C385.09,381.75,378.79,382,374.26,380.18Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.91,378.13s-4.37,4.4-12.82,4.17-11.83-4.84-12.28-6.27a5.31,5.31,0,0,1,1.14-4.87,5.66,5.66,0,0,0-1.91,4V380c0,.51-.25,2.24,2.47,4.49a6.62,6.62,0,0,1-1.6-3.57v-3s3,5,12.18,5S396.45,378.88,396.91,378.13Z",
    style: {
      fill: "#fff"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMassageAmico);
export default __webpack_public_path__ + "static/media/massage-amico.d84491e90a61f90f94e38c0744f436a9.svg";
export { ForwardRef as ReactComponent };